import React from "react"

const AvatarIcon = () => (
  <svg id="Capa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 482.9 482.9">
    <path
      d="M239.7,260.2c0.5,0,1,0,1.6,0c0.2,0,0.4,0,0.6,0c0.3,0,0.7,0,1,0c29.3-0.5,53-10.8,70.5-30.5
			c38.5-43.4,32.1-117.8,31.4-124.9c-2.5-53.3-27.7-78.8-48.5-90.7C280.8,5.2,262.7,0.4,242.5,0h-0.7c-0.1,0-0.3,0-0.4,0h-0.6
			c-11.1,0-32.9,1.8-53.8,13.7c-21,11.9-46.6,37.4-49.1,91.1c-0.7,7.1-7.1,81.5,31.4,124.9C186.7,249.4,210.4,259.7,239.7,260.2z
			 M164.6,107.3c0-0.3,0.1-0.6,0.1-0.8c3.3-71.7,54.2-79.4,76-79.4h0.4c0.2,0,0.5,0,0.8,0c27,0.6,72.9,11.6,76,79.4
			c0,0.3,0,0.6,0.1,0.8c0.1,0.7,7.1,68.7-24.7,104.5c-12.6,14.2-29.4,21.2-51.5,21.4c-0.2,0-0.3,0-0.5,0l0,0c-0.2,0-0.3,0-0.5,0
			c-22-0.2-38.9-7.2-51.4-21.4C157.7,176.2,164.5,107.9,164.6,107.3z"
    />
    <path
      d="M446.8,383.6c0-0.1,0-0.2,0-0.3c0-0.8-0.1-1.6-0.1-2.5c-0.6-19.8-1.9-66.1-45.3-80.9c-0.3-0.1-0.7-0.2-1-0.3
			c-45.1-11.5-82.6-37.5-83-37.8c-6.1-4.3-14.5-2.8-18.8,3.3c-4.3,6.1-2.8,14.5,3.3,18.8c1.7,1.2,41.5,28.9,91.3,41.7
			c23.3,8.3,25.9,33.2,26.6,56c0,0.9,0,1.7,0.1,2.5c0.1,9-0.5,22.9-2.1,30.9c-16.2,9.2-79.7,41-176.3,41
			c-96.2,0-160.1-31.9-176.4-41.1c-1.6-8-2.3-21.9-2.1-30.9c0-0.8,0.1-1.6,0.1-2.5c0.7-22.8,3.3-47.7,26.6-56
			c49.8-12.8,89.6-40.6,91.3-41.7c6.1-4.3,7.6-12.7,3.3-18.8c-4.3-6.1-12.7-7.6-18.8-3.3c-0.4,0.3-37.7,26.3-83,37.8
			c-0.4,0.1-0.7,0.2-1,0.3c-43.4,14.9-44.7,61.2-45.3,80.9c0,0.9,0,1.7-0.1,2.5c0,0.1,0,0.2,0,0.3c-0.1,5.2-0.2,31.9,5.1,45.3
			c1,2.6,2.8,4.8,5.2,6.3c3,2,74.9,47.8,195.2,47.8s192.2-45.9,195.2-47.8c2.3-1.5,4.2-3.7,5.2-6.3
			C447,415.5,446.9,388.8,446.8,383.6z"
    />
  </svg>
)

const InventoryIcon = () => (
  <svg
    id="InventoryIcon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 60 60"
  >
    <path
      className="st0"
      d="M10.5,6.5C8,6.5,6,8.5,6,11s2,4.5,4.5,4.5s4.5-2,4.5-4.5S13,6.5,10.5,6.5z M10.5,13.5C9.1,13.5,8,12.4,8,11 s1.1-2.5,2.5-2.5S13,9.6,13,11S11.9,13.5,10.5,13.5z"
    />
    <path
      className="st0"
      d="M60,16.9V5.1c0-2.5-2.1-4.6-4.6-4.6H4.6C2.1,0.5,0,2.6,0,5.1v11.8c0,1.5,0.7,2.8,1.8,3.6 C0.7,21.3,0,22.6,0,24.1v11.8c0,1.5,0.7,2.8,1.8,3.6C0.7,40.3,0,41.6,0,43.1v11.8c0,2.5,2.1,4.6,4.6,4.6h50.8 c2.5,0,4.6-2.1,4.6-4.6V43.1c0-1.5-0.7-2.8-1.8-3.6c1.1-0.8,1.8-2.1,1.8-3.6V24.1c0-1.5-0.7-2.8-1.8-3.6C59.3,19.7,60,18.4,60,16.9 z M58,43.1v11.8c0,1.4-1.2,2.6-2.6,2.6H4.6c-1.4,0-2.6-1.2-2.6-2.6V43.1c0-1.4,1.2-2.6,2.6-2.6h50.8C56.8,40.5,58,41.7,58,43.1z M58,24.1v11.8c0,1.4-1.2,2.6-2.6,2.6H4.6c-1.4,0-2.6-1.2-2.6-2.6V24.1c0-1.4,1.2-2.6,2.6-2.6h50.8C56.8,21.5,58,22.7,58,24.1z M4.6,19.5c-1.4,0-2.6-1.2-2.6-2.6V5.1c0-1.4,1.2-2.6,2.6-2.6h50.8c1.4,0,2.6,1.2,2.6,2.6v11.8c0,1.4-1.2,2.6-2.6,2.6L4.6,19.5 L4.6,19.5z"
    />
    <path
      className="st0"
      d="M10.5,34.5c2.5,0,4.5-2,4.5-4.5s-2-4.5-4.5-4.5S6,27.5,6,30S8,34.5,10.5,34.5z M10.5,27.5 c1.4,0,2.5,1.1,2.5,2.5s-1.1,2.5-2.5,2.5S8,31.4,8,30S9.1,27.5,10.5,27.5z"
    />
    <path
      className="st0"
      d="M10.5,53.5c2.5,0,4.5-2,4.5-4.5s-2-4.5-4.5-4.5S6,46.5,6,49S8,53.5,10.5,53.5z M10.5,46.5 c1.4,0,2.5,1.1,2.5,2.5s-1.1,2.5-2.5,2.5S8,50.4,8,49S9.1,46.5,10.5,46.5z"
    />
  </svg>
)

const LeftArrowIconCircular = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Capa_1"
    viewBox="0 0 44.238 44.238"
  >
    <g>
      <g>
        <path d="M22.119,44.237C9.922,44.237,0,34.315,0,22.119S9.922,0.001,22.119,0.001s22.119,9.922,22.119,22.118    S34.314,44.237,22.119,44.237z M22.119,1.501C10.75,1.501,1.5,10.75,1.5,22.119c0,11.368,9.25,20.618,20.619,20.618    s20.619-9.25,20.619-20.618C42.738,10.75,33.488,1.501,22.119,1.501z" />
        <path d="M24.667,29.884c-0.192,0-0.384-0.072-0.53-0.22l-7.328-7.334c-0.292-0.293-0.292-0.768,0-1.061l7.328-7.333    c0.293-0.293,0.768-0.293,1.061,0s0.293,0.768,0,1.061L18.4,21.8l6.798,6.805c0.292,0.293,0.292,0.769,0,1.061    C25.051,29.812,24.859,29.884,24.667,29.884z" />
      </g>
    </g>
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
  </svg>
)

const ClipboardIcon = () => (
  <svg
    id="ClipboardIcon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 415.998 415.998"
  >
    <rect x="111.999" y="176" width="192" height="16" />
    <rect x="111.999" y="224" width="192" height="16" />
    <rect x="111.999" y="272" width="192" height="16" />
    <rect x="111.999" y="320" width="96" height="16" />
    <circle cx="208.239" cy="48" r="12" />
    <path d="M367.998,95.999c0-17.673-14.326-32-31.999-32h-44.424c-5.926-6.583-13.538-11.62-22.284-14.136 c-7.367-2.118-13.037-7.788-15.156-15.155C248.37,14.664,229.897,0,207.998,0c-21.898,0-40.37,14.663-46.134,34.706 c-2.122,7.376-7.806,13.039-15.182,15.165c-8.736,2.518-16.341,7.55-22.262,14.128H79.999c-17.674,0-32,14.327-32,32v287.999 c0,17.673,14.326,32,32,32c73.466,0,163.758,0,256,0c17.674,0,32-14.327,32-32C367.999,293.119,367.998,206.096,367.998,95.999z M128,95.741c0.11-14.066,9.614-26.606,23.113-30.496c12.71-3.662,22.477-13.426,26.127-26.116 C181.157,25.51,193.805,16,207.998,16c14.194,0,26.842,9.51,30.758,23.13c3.652,12.698,13.413,22.459,26.111,26.11 c13.618,3.917,23.13,16.566,23.13,30.758v16H128V95.741z M335.999,399.998c-85.455,0-170.77,0-256,0c-8.823,0-16-7.178-16-16 V95.999c0-8.822,7.177-16,16-16h34.742c-1.73,4.892-2.698,10.143-2.74,15.617v32.383h191.998v-32c0-5.615-0.992-10.991-2.764-16 h34.764c8.822,0,15.999,7.178,15.999,16c0,45.743-0.001,260.254,0.002,287.999C351.999,392.82,344.822,399.998,335.999,399.998z" />
  </svg>
)

const WalletIcon = () => (
  <svg
    id="WalletIcon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 331.493 331.493"
  >
    <path d="M298.761,57.093l-101.2-54.8c-9.6-5.2-22.8-1.2-28,8.4l-59.2,110h-72c-9.2,0-16.4,7.2-16.4,16.4v28.8v149.2 c0,9.2,7.2,16.4,16.4,16.4h230c9.2,0,16.4-7.2,16.4-16.4v-41.6h6.8c3.6,0,6.4-2.8,6.4-6.4v-47.6c0-3.6-2.8-6.4-6.4-6.4h-6.8v-46.8 c0-7.6-5.6-14.4-12.8-16l35.2-65.2C312.361,75.093,308.761,62.693,298.761,57.093z M226.761,32.693l-63.2,117.2h-18l67.6-124.4 L226.761,32.693z M181.161,16.693c2-3.6,6.8-5.2,10.4-3.2l10,5.6l-70.4,130.8h-22L181.161,16.693z M34.361,136.693 c0-1.2,1.6-3.2,3.6-3.2h65.2l-8.8,16h-56.4c-1.2,0-2.4,0-3.6,0.4V136.693z M271.561,315.093c0,2-1.6,3.6-3.6,3.6h-230 c-2,0-3.6-1.6-3.6-3.6v-148.8c0-2,1.6-3.6,3.6-3.6h60.4h25.6h46.8h90h6.8c2,0,3.6,1.6,3.6,3.6v46.8h-24.4v0 c-10.8,0-19.2,8.8-19.2,19.2v22c0,10.8,8.8,19.2,19.2,19.2h24.8V315.093z M284.361,225.893h0.4v34.8h-0.4h-37.6 c-3.6,0-6.4-2.8-6.4-6.4v-22c0-3.6,2.8-6.4,6.4-6.4H284.361z M295.561,78.693l-38.4,71.2h-79.2l60-110.8l54.4,29.6 C296.361,70.293,297.561,75.093,295.561,78.693z" />
    <path d="M271.161,72.693l-3.2-1.6c-8-4.4-18.8-1.2-23.2,6.8l-4,7.6c-2,4-2.8,8.8-1.2,13.2c1.2,4.4,4.4,8,8.4,10l3.2,1.6 c2.4,1.2,5.2,2,8,2c6.4,0,12-3.6,15.2-8.8l4-7.6C282.361,87.493,279.161,77.093,271.161,72.693z M266.761,89.893l-4,7.6 c-1.2,2-4,2.8-6,1.6l-3.2-2c-0.8-0.4-1.6-1.6-2-2.4c-0.4-1.2-0.4-2.4,0.4-3.2l4-7.6c0.8-1.2,2.4-2.4,4-2.4c0.8,0,1.2,0,2,0.4 l3.2,1.6C266.761,85.093,267.561,87.493,266.761,89.893z" />
  </svg>
)

const DeliveryTruckIcon = () => (
  <svg
    id="DeliveryTruckIcon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 480 480"
  >
    <path d="M472,146.626h-68.72v-24c0-9.146-7.414-16.56-16.56-16.56H148c-9.146,0-16.56,7.414-16.56,16.56v49.92H66.96 c-2.87-0.011-5.525,1.515-6.96,4l-32.48,56.72H8c-4.418,0-8,3.582-8,8v89.6c0,4.418,3.582,8,8,8h23.36 c4.451,23.395,27.025,38.751,50.42,34.3c17.39-3.309,30.991-16.91,34.3-34.3h23.36c1.198-0.032,2.374-0.333,3.44-0.88 c1.622,0.562,3.324,0.859,5.04,0.88h104.64c4.451,23.395,27.025,38.751,50.42,34.3c17.39-3.309,30.991-16.91,34.3-34.3h49.44 c9.146,0,16.56-7.414,16.56-16.56v-73.04h51.68c4.418,0,8-3.582,8-8s-3.582-8-8-8h-51.68v-27.36h9.04c4.418,0,8-3.582,8-8 s-3.582-8-8-8h-9.04v-27.28H472c4.418,0,8-3.582,8-8S476.418,146.626,472,146.626z M71.6,188.866h59.84v44.4H46L71.6,188.866z M73.76,357.986c-0.027,0-0.053,0-0.08,0L73.76,357.986c-15.022,0-27.2-12.178-27.2-27.2s12.178-27.2,27.2-27.2 s27.2,12.178,27.2,27.2C100.96,345.808,88.782,357.986,73.76,357.986z M116.08,322.786c-4.451-23.395-27.025-38.751-50.42-34.3 c-17.39,3.309-30.991,16.91-34.3,34.3H16v-73.52h115.44v73.52H116.08z M295.04,357.986c-0.027,0-0.053,0-0.08,0L295.04,357.986 c-15.022,0-27.2-12.178-27.2-27.2s12.178-27.2,27.2-27.2s27.2,12.178,27.2,27.2C322.24,345.808,310.062,357.986,295.04,357.986z M387.36,146.946h-38.24c-4.418,0-8,3.582-8,8s3.582,8,8,8h38.08v27.04h-97.84c-4.418,0-8,3.582-8,8s3.582,8,8,8h97.68v27.36H332 c-4.418,0.006-7.995,3.593-7.989,8.011c0.006,4.41,3.579,7.983,7.989,7.989h54.88v73.52h-49.52 c-4.451-23.395-27.025-38.751-50.42-34.3c-17.39,3.309-30.991,16.91-34.3,34.3l-105.12-0.48l0.56-200l239.28,0.56V146.946z" />
  </svg>
)

const HeadsetIcon = () => (
  <svg
    id="HeadsetIcon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 430.333 430.333"
  >
    <path d="M388.368,199.04c-3.477-6.029-9.3-10.346-16.08-11.92V150c0-82.64-70.56-150-157.28-150S57.728,67.36,57.728,150v37.12 c-6.807,1.669-12.608,6.107-16,12.24c-2.637,5.083-3.932,10.756-3.76,16.48v81.68c-0.158,5.697,1.136,11.341,3.76,16.4 c5.359,9.2,15.555,14.47,26.16,13.52h12.4c0.508,8.46,7.525,15.055,16,15.04h14.08c8.837,0,16-7.163,16-16v-141.2 c0-8.837-7.163-16-16-16h-14.48c-8.837,0-16,7.163-16,16v0.64h-6.48V150c0-73.92,63.36-134,141.28-134s141.28,60.08,141.28,134 v35.92h-6.48v-0.64c0-8.837-7.163-16-16-16h-13.44c-8.837,0-16,7.163-16,16v141.76c0.192,8.009,6.277,14.641,14.24,15.52 c-1.526,10.175-6.036,19.669-12.96,27.28c-12.56,13.92-33.04,21.92-60.64,24v-3.52c-0.432-9.218-8.219-16.362-17.44-16h-34.32 c-9.221-0.362-17.008,6.782-17.44,16v24c0.432,9.218,8.219,16.362,17.44,16h34.64c9.221,0.362,17.008-6.782,17.44-16v-4.48 c32.4-2.16,56.88-11.92,72.48-29.12c9.721-10.584,15.852-23.967,17.52-38.24c8.074-0.469,14.528-6.889,15.04-14.96h12.4 c10.604,0.95,20.801-4.32,26.16-13.52c2.624-5.059,3.918-10.703,3.76-16.4v-81.76C392.521,209.987,391.142,204.196,388.368,199.04 z M96.288,312.08V201.6c0.082-0.932,0.082-1.868,0-2.8v-13.2l13.44-0.4v141.36h-13.44V312.08z M80.288,201.2v110.24h-12.4 c-9.28,0-11.44-3.92-12.16-5.28c-1.294-2.718-1.899-5.713-1.76-8.72v-81.6c-0.177-3.027,0.4-6.051,1.68-8.8 c0.72-1.28,2.88-5.28,12.16-5.28L80.288,201.2z M229.328,402v10.96c-0.356,0.651-1.02,1.073-1.76,1.12h-34.64 c-0.426,0.031-0.854,0.031-1.28,0v-23.36c0.447-0.368,1.024-0.541,1.6-0.48h34.64c0.88,0,1.44,0,1.44,0V402z M333.808,201.6 v124.96h-6.32h-0.96h-0.64h-5.6V185.28h13.76L333.808,201.6z M374.288,306.32c-0.72,1.28-2.88,5.28-12.16,5.28h-12.32V201.92 h12.32c9.28,0,11.44,3.92,12.16,5.28c1.294,2.718,1.899,5.713,1.76,8.72v81.68C376.186,300.607,375.582,303.602,374.288,306.32z" />
  </svg>
)

const DiagramIcon = () => (
  <svg
    id="DiagramIcon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 248 296"
  >
    <path d="M64,168H8c-4.4,0-8,3.6-8,8v112c0,4.4,3.6,8,8,8h56c4.4,0,8-3.6,8-8V176C72,171.6,68.4,168,64,168z M56,280H16v-96h40V280 z" />
    <path d="M152,112H96c-4.4,0-8,3.6-8,8v168c0,4.4,3.6,8,8,8h56c4.4,0,8-3.6,8-8V120C160,115.6,156.4,112,152,112z M144,280h-40V128 h40V280z" />
    <path d="M240,0h-56c-4.4,0-8,3.6-8,8v280c0,4.4,3.6,8,8,8h56c4.4,0,8-3.6,8-8V8C248,3.6,244.4,0,240,0z M232,280h-40V16h40V280z" />
  </svg>
)

const ShopIcon = () => (
  <svg
    id="ShopIcon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 489.4 489.4"
  >
    <path d="M347.7,263.75h-66.5c-18.2,0-33,14.8-33,33v51c0,18.2,14.8,33,33,33h66.5c18.2,0,33-14.8,33-33v-51 C380.7,278.55,365.9,263.75,347.7,263.75z M356.7,347.75c0,5-4.1,9-9,9h-66.5c-5,0-9-4.1-9-9v-51c0-5,4.1-9,9-9h66.5 c5,0,9,4.1,9,9V347.75z" />
    <path d="M489.4,171.05c0-2.1-0.5-4.1-1.6-5.9l-72.8-128c-2.1-3.7-6.1-6.1-10.4-6.1H84.7c-4.3,0-8.3,2.3-10.4,6.1l-72.7,128 c-1,1.8-1.6,3.8-1.6,5.9c0,28.7,17.3,53.3,42,64.2v211.1c0,6.6,5.4,12,12,12h66.3c0.1,0,0.2,0,0.3,0h93c0.1,0,0.2,0,0.3,0h221.4 c6.6,0,12-5.4,12-12v-209.6c0-0.5,0-0.9-0.1-1.3C472,224.55,489.4,199.85,489.4,171.05z M91.7,55.15h305.9l56.9,100.1H34.9 L91.7,55.15z M348.3,179.15c-3.8,21.6-22.7,38-45.4,38c-22.7,0-41.6-16.4-45.4-38H348.3z M232,179.15c-3.8,21.6-22.7,38-45.4,38 s-41.6-16.4-45.5-38H232z M24.8,179.15h90.9c-3.8,21.6-22.8,38-45.5,38C47.5,217.25,28.6,200.75,24.8,179.15z M201.6,434.35h-69 v-129.5c0-9.4,7.6-17.1,17.1-17.1h34.9c9.4,0,17.1,7.6,17.1,17.1v129.5H201.6z M423.3,434.35H225.6v-129.5 c0-22.6-18.4-41.1-41.1-41.1h-34.9c-22.6,0-41.1,18.4-41.1,41.1v129.6H66v-193.3c1.4,0.1,2.8,0.1,4.2,0.1 c24.2,0,45.6-12.3,58.2-31c12.6,18.7,34,31,58.2,31s45.5-12.3,58.2-31c12.6,18.7,34,31,58.1,31c24.2,0,45.5-12.3,58.1-31 c12.6,18.7,34,31,58.2,31c1.4,0,2.7-0.1,4.1-0.1L423.3,434.35L423.3,434.35z M419.2,217.25c-22.7,0-41.6-16.4-45.4-38h90.9 C460.8,200.75,441.9,217.25,419.2,217.25z" />
  </svg>
)

const FlagIcon = () => (
  <svg id="FlagIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
    <path d="M52.5,3h-44V1c0-0.553-0.448-1-1-1s-1,0.447-1,1v3v29v3v23c0,0.553,0.448,1,1,1s1-0.447,1-1V37h44c0.553,0,1-0.447,1-1V4	C53.5,3.447,53.053,3,52.5,3z M51.5,35h-43v-2V5h43V35z" />
  </svg>
)

const NextIcon = () => (
  <svg
    id="NextIcon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 477.175 477.175"
  >
    <path d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5 c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z" />
  </svg>
)

const MapMarkerIcon = () => (
  <svg
    id="MapMarkerIcon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
  >
    <path d="M256,0C156.748,0,76,80.748,76,180c0,33.534,9.289,66.26,26.869,94.652l142.885,230.257 c2.737,4.411,7.559,7.091,12.745,7.091c0.04,0,0.079,0,0.119,0c5.231-0.041,10.063-2.804,12.75-7.292L410.611,272.22 C427.221,244.428,436,212.539,436,180C436,80.748,355.252,0,256,0z M384.866,256.818L258.272,468.186l-129.905-209.34 C113.734,235.214,105.8,207.95,105.8,180c0-82.71,67.49-150.2,150.2-150.2S406.1,97.29,406.1,180 C406.1,207.121,398.689,233.688,384.866,256.818z" />
    <path d="M256,90c-49.626,0-90,40.374-90,90c0,49.309,39.717,90,90,90c50.903,0,90-41.233,90-90C346,130.374,305.626,90,256,90z M256,240.2c-33.257,0-60.2-27.033-60.2-60.2c0-33.084,27.116-60.2,60.2-60.2s60.1,27.116,60.1,60.2 C316.1,212.683,289.784,240.2,256,240.2z" />
  </svg>
)

const ShadedMapMarkerIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className="svg-inline--fa fa-map-marker-alt fa-w-12"
    data-icon="map-marker-alt"
    data-prefix="fas"
    viewBox="0 0 384 512"
  >
    <path
      fill="#eb6b6b"
      d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"
    />
  </svg>
)

const MapOriginIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path
      fill="#828282"
      d="M256,498L256,498c-6.6,0-12-5.4-12-12V376c0-6.6,5.4-12,12-12h0c6.6,0,12,5.4,12,12v110
    C268,492.6,262.6,498,256,498z"
    />
    <circle fill="#0096E6" cx="256" cy="198.3" r="198.3" />
    <path
      fill="#FFFFFF"
      d="M256,286.9c-48.6,0-88-39.5-88-88s39.5-88,88-88s88,39.5,88,88S304.6,286.9,256,286.9z"
    />
  </svg>
)

const MailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44">
    <path d="M43,6H1C0.447,6,0,6.447,0,7v30c0,0.553,0.447,1,1,1h42c0.552,0,1-0.447,1-1V7C44,6.447,43.552,6,43,6z M42,33.581 L29.612,21.194l-1.414,1.414L41.59,36H2.41l13.392-13.392l-1.414-1.414L2,33.581V8h40V33.581z" />
    <path d="M39.979,8L22,25.979L4.021,8H2v0.807L21.293,28.1c0.391,0.391,1.023,0.391,1.414,0L42,8.807V8H39.979z" />
  </svg>
)

const PhoneIcon = () => (
  <svg
    id="PhoneIcon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 29.731 29.731"
  >
    <path d="M23.895,29.731c-1.237,0-2.731-0.31-4.374-0.93c-3.602-1.358-7.521-4.042-11.035-7.556 c-3.515-3.515-6.199-7.435-7.558-11.037C-0.307,6.933-0.31,4.245,0.921,3.015c0.177-0.177,0.357-0.367,0.543-0.563 c1.123-1.181,2.392-2.51,4.074-2.45C6.697,0.05,7.82,0.77,8.97,2.201c3.398,4.226,1.866,5.732,0.093,7.478l-0.313,0.31 c-0.29,0.29-0.838,1.633,4.26,6.731c1.664,1.664,3.083,2.882,4.217,3.619c0.714,0.464,1.991,1.166,2.515,0.642l0.315-0.318 c1.744-1.769,3.25-3.296,7.473,0.099c1.431,1.15,2.15,2.272,2.198,3.433c0.069,1.681-1.27,2.953-2.452,4.075 c-0.195,0.186-0.385,0.366-0.562,0.542C26.103,29.424,25.126,29.731,23.895,29.731z M5.418,1C4.223,1,3.144,2.136,2.189,3.141 C1.997,3.343,1.811,3.539,1.628,3.722C0.711,4.638,0.804,7.045,1.864,9.856c1.31,3.472,3.913,7.266,7.33,10.683 c3.416,3.415,7.208,6.018,10.681,7.327c2.811,1.062,5.218,1.152,6.133,0.237c0.183-0.183,0.379-0.369,0.581-0.56 c1.027-0.976,2.192-2.082,2.141-3.309c-0.035-0.843-0.649-1.75-1.825-2.695c-3.519-2.83-4.503-1.831-6.135-0.176l-0.32,0.323 c-0.78,0.781-2.047,0.608-3.767-0.51c-1.193-0.776-2.667-2.038-4.379-3.751c-4.231-4.23-5.584-6.819-4.26-8.146l0.319-0.315 c1.659-1.632,2.66-2.617-0.171-6.138C7.245,1.651,6.339,1.037,5.496,1.001C5.47,1,5.444,1,5.418,1z" />
  </svg>
)

const BackIcon = () => (
  <svg
    id="BackIcon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 477.175 477.175"
  >
    <path d="M145.188,238.575l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225 c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z" />
  </svg>
)

const HomeIcon = () => (
  <svg id="HomeIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 33">
    <path d="M27.649,33h-7.216c-0.276,0-0.5-0.224-0.5-0.5V22.32h-6.867V32.5c0,0.276-0.224,0.5-0.5,0.5H5.348	c-0.276,0-0.5-0.224-0.5-0.5V15.893H0.73c-0.205,0-0.389-0.125-0.465-0.315c-0.075-0.19-0.027-0.407,0.121-0.548L16.154,0.137	c0.193-0.183,0.494-0.182,0.688,0l15.772,14.893c0.148,0.141,0.196,0.358,0.121,0.548c-0.076,0.19-0.26,0.315-0.465,0.315h-4.121	V32.5C28.149,32.776,27.925,33,27.649,33z M20.933,32h6.216V15.393c0-0.276,0.224-0.5,0.5-0.5h3.363L16.498,1.188L1.988,14.893h3.36	c0.276,0,0.5,0.224,0.5,0.5V32h6.218V21.82c0-0.276,0.224-0.5,0.5-0.5h7.867c0.276,0,0.5,0.224,0.5,0.5V32z" />
  </svg>
)

const CustomerIcon = () => (
  <svg id="CustomerIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
    <path d="M48.014,42.889l-9.553-4.776C37.56,37.662,37,36.756,37,35.748v-3.381c0.229-0.28,0.47-0.599,0.719-0.951	c1.239-1.75,2.232-3.698,2.954-5.799C42.084,24.97,43,23.575,43,22v-4c0-0.963-0.36-1.896-1-2.625v-5.319	c0.056-0.55,0.276-3.824-2.092-6.525C37.854,1.188,34.521,0,30,0s-7.854,1.188-9.908,3.53C17.724,6.231,17.944,9.506,18,10.056	v5.319c-0.64,0.729-1,1.662-1,2.625v4c0,1.217,0.553,2.352,1.497,3.109c0.916,3.627,2.833,6.36,3.503,7.237v3.309	c0,0.968-0.528,1.856-1.377,2.32l-8.921,4.866C8.801,44.424,7,47.458,7,50.762V54c0,4.746,15.045,6,23,6s23-1.254,23-6v-3.043	C53,47.519,51.089,44.427,48.014,42.889z M51,54c0,1.357-7.412,4-21,4S9,55.357,9,54v-3.238c0-2.571,1.402-4.934,3.659-6.164	l8.921-4.866C23.073,38.917,24,37.354,24,35.655v-4.019l-0.233-0.278c-0.024-0.029-2.475-2.994-3.41-7.065l-0.091-0.396l-0.341-0.22	C19.346,23.303,19,22.676,19,22v-4c0-0.561,0.238-1.084,0.67-1.475L20,16.228V10l-0.009-0.131c-0.003-0.027-0.343-2.799,1.605-5.021	C23.253,2.958,26.081,2,30,2c3.905,0,6.727,0.951,8.386,2.828c1.947,2.201,1.625,5.017,1.623,5.041L40,16.228l0.33,0.298	C40.762,16.916,41,17.439,41,18v4c0,0.873-0.572,1.637-1.422,1.899l-0.498,0.153l-0.16,0.495c-0.669,2.081-1.622,4.003-2.834,5.713	c-0.297,0.421-0.586,0.794-0.837,1.079L35,31.623v4.125c0,1.77,0.983,3.361,2.566,4.153l9.553,4.776	C49.513,45.874,51,48.28,51,50.957V54z" />
  </svg>
)

const CalendarIcon = () => (
  <svg id="CalendarIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
    <path d="M57,4h-7V1c0-0.553-0.447-1-1-1h-7c-0.553,0-1,0.447-1,1v3H19V1c0-0.553-0.447-1-1-1h-7c-0.553,0-1,0.447-1,1v3H3 C2.447,4,2,4.447,2,5v11v43c0,0.553,0.447,1,1,1h54c0.553,0,1-0.447,1-1V16V5C58,4.447,57.553,4,57,4z M43,2h5v3v3h-5V5V2z M12,2h5 v3v3h-5V5V2z M4,6h6v3c0,0.553,0.447,1,1,1h7c0.553,0,1-0.447,1-1V6h22v3c0,0.553,0.447,1,1,1h7c0.553,0,1-0.447,1-1V6h6v9H4V6z M4,58V17h52v41H4z" />
    <path d="M38,23h-7h-2h-7h-2h-9v9v2v7v2v9h9h2h7h2h7h2h9v-9v-2v-7v-2v-9h-9H38z M31,25h7v7h-7V25z M38,41h-7v-7h7V41z M22,34h7v7h-7 V34z M22,25h7v7h-7V25z M13,25h7v7h-7V25z M13,34h7v7h-7V34z M20,50h-7v-7h7V50z M29,50h-7v-7h7V50z M38,50h-7v-7h7V50z M47,50h-7 v-7h7V50z M47,41h-7v-7h7V41z M47,25v7h-7v-7H47z" />
  </svg>
)

const AddIcon = () => (
  <div>
    <svg id="AddIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 42">
      <polygon points="42,20 22,20 22,0 20,0 20,20 0,20 0,22 20,22 20,42 22,42 22,22 42,22" />
    </svg>
  </div>
)

const SubtractIcon = () => (
  <div>
    <svg id="AddIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 42">
      <polygon points="42,20 0,20 0,22 42,22" />
    </svg>
  </div>
)

const CloseIcon = () => (
  <svg
    id="CloseIcon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 47.971 47.971"
  >
    <path d="M28.228,23.986L47.092,5.122c1.172-1.171,1.172-3.071,0-4.242c-1.172-1.172-3.07-1.172-4.242,0L23.986,19.744L5.121,0.88 c-1.172-1.172-3.07-1.172-4.242,0c-1.172,1.171-1.172,3.071,0,4.242l18.865,18.864L0.879,42.85c-1.172,1.171-1.172,3.071,0,4.242 C1.465,47.677,2.233,47.97,3,47.97s1.535-0.293,2.121-0.879l18.865-18.864L42.85,47.091c0.586,0.586,1.354,0.879,2.121,0.879 s1.535-0.293,2.121-0.879c1.172-1.171,1.172-3.071,0-4.242L28.228,23.986z" />
  </svg>
)

const MagnifierIcon = () => (
  <svg id="ArrowDown" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 451 451">
    <path d="M447.05,428l-109.6-109.6c29.4-33.8,47.2-77.9,47.2-126.1C384.65,86.2,298.35,0,192.35,0C86.25,0,0.05,86.3,0.05,192.3 s86.3,192.3,192.3,192.3c48.2,0,92.3-17.8,126.1-47.2L428.05,447c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4 C452.25,441.8,452.25,433.2,447.05,428z M26.95,192.3c0-91.2,74.2-165.3,165.3-165.3c91.2,0,165.3,74.2,165.3,165.3 s-74.1,165.4-165.3,165.4C101.15,357.7,26.95,283.5,26.95,192.3z" />
  </svg>
)

const ArrowDownIcon = () => (
  <svg
    id="ArrowDownIcon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 451.8 451.8"
  >
    <path d="M225.9,354.7c-8.1,0-16.2-3.1-22.4-9.3L9.3,151.2c-12.4-12.4-12.4-32.4,0-44.8c12.4-12.4,32.4-12.4,44.7,0l171.9,171.9 l171.9-171.9c12.4-12.4,32.4-12.4,44.7,0c12.4,12.4,12.4,32.4,0,44.8L248.3,345.4C242.1,351.6,234,354.7,225.9,354.7z" />
  </svg>
)

const TrashCanIcon = () => (
  <svg id="TrashCanIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59 59">
    <path d="M29.5,51c0.552,0,1-0.447,1-1V17c0-0.553-0.448-1-1-1s-1,0.447-1,1v33C28.5,50.553,28.948,51,29.5,51z" />
    <path d="M19.5,51c0.552,0,1-0.447,1-1V17c0-0.553-0.448-1-1-1s-1,0.447-1,1v33C18.5,50.553,18.948,51,19.5,51z" />
    <path d="M39.5,51c0.552,0,1-0.447,1-1V17c0-0.553-0.448-1-1-1s-1,0.447-1,1v33C38.5,50.553,38.948,51,39.5,51z" />
    <path d="M52.5,6H38.456c-0.11-1.25-0.495-3.358-1.813-4.711C35.809,0.434,34.751,0,33.499,0H23.5c-1.252,0-2.31,0.434-3.144,1.289 C19.038,2.642,18.653,4.75,18.543,6H6.5c-0.552,0-1,0.447-1,1s0.448,1,1,1h2.041l1.915,46.021C10.493,55.743,11.565,59,15.364,59 h28.272c3.799,0,4.871-3.257,4.907-4.958L50.459,8H52.5c0.552,0,1-0.447,1-1S53.052,6,52.5,6z M21.792,2.681 C22.24,2.223,22.799,2,23.5,2h9.999c0.701,0,1.26,0.223,1.708,0.681c0.805,0.823,1.128,2.271,1.24,3.319H20.553 C20.665,4.952,20.988,3.504,21.792,2.681z M46.544,53.979C46.538,54.288,46.4,57,43.636,57H15.364 c-2.734,0-2.898-2.717-2.909-3.042L10.542,8h37.915L46.544,53.979z" />
  </svg>
)

const NotPermittedIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 125">
    <path d="M49.333,8.835c-21.597,0-39.167,17.57-39.167,39.167s17.57,39.166,39.167,39.166S88.5,69.599,88.5,48.002 S70.93,8.835,49.333,8.835z M49.333,11.835c9.433,0,18.03,3.633,24.476,9.569L22.737,72.478c-5.937-6.445-9.57-15.043-9.57-24.476 C13.167,28.06,29.391,11.835,49.333,11.835z M49.333,84.168c-9.433,0-18.03-3.633-24.476-9.569L75.93,23.525 c5.936,6.446,9.57,15.044,9.57,24.477C85.5,67.944,69.276,84.168,49.333,84.168z" />
  </svg>
)

const CheckedIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <path d="M 50 6 C 25.72316 6 6 25.72314 6 50 C 6 74.2768 25.72316 94 50 94 C 74.27684 94 94 74.2768 94 50 C 94 25.72314 74.27684 6 50 6 z M 50 10 C 72.115076 10 90 27.8849 90 50 C 90 72.1151 72.115076 90 50 90 C 27.884924 90 10 72.1151 10 50 C 10 27.8849 27.884924 10 50 10 z M 73.75 30.96875 A 2.0002 2.0002 0 0 0 72.59375 31.5625 L 40 64.15625 L 27.40625 51.5625 A 2.0002 2.0002 0 1 0 24.59375 54.40625 L 38.59375 68.40625 A 2.0002 2.0002 0 0 0 41.40625 68.40625 L 75.40625 34.40625 A 2.0002 2.0002 0 0 0 73.75 30.96875 z" />
  </svg>
)

const BlueCheckedIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.262 30.262">
    <path
      d="M15.131,0.002C6.773,0.002,0,6.777,0,15.13c0,8.358,6.773,15.13,15.131,15.13   s15.131-6.771,15.131-15.13C30.262,6.777,23.488,0.002,15.131,0.002z M12.859,24.148c-0.34,0.336-0.887,0.336-1.223,0l-0.271-0.271   l0,0l-0.295-0.293l-1.266-1.266l-0.02-0.029l-5.807-5.851c-0.338-0.336-0.338-0.887,0-1.22l1.83-1.83   c0.34-0.339,0.883-0.339,1.221,0l5.225,5.262l10.98-10.982c0.336-0.337,0.883-0.337,1.219,0l1.83,1.832   c0.338,0.336,0.338,0.885,0,1.221L12.859,24.148z"
      data-original="#030104"
      class="active-path"
      data-old_color="#4d6f87"
    />
  </svg>
)

const StarIcon = () => (
  <svg
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 53.867 53.867"
  >
    <polygon
      points="26.934,1.318 35.256,18.182 53.867,20.887 40.4,34.013 43.579,52.549 26.934,43.798 
	10.288,52.549 13.467,34.013 0,20.887 18.611,18.182 "
    />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
  </svg>
)

const OrangeCheckedIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.262 30.262">
    <path d="M15.131,0.002C6.773,0.002,0,6.777,0,15.13c0,8.358,6.773,15.13,15.131,15.13   s15.131-6.771,15.131-15.13C30.262,6.777,23.488,0.002,15.131,0.002z M12.859,24.148c-0.34,0.336-0.887,0.336-1.223,0l-0.271-0.271   l0,0l-0.295-0.293l-1.266-1.266l-0.02-0.029l-5.807-5.851c-0.338-0.336-0.338-0.887,0-1.22l1.83-1.83   c0.34-0.339,0.883-0.339,1.221,0l5.225,5.262l10.98-10.982c0.336-0.337,0.883-0.337,1.219,0l1.83,1.832   c0.338,0.336,0.338,0.885,0,1.221L12.859,24.148z" />
  </svg>
)

const InfoIcon = () => (
  <svg id="InfoIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65 65">
    <path d="M32.5,0C14.58,0,0,14.579,0,32.5S14.58,65,32.5,65S65,50.421,65,32.5S50.42,0,32.5,0z M32.5,61C16.785,61,4,48.215,4,32.5 S16.785,4,32.5,4S61,16.785,61,32.5S48.215,61,32.5,61z" />
    <circle cx="33.018" cy="19.541" r="3.345" />
    <path d="M32.137,28.342c-1.104,0-2,0.896-2,2v17c0,1.104,0.896,2,2,2s2-0.896,2-2v-17C34.137,29.237,33.241,28.342,32.137,28.342z" />
  </svg>
)

const WarningIcon = () => (
  <svg
    id="WarningIcon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
  >
    <path d="M256,0C114.497,0,0,114.507,0,256c0,141.503,114.507,256,256,256c141.503,0,256-114.507,256-256 C512,114.497,397.493,0,256,0z M256,472c-119.393,0-216-96.615-216-216c0-119.393,96.615-216,216-216 c119.393,0,216,96.615,216,216C472,375.393,375.385,472,256,472z" />
    <path d="M256,128.877c-11.046,0-20,8.954-20,20V277.67c0,11.046,8.954,20,20,20s20-8.954,20-20V148.877 C276,137.831,267.046,128.877,256,128.877z" />
    <circle cx="256" cy="349.16" r="27" />
  </svg>
)

const PencilIcon = () => (
  <svg
    id="PencilIcon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 94.6 94.8"
  >
    <path d="M0.1,71.1L0,90.6c0,1.1,0.4,2.2,1.2,3s1.8,1.2,2.9,1.2l19.4-0.1c1.1,0,2.1-0.4,2.9-1.2l67-67c1.6-1.6,1.6-4.2,0-5.9 L74.2,1.2c-1.6-1.6-4.2-1.6-5.9,0L54.9,14.7L1.3,68.2C0.6,69,0.1,70,0.1,71.1z M71.3,5.8l17.7,17.7l-9.7,9.7L61.6,15.5L71.3,5.8z M6.3,70.8l51.5-51.5L75.6,37L24,88.4L6.2,88.5L6.3,70.8z" />
  </svg>
)

const UserProfileIcon = () => (
  <svg id="Capa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55 55">
    <path d="M55,27.5C55,12.337,42.663,0,27.5,0S0,12.337,0,27.5c0,8.009,3.444,15.228,8.926,20.258l-0.026,0.023l0.892,0.752	c0.058,0.049,0.121,0.089,0.179,0.137c0.474,0.393,0.965,0.766,1.465,1.127c0.162,0.117,0.324,0.234,0.489,0.348	c0.534,0.368,1.082,0.717,1.642,1.048c0.122,0.072,0.245,0.142,0.368,0.212c0.613,0.349,1.239,0.678,1.88,0.98	c0.047,0.022,0.095,0.042,0.142,0.064c2.089,0.971,4.319,1.684,6.651,2.105c0.061,0.011,0.122,0.022,0.184,0.033	c0.724,0.125,1.456,0.225,2.197,0.292c0.09,0.008,0.18,0.013,0.271,0.021C25.998,54.961,26.744,55,27.5,55	c0.749,0,1.488-0.039,2.222-0.098c0.093-0.008,0.186-0.013,0.279-0.021c0.735-0.067,1.461-0.164,2.178-0.287	c0.062-0.011,0.125-0.022,0.187-0.034c2.297-0.412,4.495-1.109,6.557-2.055c0.076-0.035,0.153-0.068,0.229-0.104	c0.617-0.29,1.22-0.603,1.811-0.936c0.147-0.083,0.293-0.167,0.439-0.253c0.538-0.317,1.067-0.648,1.581-1	c0.185-0.126,0.366-0.259,0.549-0.391c0.439-0.316,0.87-0.642,1.289-0.983c0.093-0.075,0.193-0.14,0.284-0.217l0.915-0.764	l-0.027-0.023C51.523,42.802,55,35.55,55,27.5z M2,27.5C2,13.439,13.439,2,27.5,2S53,13.439,53,27.5	c0,7.577-3.325,14.389-8.589,19.063c-0.294-0.203-0.59-0.385-0.893-0.537l-8.467-4.233c-0.76-0.38-1.232-1.144-1.232-1.993v-2.957	c0.196-0.242,0.403-0.516,0.617-0.817c1.096-1.548,1.975-3.27,2.616-5.123c1.267-0.602,2.085-1.864,2.085-3.289v-3.545	c0-0.867-0.318-1.708-0.887-2.369v-4.667c0.052-0.519,0.236-3.448-1.883-5.864C34.524,9.065,31.541,8,27.5,8	s-7.024,1.065-8.867,3.168c-2.119,2.416-1.935,5.345-1.883,5.864v4.667c-0.568,0.661-0.887,1.502-0.887,2.369v3.545	c0,1.101,0.494,2.128,1.34,2.821c0.81,3.173,2.477,5.575,3.093,6.389v2.894c0,0.816-0.445,1.566-1.162,1.958l-7.907,4.313	c-0.252,0.137-0.502,0.297-0.752,0.476C5.276,41.792,2,35.022,2,27.5z M42.459,48.132c-0.35,0.254-0.706,0.5-1.067,0.735	c-0.166,0.108-0.331,0.216-0.5,0.321c-0.472,0.292-0.952,0.57-1.442,0.83c-0.108,0.057-0.217,0.111-0.326,0.167	c-1.126,0.577-2.291,1.073-3.488,1.476c-0.042,0.014-0.084,0.029-0.127,0.043c-0.627,0.208-1.262,0.393-1.904,0.552	c-0.002,0-0.004,0.001-0.006,0.001c-0.648,0.16-1.304,0.293-1.964,0.402c-0.018,0.003-0.036,0.007-0.054,0.01	c-0.621,0.101-1.247,0.174-1.875,0.229c-0.111,0.01-0.222,0.017-0.334,0.025C28.751,52.97,28.127,53,27.5,53	c-0.634,0-1.266-0.031-1.895-0.078c-0.109-0.008-0.218-0.015-0.326-0.025c-0.634-0.056-1.265-0.131-1.89-0.233	c-0.028-0.005-0.056-0.01-0.084-0.015c-1.322-0.221-2.623-0.546-3.89-0.971c-0.039-0.013-0.079-0.027-0.118-0.04	c-0.629-0.214-1.251-0.451-1.862-0.713c-0.004-0.002-0.009-0.004-0.013-0.006c-0.578-0.249-1.145-0.525-1.705-0.816	c-0.073-0.038-0.147-0.074-0.219-0.113c-0.511-0.273-1.011-0.568-1.504-0.876c-0.146-0.092-0.291-0.185-0.435-0.279	c-0.454-0.297-0.902-0.606-1.338-0.933c-0.045-0.034-0.088-0.07-0.133-0.104c0.032-0.018,0.064-0.036,0.096-0.054l7.907-4.313	c1.36-0.742,2.205-2.165,2.205-3.714l-0.001-3.602l-0.23-0.278c-0.022-0.025-2.184-2.655-3.001-6.216l-0.091-0.396l-0.341-0.221	c-0.481-0.311-0.769-0.831-0.769-1.392v-3.545c0-0.465,0.197-0.898,0.557-1.223l0.33-0.298v-5.57l-0.009-0.131	c-0.003-0.024-0.298-2.429,1.396-4.36C21.583,10.837,24.061,10,27.5,10c3.426,0,5.896,0.83,7.346,2.466	c1.692,1.911,1.415,4.361,1.413,4.381l-0.009,5.701l0.33,0.298c0.359,0.324,0.557,0.758,0.557,1.223v3.545	c0,0.713-0.485,1.36-1.181,1.575l-0.497,0.153l-0.16,0.495c-0.59,1.833-1.43,3.526-2.496,5.032c-0.262,0.37-0.517,0.698-0.736,0.949	l-0.248,0.283V39.8c0,1.612,0.896,3.062,2.338,3.782l8.467,4.233c0.054,0.027,0.107,0.055,0.16,0.083	C42.677,47.979,42.567,48.054,42.459,48.132z" />
  </svg>
)

const UserProfileDropdownIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14.665" height="9.335">
    <path
      fillRule="evenodd"
      fill="#656565"
      d="M5.493,6.400 C5.297,6.400 5.100,6.329 4.950,6.186 L0.234,1.695 C-0.066,1.409 -0.066,0.946 0.234,0.661 C0.534,0.375 1.020,0.375 1.320,0.661 L5.493,4.635 L9.666,0.661 C9.966,0.375 10.453,0.375 10.752,0.661 C11.052,0.946 11.052,1.410 10.752,1.695 L6.036,6.186 C5.886,6.329 5.690,6.400 5.493,6.400 Z"
    />
  </svg>
)

const HidePasswordButton = () => (
  <svg
    id="HidePasswordButton"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 59.049 59.049"
  >
    <path d="M11.285,41.39c0.184,0.146,0.404,0.218,0.623,0.218c0.294,0,0.585-0.129,0.783-0.377c0.344-0.432,0.273-1.061-0.159-1.405 c-0.801-0.638-1.577-1.331-2.305-2.06l-7.398-7.398l7.629-7.629c7.334-7.333,18.003-9.836,27.839-6.534 c0.523,0.173,1.09-0.107,1.267-0.63c0.175-0.523-0.106-1.091-0.63-1.267c-10.562-3.545-22.016-0.857-29.89,7.016L0,30.368 l8.812,8.812C9.593,39.962,10.426,40.705,11.285,41.39z" />
    <path d="M50.237,21.325c-1.348-1.348-2.826-2.564-4.394-3.616c-0.458-0.307-1.081-0.185-1.388,0.273 c-0.308,0.458-0.185,1.08,0.273,1.388c1.46,0.979,2.838,2.113,4.094,3.369l7.398,7.398l-7.629,7.629 c-7.385,7.385-18.513,9.882-28.352,6.356c-0.52-0.187-1.093,0.084-1.279,0.604c-0.186,0.52,0.084,1.092,0.604,1.279 c3.182,1.14,6.49,1.693,9.776,1.693c7.621,0,15.124-2.977,20.665-8.518l9.043-9.043L50.237,21.325z" />
    <path d="M30.539,41.774c-2.153,0-4.251-0.598-6.07-1.73c-0.467-0.29-1.084-0.148-1.377,0.321c-0.292,0.469-0.148,1.085,0.321,1.377 c2.135,1.33,4.6,2.032,7.126,2.032c7.444,0,13.5-6.056,13.5-13.5c0-2.685-0.787-5.279-2.275-7.502 c-0.308-0.459-0.93-0.582-1.387-0.275c-0.459,0.308-0.582,0.929-0.275,1.387c1.267,1.893,1.937,4.102,1.937,6.39 C42.039,36.616,36.88,41.774,30.539,41.774z" />
    <path d="M30.539,18.774c2.065,0,4.089,0.553,5.855,1.6c0.474,0.281,1.088,0.125,1.37-0.351c0.281-0.475,0.125-1.088-0.351-1.37 c-2.074-1.229-4.451-1.879-6.875-1.879c-7.444,0-13.5,6.056-13.5,13.5c0,2.084,0.462,4.083,1.374,5.941 c0.174,0.354,0.529,0.56,0.899,0.56c0.147,0,0.298-0.033,0.439-0.102c0.496-0.244,0.701-0.843,0.458-1.338 c-0.776-1.582-1.17-3.284-1.17-5.06C19.039,23.933,24.198,18.774,30.539,18.774z" />
    <path d="M54.621,5.567c-0.391-0.391-1.023-0.391-1.414,0l-46.5,46.5c-0.391,0.391-0.391,1.023,0,1.414 c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293l46.5-46.5C55.012,6.591,55.012,5.958,54.621,5.567z" />
  </svg>
)

const ViewPasswordButton = () => (
  <svg
    id="ViewPasswordButton"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 59.2 59.2"
  >
    <path d="M51.062,21.561c-11.889-11.889-31.232-11.889-43.121,0L0,29.501l8.138,8.138c5.944,5.944,13.752,8.917,21.561,8.917 s15.616-2.972,21.561-8.917l7.941-7.941L51.062,21.561z M49.845,36.225c-11.109,11.108-29.184,11.108-40.293,0l-6.724-6.724 l6.527-6.527c11.109-11.108,29.184-11.108,40.293,0l6.724,6.724L49.845,36.225z" />
    <path d="M28.572,21.57c-3.86,0-7,3.14-7,7c0,0.552,0.448,1,1,1s1-0.448,1-1c0-2.757,2.243-5,5-5c0.552,0,1-0.448,1-1 S29.125,21.57,28.572,21.57z" />
    <path d="M29.572,16.57c-7.168,0-13,5.832-13,13s5.832,13,13,13s13-5.832,13-13S36.741,16.57,29.572,16.57z M29.572,40.57 c-6.065,0-11-4.935-11-11s4.935-11,11-11s11,4.935,11,11S35.638,40.57,29.572,40.57z" />
  </svg>
)

const DuplicateIcon = () => (
  <svg
    baseProfile="tiny"
    id="DuplicateIcon"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path d="M15.979,7.62H1.021c-0.221,0-0.4,0.18-0.4,0.4v14.959c0,0.221,0.179,0.4,0.4,0.4h14.959c0.221,0,0.4-0.18,0.4-0.4V8.021 C16.379,7.8,16.2,7.62,15.979,7.62z M15.58,22.579H1.42V8.421H15.58V22.579z" />
    <path d="M22.979,0.62H8.021c-0.221,0-0.4,0.18-0.4,0.4v4.959c0,0.221,0.179,0.4,0.4,0.4s0.4-0.18,0.4-0.4V1.421H22.58v14.158 h-4.559c-0.221,0-0.4,0.18-0.4,0.4s0.179,0.4,0.4,0.4h4.959c0.221,0,0.4-0.18,0.4-0.4V1.021C23.379,0.8,23.2,0.62,22.979,0.62z" />
  </svg>
)

const BoxIcon = () => (
  <svg id="BoxIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
    <path d="M60,8.3c0-0.2-0.1-0.4-0.1-0.6c0-0.2-0.1-0.4-0.3-0.6L53.5,0H6.5L0.4,7.2C0.2,7.3,0.2,7.6,0.1,7.8C0.1,7.9,0,8.1,0,8.3V19 h3v41h54V19h3V8.3z M7.5,2h45.1l4.3,5H3.2L7.5,2z M55,58H5V19h50V58z M58,17h-1H3H2V9h56V17z" />
  </svg>
)

const PriceTagIcon = () => (
  <svg
    id="PriceTagIcon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 59.998 59.998"
  >
    <path d="M59.206,0.293c-0.391-0.391-1.023-0.391-1.414,0L54.085,4H30.802L1.532,33.511c-0.666,0.666-1.033,1.553-1.033,2.495	s0.367,1.829,1.033,2.495l20.466,20.466c0.687,0.687,1.588,1.031,2.491,1.031c0.907,0,1.814-0.347,2.509-1.041l28.501-29.271V5.414	l3.707-3.707C59.597,1.316,59.597,0.684,59.206,0.293z M53.499,28.874L25.574,57.553c-0.596,0.596-1.566,0.596-2.162,0L2.946,37.087	c-0.596-0.596-0.596-1.566,0.003-2.165L31.636,6h20.449l-4.833,4.833C46.461,10.309,45.516,10,44.499,10c-2.757,0-5,2.243-5,5	s2.243,5,5,5s5-2.243,5-5c0-1.017-0.309-1.962-0.833-2.753l4.833-4.833V28.874z M47.499,15c0,1.654-1.346,3-3,3s-3-1.346-3-3	s1.346-3,3-3c0.462,0,0.894,0.114,1.285,0.301l-1.992,1.992c-0.391,0.391-0.391,1.023,0,1.414C43.987,15.902,44.243,16,44.499,16	s0.512-0.098,0.707-0.293l1.992-1.992C47.386,14.106,47.499,14.538,47.499,15z" />
  </svg>
)

const CalculatorIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512pt">
    <path
      d="m437 0h-362c-41.355469 0-75 33.644531-75 75v362c0 41.355469 33.644531 75 75 75h362c41.355469 0 75-33.644531 75-75v-362c0-41.355469-33.644531-75-75-75zm0 482h-166v-211.503906h211v166.503906c0 24.8125-20.1875 45-45 45zm-362-452h166v210.496094h-211v-165.496094c0-24.8125 20.1875-45 45-45zm407 210.496094h-211v-210.496094h166c24.8125 0 45 20.1875 45 45zm-452 30h211v211.503906h-166c-24.8125 0-45-20.1875-45-45zm0 0"
      fill="#696969"
    />
    <path
      d="m423.355469 118.433594h-92.570313c-8.285156 0-15 6.714844-15 15s6.714844 15 15 15h92.570313c8.285156 0 15-6.714844 15-15s-6.714844-15-15-15zm0 0"
      fill="#696969"
    />
    <path
      d="m423.359375 368.179688h-92.578125c-8.285156 0-15 6.714843-15 15 0 8.285156 6.714844 15 15 15h92.578125c8.285156 0 15-6.714844 15-15 0-8.285157-6.714844-15-15-15zm0 0"
      fill="#696969"
    />
    <path
      d="m89.476562 148.441406h31.285157v31.765625c0 8.285157 6.714843 15 15 15 8.28125 0 15-6.714843 15-15v-31.765625h31.289062c8.28125 0 15-6.714844 15-15s-6.71875-15-15-15h-31.289062v-31.78125c0-8.285156-6.71875-15-15-15-8.285157 0-15 6.714844-15 15v31.78125h-31.285157c-8.28125 0-15 6.714844-15 15s6.714844 15 15 15zm0 0"
      fill="#696969"
    />
    <path
      d="m92.476562 426.914062c2.925782 2.894532 6.738282 4.339844 10.550782 4.339844 3.867187 0 7.730468-1.484375 10.664062-4.449218l22.066406-22.292969 22.066407 22.292969c2.933593 2.964843 6.796875 4.449218 10.660156 4.449218 3.8125 0 7.628906-1.445312 10.550781-4.339844 5.890625-5.828124 5.9375-15.324218.109375-21.210937l-22.285156-22.519531 22.292969-22.527344c5.828125-5.886719 5.777344-15.386719-.109375-21.214844-5.890625-5.824218-15.386719-5.777344-21.214844.113282l-22.074219 22.304687-22.0625-22.292969c-5.828125-5.886718-15.328125-5.933594-21.214844-.109375-5.886718 5.828125-5.9375 15.324219-.109374 21.214844l22.285156 22.511719-22.285156 22.515625c-5.828126 5.890625-5.777344 15.390625.109374 21.214843zm0 0"
      fill="#696969"
    />
    <path
      d="m391.035156 337.640625c0-7.832031-6.285156-14.179687-14.035156-14.179687s-14.035156 6.347656-14.035156 14.179687c0 7.835937 6.285156 14.183594 14.035156 14.183594s14.035156-6.347657 14.035156-14.183594zm0 0"
      fill="#696969"
    />
    <path
      d="m391.035156 428.585938c0-7.835938-6.285156-14.183594-14.035156-14.183594s-14.035156 6.347656-14.035156 14.183594c0 7.832031 6.285156 14.183593 14.035156 14.183593s14.035156-6.351562 14.035156-14.183593zm0 0"
      fill="#696969"
    />
  </svg>
)

const PaymentMethodIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="PaymentMethodIcon"
    viewBox="0 0 512 512"
  >
    <path d="M469.256,175.503h-52.1v-73.542c0-23.569-19.175-42.744-42.744-42.744H42.744C19.175,59.218,0,78.393,0,101.962v191.786 c0,23.569,19.175,42.744,42.744,42.744h52.102v73.546c0,23.569,19.175,42.744,42.744,42.744h331.666 c23.569,0,42.744-19.175,42.744-42.744V218.247C512,194.678,492.825,175.503,469.256,175.503z M24.425,101.962 c0-10.101,8.218-18.319,18.319-18.319h331.668c10.101,0,18.319,8.218,18.319,18.319v17.051H24.425V101.962z M94.846,218.247 v93.819H42.744c-10.101,0-18.319-8.218-18.319-18.319v-93.743h74.52C96.32,205.54,94.846,211.725,94.846,218.247z M24.425,175.579 v-32.14h368.306v32.064H137.59c-0.826,0-1.644,0.029-2.458,0.076H24.425z M469.256,428.357H137.59 c-10.101,0-18.319-8.218-18.319-18.319V218.247c0-9.597,7.422-17.479,16.824-18.243H404.94c0.451,0,0.894-0.028,1.331-0.076 h62.984c10.101,0,18.319,8.218,18.319,18.319v191.791h0.001C487.575,420.139,479.357,428.357,469.256,428.357z" />
    <path d="M340.211,255.272c-13.892,0-26.666,4.847-36.745,12.924c-10.333-8.324-23.209-12.931-36.829-12.931 c-32.465,0-58.877,26.412-58.877,58.877c0,32.465,26.412,58.877,58.877,58.877c13.621,0,26.496-4.607,36.829-12.929 c10.079,8.077,22.853,12.925,36.745,12.925c32.462,0,58.871-26.41,58.871-58.872C399.082,281.681,372.673,255.272,340.211,255.272 z M287.953,341.201c-6.009,4.758-13.451,7.392-21.317,7.392c-18.997,0.001-34.452-15.454-34.452-34.45 c0-18.997,15.455-34.452,34.452-34.452c7.866,0,15.307,2.635,21.317,7.392c-4.216,8.108-6.613,17.306-6.613,27.058 C281.34,323.894,283.738,333.092,287.953,341.201z M340.211,348.589c-18.993,0-34.445-15.453-34.445-34.447 c0-18.993,15.453-34.445,34.445-34.445c18.993,0,34.445,15.453,34.445,34.445C374.656,333.137,359.204,348.589,340.211,348.589z" />
  </svg>
)

const SettingsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" id="SettingsIcon" viewBox="0 0 54 54">
    <path d="M51.22,21h-5.052c-0.812,0-1.481-0.447-1.792-1.197s-0.153-1.54,0.42-2.114l3.572-3.571 c0.525-0.525,0.814-1.224,0.814-1.966c0-0.743-0.289-1.441-0.814-1.967l-4.553-4.553c-1.05-1.05-2.881-1.052-3.933,0l-3.571,3.571 c-0.574,0.573-1.366,0.733-2.114,0.421C33.447,9.313,33,8.644,33,7.832V2.78C33,1.247,31.753,0,30.22,0H23.78 C22.247,0,21,1.247,21,2.78v5.052c0,0.812-0.447,1.481-1.197,1.792c-0.748,0.313-1.54,0.152-2.114-0.421l-3.571-3.571 c-1.052-1.052-2.883-1.05-3.933,0l-4.553,4.553c-0.525,0.525-0.814,1.224-0.814,1.967c0,0.742,0.289,1.44,0.814,1.966l3.572,3.571 c0.573,0.574,0.73,1.364,0.42,2.114S8.644,21,7.832,21H2.78C1.247,21,0,22.247,0,23.78v6.439C0,31.753,1.247,33,2.78,33h5.052 c0.812,0,1.481,0.447,1.792,1.197s0.153,1.54-0.42,2.114l-3.572,3.571c-0.525,0.525-0.814,1.224-0.814,1.966 c0,0.743,0.289,1.441,0.814,1.967l4.553,4.553c1.051,1.051,2.881,1.053,3.933,0l3.571-3.572c0.574-0.573,1.363-0.731,2.114-0.42 c0.75,0.311,1.197,0.98,1.197,1.792v5.052c0,1.533,1.247,2.78,2.78,2.78h6.439c1.533,0,2.78-1.247,2.78-2.78v-5.052 c0-0.812,0.447-1.481,1.197-1.792c0.751-0.312,1.54-0.153,2.114,0.42l3.571,3.572c1.052,1.052,2.883,1.05,3.933,0l4.553-4.553 c0.525-0.525,0.814-1.224,0.814-1.967c0-0.742-0.289-1.44-0.814-1.966l-3.572-3.571c-0.573-0.574-0.73-1.364-0.42-2.114 S45.356,33,46.168,33h5.052c1.533,0,2.78-1.247,2.78-2.78V23.78C54,22.247,52.753,21,51.22,21z M52,30.22 C52,30.65,51.65,31,51.22,31h-5.052c-1.624,0-3.019,0.932-3.64,2.432c-0.622,1.5-0.295,3.146,0.854,4.294l3.572,3.571 c0.305,0.305,0.305,0.8,0,1.104l-4.553,4.553c-0.304,0.304-0.799,0.306-1.104,0l-3.571-3.572c-1.149-1.149-2.794-1.474-4.294-0.854 c-1.5,0.621-2.432,2.016-2.432,3.64v5.052C31,51.65,30.65,52,30.22,52H23.78C23.35,52,23,51.65,23,51.22v-5.052 c0-1.624-0.932-3.019-2.432-3.64c-0.503-0.209-1.021-0.311-1.533-0.311c-1.014,0-1.997,0.4-2.761,1.164l-3.571,3.572 c-0.306,0.306-0.801,0.304-1.104,0l-4.553-4.553c-0.305-0.305-0.305-0.8,0-1.104l3.572-3.571c1.148-1.148,1.476-2.794,0.854-4.294 C10.851,31.932,9.456,31,7.832,31H2.78C2.35,31,2,30.65,2,30.22V23.78C2,23.35,2.35,23,2.78,23h5.052 c1.624,0,3.019-0.932,3.64-2.432c0.622-1.5,0.295-3.146-0.854-4.294l-3.572-3.571c-0.305-0.305-0.305-0.8,0-1.104l4.553-4.553 c0.304-0.305,0.799-0.305,1.104,0l3.571,3.571c1.147,1.147,2.792,1.476,4.294,0.854C22.068,10.851,23,9.456,23,7.832V2.78 C23,2.35,23.35,2,23.78,2h6.439C30.65,2,31,2.35,31,2.78v5.052c0,1.624,0.932,3.019,2.432,3.64 c1.502,0.622,3.146,0.294,4.294-0.854l3.571-3.571c0.306-0.305,0.801-0.305,1.104,0l4.553,4.553c0.305,0.305,0.305,0.8,0,1.104 l-3.572,3.571c-1.148,1.148-1.476,2.794-0.854,4.294c0.621,1.5,2.016,2.432,3.64,2.432h5.052C51.65,23,52,23.35,52,23.78V30.22z" />
    <path d="M27,18c-4.963,0-9,4.037-9,9s4.037,9,9,9s9-4.037,9-9S31.963,18,27,18z M27,34c-3.859,0-7-3.141-7-7s3.141-7,7-7 s7,3.141,7,7S30.859,34,27,34z" />
  </svg>
)

const ArrowUpIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="ArrowUpIcon"
    viewBox="0 0 284.929 284.929"
  >
    <path d="M282.082,195.285L149.028,62.24c-1.901-1.903-4.088-2.856-6.562-2.856s-4.665,0.953-6.567,2.856L2.856,195.285 C0.95,197.191,0,199.378,0,201.853c0,2.474,0.953,4.664,2.856,6.566l14.272,14.271c1.903,1.903,4.093,2.854,6.567,2.854 c2.474,0,4.664-0.951,6.567-2.854l112.204-112.202l112.208,112.209c1.902,1.903,4.093,2.848,6.563,2.848 c2.478,0,4.668-0.951,6.57-2.848l14.274-14.277c1.902-1.902,2.847-4.093,2.847-6.566 C284.929,199.378,283.984,197.188,282.082,195.285z" />
  </svg>
)
const UserIcon = () => (
  <svg id="UserIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
    <path d="M48.014,42.889l-9.553-4.776C37.56,37.662,37,36.756,37,35.748v-3.381c0.229-0.28,0.47-0.599,0.719-0.951	c1.239-1.75,2.232-3.698,2.954-5.799C42.084,24.97,43,23.575,43,22v-4c0-0.963-0.36-1.896-1-2.625v-5.319	c0.056-0.55,0.276-3.824-2.092-6.525C37.854,1.188,34.521,0,30,0s-7.854,1.188-9.908,3.53C17.724,6.231,17.944,9.506,18,10.056	v5.319c-0.64,0.729-1,1.662-1,2.625v4c0,1.217,0.553,2.352,1.497,3.109c0.916,3.627,2.833,6.36,3.503,7.237v3.309	c0,0.968-0.528,1.856-1.377,2.32l-8.921,4.866C8.801,44.424,7,47.458,7,50.762V54c0,4.746,15.045,6,23,6s23-1.254,23-6v-3.043	C53,47.519,51.089,44.427,48.014,42.889z M51,54c0,1.357-7.412,4-21,4S9,55.357,9,54v-3.238c0-2.571,1.402-4.934,3.659-6.164	l8.921-4.866C23.073,38.917,24,37.354,24,35.655v-4.019l-0.233-0.278c-0.024-0.029-2.475-2.994-3.41-7.065l-0.091-0.396l-0.341-0.22	C19.346,23.303,19,22.676,19,22v-4c0-0.561,0.238-1.084,0.67-1.475L20,16.228V10l-0.009-0.131c-0.003-0.027-0.343-2.799,1.605-5.021	C23.253,2.958,26.081,2,30,2c3.905,0,6.727,0.951,8.386,2.828c1.947,2.201,1.625,5.017,1.623,5.041L40,16.228l0.33,0.298	C40.762,16.916,41,17.439,41,18v4c0,0.873-0.572,1.637-1.422,1.899l-0.498,0.153l-0.16,0.495c-0.669,2.081-1.622,4.003-2.834,5.713	c-0.297,0.421-0.586,0.794-0.837,1.079L35,31.623v4.125c0,1.77,0.983,3.361,2.566,4.153l9.553,4.776	C49.513,45.874,51,48.28,51,50.957V54z" />
  </svg>
)

const CameraIcon = () => (
  <svg
    id="CameraIcon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 420.8 420.8"
  >
    <path d="M406.8,96.4c-8.4-8.8-20-14-33.2-14h-66.4v-0.8c0-10-4-19.6-10.8-26c-6.8-6.8-16-10.8-26-10.8h-120 c-10.4,0-19.6,4-26.4,10.8c-6.8,6.8-10.8,16-10.8,26v0.8h-66c-13.2,0-24.8,5.2-33.2,14c-8.4,8.4-14,20.4-14,33.2v199.2 C0,342,5.2,353.6,14,362c8.4,8.4,20.4,14,33.2,14h326.4c13.2,0,24.8-5.2,33.2-14c8.4-8.4,14-20.4,14-33.2V129.6 C420.8,116.4,415.6,104.8,406.8,96.4z M400,328.8h-0.4c0,7.2-2.8,13.6-7.6,18.4s-11.2,7.6-18.4,7.6H47.2 c-7.2,0-13.6-2.8-18.4-7.6c-4.8-4.8-7.6-11.2-7.6-18.4V129.6c0-7.2,2.8-13.6,7.6-18.4s11.2-7.6,18.4-7.6h77.2 c6,0,10.8-4.8,10.8-10.8V81.2c0-4.4,1.6-8.4,4.4-11.2s6.8-4.4,11.2-4.4h119.6c4.4,0,8.4,1.6,11.2,4.4c2.8,2.8,4.4,6.8,4.4,11.2 v11.6c0,6,4.8,10.8,10.8,10.8H374c7.2,0,13.6,2.8,18.4,7.6s7.6,11.2,7.6,18.4V328.8z" />
    <path d="M210.4,130.8c-27.2,0-52,11.2-69.6,28.8c-18,18-28.8,42.4-28.8,69.6s11.2,52,28.8,69.6c18,18,42.4,28.8,69.6,28.8 s52-11.2,69.6-28.8c18-18,28.8-42.4,28.8-69.6s-11.2-52-28.8-69.6C262.4,142,237.6,130.8,210.4,130.8z M264.8,284 c-14,13.6-33.2,22.4-54.4,22.4S170,297.6,156,284c-14-14-22.4-33.2-22.4-54.4c0-21.2,8.8-40.4,22.4-54.4 c14-14,33.2-22.4,54.4-22.4s40.4,8.8,54.4,22.4c14,14,22.4,33.2,22.4,54.4C287.6,250.8,278.8,270,264.8,284z" />
    <circle cx="352.8" cy="150" r="19.6" />
  </svg>
)

const LogOutIcon = () => (
  <svg id="Capa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56">
    <path d="M54.424,28.382c0.101-0.244,0.101-0.519,0-0.764c-0.051-0.123-0.125-0.234-0.217-0.327L42.208,15.293 c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414L51.087,27H20.501c-0.552,0-1,0.447-1,1s0.448,1,1,1h30.586L40.794,39.293 c-0.391,0.391-0.391,1.023,0,1.414C40.989,40.902,41.245,41,41.501,41s0.512-0.098,0.707-0.293l11.999-11.999 C54.299,28.616,54.373,28.505,54.424,28.382z" />
    <path d="M36.501,33c-0.552,0-1,0.447-1,1v20h-32V2h32v20c0,0.553,0.448,1,1,1s1-0.447,1-1V1c0-0.553-0.448-1-1-1h-34 c-0.552,0-1,0.447-1,1v54c0,0.553,0.448,1,1,1h34c0.552,0,1-0.447,1-1V34C37.501,33.447,37.053,33,36.501,33z" />
  </svg>
)

const ClockIcon = () => (
  <svg id="Capa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
    <path d="M30,0C13.458,0,0,13.458,0,30s13.458,30,30,30s30-13.458,30-30S46.542,0,30,0z M30,58C14.561,58,2,45.439,2,30 S14.561,2,30,2s28,12.561,28,28S45.439,58,30,58z" />
    <path d="M30,6c-0.552,0-1,0.447-1,1v23H14c-0.552,0-1,0.447-1,1s0.448,1,1,1h16c0.552,0,1-0.447,1-1V7C31,6.447,30.552,6,30,6z" />
  </svg>
)

const IncreaseArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 129 129"
    enableBackground="new 0 0 129 129"
    width="512px"
    height="512px"
  >
    <g>
      <path
        d="m121.4,61.6l-54-54c-0.7-0.7-1.8-1.2-2.9-1.2s-2.2,0.5-2.9,1.2l-54,54c-1.6,1.6-1.6,4.2 0,5.8 0.8,0.8 1.8,1.2 2.9,1.2s2.1-0.4 2.9-1.2l47-47v98.1c0,2.3 1.8,4.1 4.1,4.1s4.1-1.8 4.1-4.1v-98.1l47,47c1.6,1.6 4.2,1.6 5.8,0s1.5-4.2 1.42109e-14-5.8z"
        fill="#91DC5A"
      />
    </g>
  </svg>
)

const PackageIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 468 468"
    width="468"
    height="468"
  >
    <g id="Layer">
      <g id="Layer">
        <path
          id="Layer"
          className="shp0"
          d="M457.65,128.3v326.9c0,6.6 -5.4,12 -12,12h-424.1c-6.6,0 -12,-5.4 -12,-12v-326.9c0,-2.7 0.9,-5.3 2.6,-7.4l91.7,-116.3c2.3,-2.9 5.7,-4.6 9.4,-4.6h240.8c3.7,0 7.1,1.7 9.4,4.6l91.7,116.3c1.7,2.1 2.6,4.7 2.5,7.4zM348.25,24h-102.6v94.3h176.9zM44.75,118.3h176.9v-94.3h-102.6zM33.55,443.2h400.1v-300.9h-400.1z"
        />
      </g>
    </g>
  </svg>
)

const RobotIcon = () => (
  <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 532 512">
    <path
      className="st0"
      d="M154.9,164.8c-0.1-0.7-0.4-1.4-0.6-2.1c-0.3-0.7-0.6-1.3-1-1.9c-0.4-0.6-0.9-1.2-1.4-1.7 c-0.5-0.5-1.1-1-1.7-1.4c-0.6-0.4-1.2-0.7-1.9-1c-0.7-0.3-1.4-0.5-2.1-0.6c-1.4-0.3-2.9-0.3-4.4,0c-0.7,0.1-1.4,0.4-2.1,0.6 c-0.7,0.3-1.3,0.6-1.9,1c-0.6,0.4-1.2,0.9-1.7,1.4c-0.5,0.5-1,1.1-1.4,1.7c-0.4,0.6-0.7,1.2-1,1.9c-0.3,0.7-0.5,1.4-0.6,2.1 c-0.1,0.7-0.2,1.4-0.2,2.2s0.1,1.5,0.2,2.2s0.4,1.4,0.6,2.1c0.3,0.7,0.6,1.3,1,1.9c0.4,0.6,0.9,1.2,1.4,1.7c0.5,0.5,1.1,1,1.7,1.4 c0.6,0.4,1.3,0.7,1.9,1s1.4,0.5,2.1,0.6c0.7,0.1,1.4,0.2,2.2,0.2c0.7,0,1.5-0.1,2.2-0.2c0.7-0.1,1.4-0.4,2.1-0.6 c0.7-0.3,1.3-0.6,1.9-1c0.6-0.4,1.2-0.9,1.7-1.4c0.5-0.5,1-1.1,1.4-1.7c0.4-0.6,0.7-1.2,1-1.9c0.3-0.7,0.5-1.4,0.6-2.1 s0.2-1.4,0.2-2.2S155,165.5,154.9,164.8z"
    />
    <path
      className="st0"
      d="M520.9,222.6h-43.4V167c0-6.1-5-11.1-11.1-11.1H277.1v-24.2c13-4.6,22.3-17,22.3-31.5 c0-18.4-15-33.4-33.4-33.4s-33.4,15-33.4,33.4c0,14.5,9.3,26.9,22.3,31.5v24.2h-77.2c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1 h277.5v55.7v133.6V453H76.8v-85.7V233.7v-55.7h33.4c6.1,0,11.1-5,11.1-11.1s-5-11.1-11.1-11.1H65.7c-6.1,0-11.1,5-11.1,11.1v55.7 H11.1c-6.1,0-11.1,5-11.1,11.1v133.6c0,6.1,5,11.1,11.1,11.1h43.4v85.7c0,6.1,5,11.1,11.1,11.1h400.7c6.1,0,11.1-5,11.1-11.1 v-85.7h43.4c6.1,0,11.1-5,11.1-11.1V233.7C532,227.6,527,222.6,520.9,222.6z M266,111.3c-6.1,0-11.1-5-11.1-11.1S259.9,89,266,89 c6.1,0,11.1,5,11.1,11.1C277.1,106.3,272.1,111.3,266,111.3z M54.5,356.2H22.3V244.9h32.3V356.2z M509.7,356.2h-32.3V244.9h32.3 V356.2z"
    />
    <rect x="67.1" y="155.8" className="st0" width="223.9" height="22.3" />
    <path
      className="st0"
      d="M177,234.9c-18.4,0-33.4,15-33.4,33.4s15,33.4,33.4,33.4s33.4-15,33.4-33.4 C210.3,249.8,195.4,234.9,177,234.9z M177,279.4c-6.1,0-11.1-5-11.1-11.1s5-11.1,11.1-11.1s11.1,5,11.1,11.1 S183.1,279.4,177,279.4z"
    />
    <path
      className="st0"
      d="M355,234.9c-18.4,0-33.4,15-33.4,33.4s15,33.4,33.4,33.4s33.4-15,33.4-33.4 C388.4,249.8,373.5,234.9,355,234.9z M355,279.4c-6.1,0-11.1-5-11.1-11.1s5-11.1,11.1-11.1s11.1,5,11.1,11.1 S361.2,279.4,355,279.4z"
    />
    <g>
      <path
        className="st0"
        d="M321.7,331.7H210.3c-6.1,0-11.1,5-11.1,11.1c0,36.8,30,66.8,66.8,66.8s66.8-30,66.8-66.8 C332.8,336.6,327.8,331.7,321.7,331.7z M266,387.3c-20.7,0-38.2-14.2-43.1-33.4h86.2C304.2,373.1,286.7,387.3,266,387.3z"
      />
    </g>
  </svg>
)

const CreditCardIcon = () => (
  <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="M469.256,175.503h-52.1v-73.542c0-23.569-19.175-42.744-42.744-42.744H42.744C19.175,59.218,0,78.393,0,101.962v191.786 c0,23.569,19.175,42.744,42.744,42.744h52.102v73.546c0,23.569,19.175,42.744,42.744,42.744h331.666 c23.569,0,42.744-19.175,42.744-42.744V218.247C512,194.678,492.825,175.503,469.256,175.503z M24.425,101.962 c0-10.101,8.218-18.319,18.319-18.319h331.668c10.101,0,18.319,8.218,18.319,18.319v17.051H24.425V101.962z M94.846,218.247 v93.819H42.744c-10.101,0-18.319-8.218-18.319-18.319v-93.743h74.52C96.32,205.54,94.846,211.725,94.846,218.247z M24.425,175.579 v-32.14h368.306v32.064H137.59c-0.826,0-1.644,0.029-2.458,0.076H24.425z M469.256,428.357H137.59 c-10.101,0-18.319-8.218-18.319-18.319V218.247c0-9.597,7.422-17.479,16.824-18.243H404.94c0.451,0,0.894-0.028,1.331-0.076 h62.984c10.101,0,18.319,8.218,18.319,18.319v191.791h0.001C487.575,420.139,479.357,428.357,469.256,428.357z" />
    <path d="M340.211,255.272c-13.892,0-26.666,4.847-36.745,12.924c-10.333-8.324-23.209-12.931-36.829-12.931 c-32.465,0-58.877,26.412-58.877,58.877c0,32.465,26.412,58.877,58.877,58.877c13.621,0,26.496-4.607,36.829-12.929 c10.079,8.077,22.853,12.925,36.745,12.925c32.462,0,58.871-26.41,58.871-58.872C399.082,281.681,372.673,255.272,340.211,255.272 z M287.953,341.201c-6.009,4.758-13.451,7.392-21.317,7.392c-18.997,0.001-34.452-15.454-34.452-34.45 c0-18.997,15.455-34.452,34.452-34.452c7.866,0,15.307,2.635,21.317,7.392c-4.216,8.108-6.613,17.306-6.613,27.058 C281.34,323.894,283.738,333.092,287.953,341.201z M340.211,348.589c-18.993,0-34.445-15.453-34.445-34.447 c0-18.993,15.453-34.445,34.445-34.445c18.993,0,34.445,15.453,34.445,34.445C374.656,333.137,359.204,348.589,340.211,348.589z" />
  </svg>
)

const SadIcon = () => (
  <svg
    id="SadIcon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 65.44 65.44"
  >
    <g id="group-3svg">
      <path
        id="path-1_21_"
        d="M65.44,34.88c0,16.616-13.472,30.086-30.089,30.086 c-16.618,0-30.09-13.47-30.09-30.086S18.733,4.794,35.351,4.794C51.968,4.794,65.44,18.264,65.44,34.88z"
        fill="#edc951"
      />
      <path
        id="path-2_21_"
        d="M45.647,23.775c0,2.01-1.63,3.639-3.64,3.639c-2.01,0-3.64-1.629-3.64-3.639s1.63-3.639,3.64-3.639 C44.017,20.136,45.647,21.765,45.647,23.775z"
      />
      <path
        id="path-3_21_"
        d="M24.717,23.775c0,2.01-1.629,3.639-3.639,3.639c-2.011,0-3.64-1.629-3.64-3.639s1.629-3.639,3.64-3.639 C23.088,20.136,24.717,21.765,24.717,23.775z"
      />
      <path
        id="path-4_21_"
        d="M19.207,50.977c-0.829,0-1.5-0.672-1.5-1.5c0-6.473,5.209-11.739,11.611-11.739h5.055 c6.403,0,11.611,5.237,11.611,11.674c0,0.829-0.671,1.5-1.5,1.5c-0.829,0-1.5-0.671-1.5-1.5c0-4.783-3.863-8.674-8.611-8.674 h-5.055c-4.748,0-8.611,3.92-8.611,8.739C20.707,50.305,20.036,50.977,19.207,50.977z"
      />
      <path
        id="path-5_21_"
        d="M31.589,63.645C14.171,63.645,0,49.476,0,32.059C0,14.643,14.171,0.474,31.589,0.474 c17.419,0,31.59,14.169,31.59,31.585C63.179,49.476,49.008,63.645,31.589,63.645z M31.589,3.474C15.825,3.474,3,16.297,3,32.059 c0,15.763,12.825,28.587,28.589,28.587c15.765,0,28.59-12.824,28.59-28.587C60.179,16.297,47.354,3.474,31.589,3.474z"
      />
    </g>
  </svg>
)

const TickedIcon = () => (
  <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="M504.502,75.496c-9.997-9.998-26.205-9.998-36.204,0L161.594,382.203L43.702,264.311c-9.997-9.998-26.205-9.997-36.204,0 c-9.998,9.997-9.998,26.205,0,36.203l135.994,135.992c9.994,9.997,26.214,9.99,36.204,0L504.502,111.7 C514.5,101.703,514.499,85.494,504.502,75.496z" />
  </svg>
)

const CircularFacebookIcon = () => (
  <svg
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 112.196 112.196"
  >
    <circle cx="56.098" cy="56.098" r="56.098" fill="#3b5998" />
    <path
      d="M70.201,58.294h-10.01v36.672H45.025V58.294h-7.213V45.406h7.213v-8.34 c0-5.964,2.833-15.303,15.301-15.303L71.56,21.81v12.51h-8.151c-1.337,0-3.217,0.668-3.217,3.513v7.585h11.334L70.201,58.294z"
      fill="#fff"
    />
  </svg>
)

const CircularTwitterIcon = () => (
  <svg
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 112.197 112.197"
  >
    <circle cx="56.099" cy="56.098" r="56.098" fill="#55acee" />
    <path
      d="M90.461,40.316c-2.404,1.066-4.99,1.787-7.702,2.109c2.769-1.659,4.894-4.284,5.897-7.417 c-2.591,1.537-5.462,2.652-8.515,3.253c-2.446-2.605-5.931-4.233-9.79-4.233c-7.404,0-13.409,6.005-13.409,13.409 c0,1.051,0.119,2.074,0.349,3.056c-11.144-0.559-21.025-5.897-27.639-14.012c-1.154,1.98-1.816,4.285-1.816,6.742 c0,4.651,2.369,8.757,5.965,11.161c-2.197-0.069-4.266-0.672-6.073-1.679c-0.001,0.057-0.001,0.114-0.001,0.17 c0,6.497,4.624,11.916,10.757,13.147c-1.124,0.308-2.311,0.471-3.532,0.471c-0.866,0-1.705-0.083-2.523-0.239 c1.706,5.326,6.657,9.203,12.526,9.312c-4.59,3.597-10.371,5.74-16.655,5.74c-1.08,0-2.15-0.063-3.197-0.188 c5.931,3.806,12.981,6.025,20.553,6.025c24.664,0,38.152-20.432,38.152-38.153c0-0.581-0.013-1.16-0.039-1.734 C86.391,45.366,88.664,43.005,90.461,40.316L90.461,40.316z"
      fill="#f1f2f2"
    />
  </svg>
)

const CircularLinkedInIcon = () => (
  <svg
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 112.196 112.196"
  >
    <circle cx="56.098" cy="56.097" r="56.098" fill="#007ab9" />
    <path
      d="M89.616,60.611v23.128H76.207V62.161c0-5.418-1.936-9.118-6.791-9.118 c-3.705,0-5.906,2.491-6.878,4.903c-0.353,0.862-0.444,2.059-0.444,3.268v22.524H48.684c0,0,0.18-36.546,0-40.329h13.411v5.715 c-0.027,0.045-0.065,0.089-0.089,0.132h0.089v-0.132c1.782-2.742,4.96-6.662,12.085-6.662 C83.002,42.462,89.616,48.226,89.616,60.611L89.616,60.611z M34.656,23.969c-4.587,0-7.588,3.011-7.588,6.967 c0,3.872,2.914,6.97,7.412,6.97h0.087c4.677,0,7.585-3.098,7.585-6.97C42.063,26.98,39.244,23.969,34.656,23.969L34.656,23.969z M27.865,83.739H41.27V43.409H27.865V83.739z"
      fill="#f1f2f2"
    />
  </svg>
)

const GiftIcon = () => (
  <svg id="Capa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 416.4 352.9">
    <path d="M381.2,76.8h-47.7c0.4-1.4,0.7-3,0.7-4.6c0-1.2,0.1-2.8,0.1-4.7c0.5-15.3,1.5-43.8-12.8-58.6C315.8,3,308.5,0,299.9,0	c-22.3,0-50.6,20.5-61.7,29.3c-4.3,3.4-21,17-29.9,29.5c-9-12.5-25.6-26.1-29.9-29.5C167.2,20.5,138.9,0,116.6,0	c-8.7,0-15.9,3-21.6,8.8C80.7,23.6,81.6,52.1,82.1,67.5c0.1,1.9,0.1,3.6,0.1,4.7c0,1.6,0.2,3.2,0.7,4.6H35.2	c-9.6,0-17.5,7.9-17.5,17.5v43.4c0,9.6,7.9,17.5,17.5,17.5h14.1v184.2c0,7.4,6.1,13.5,13.5,13.5h103.4l84,0.1v-0.1h103.4	c7.4,0,13.5-6.1,13.5-13.5V155.2h14.1c9.6,0,17.5-7.9,17.5-17.5V94.3C398.7,84.6,390.9,76.8,381.2,76.8z M235.2,336.9h-54V91.8h54	V336.9z M105.8,19.2c2.8-2.9,6.2-4.2,10.8-4.2c11.8,0,30.8,9.3,50.8,24.8c19,14.8,30.2,28.4,31.6,32.5c-0.5,0.5-3,2.4-12.6,3.5	c-8.5,1-67.9,1-76.4,0c-10.1-1.1-12.3-3.2-12.7-3.5c0,0,0,0,0,0c0-1.4-0.1-3.2-0.1-5.2C96.7,55.7,95.9,29.5,105.8,19.2z M166.2,337.9H64.3V155.2h101.9V337.9z M166.2,140.2H62.8H35.2v0c-1.4,0-2.5-1.1-2.5-2.5V94.3c0-1.4,1.1-2.5,2.5-2.5h107.2h11.3	h12.4V140.2z M230.1,75.7c-9.6-1.1-12.1-3-12.6-3.5c1.4-4.1,12.6-17.7,31.6-32.5C269,24.3,288,15,299.9,15c4.6,0,8,1.3,10.8,4.2	c9.9,10.2,9,36.5,8.6,47.7c-0.1,2.1-0.1,3.8-0.1,5.2c0,0,0,0,0,0c-0.3,0.4-2.6,2.4-12.7,3.5C298,76.7,238.6,76.7,230.1,75.7z M352.2,337.9H250.2V155.2h101.9V337.9z M383.7,137.7c0,1.4-1.1,2.5-2.5,2.5h-27.6H250.2V91.8h12.4H274h107.2c1.4,0,2.5,1.1,2.5,2.5	V137.7z" />
  </svg>
)

const MoreIcon = () => (
  <svg id="MoreIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
    <path d="M30,16c4.411,0,8-3.589,8-8s-3.589-8-8-8s-8,3.589-8,8S25.589,16,30,16z M30,2c3.309,0,6,2.691,6,6s-2.691,6-6,6 s-6-2.691-6-6S26.691,2,30,2z" />
    <path d="M30,44c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8S34.411,44,30,44z M30,58c-3.309,0-6-2.691-6-6s2.691-6,6-6 s6,2.691,6,6S33.309,58,30,58z" />
    <path d="M30,22c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8S34.411,22,30,22z M30,36c-3.309,0-6-2.691-6-6s2.691-6,6-6 s6,2.691,6,6S33.309,36,30,36z" />
  </svg>
)

const ShoppingCartIcon = () => (
  <svg
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 486.569 486.569"
  >
    <path d="M146.069,320.369h268.1c30.4,0,55.2-24.8,55.2-55.2v-112.8c0-0.1,0-0.3,0-0.4c0-0.3,0-0.5,0-0.8c0-0.2,0-0.4-0.1-0.6 c0-0.2-0.1-0.5-0.1-0.7s-0.1-0.4-0.1-0.6c-0.1-0.2-0.1-0.4-0.2-0.7c-0.1-0.2-0.1-0.4-0.2-0.6c-0.1-0.2-0.1-0.4-0.2-0.6 c-0.1-0.2-0.2-0.4-0.3-0.7c-0.1-0.2-0.2-0.4-0.3-0.5c-0.1-0.2-0.2-0.4-0.3-0.6c-0.1-0.2-0.2-0.3-0.3-0.5c-0.1-0.2-0.3-0.4-0.4-0.6 c-0.1-0.2-0.2-0.3-0.4-0.5c-0.1-0.2-0.3-0.3-0.4-0.5s-0.3-0.3-0.4-0.5s-0.3-0.3-0.4-0.4c-0.2-0.2-0.3-0.3-0.5-0.5 c-0.2-0.1-0.3-0.3-0.5-0.4c-0.2-0.1-0.4-0.3-0.6-0.4c-0.2-0.1-0.3-0.2-0.5-0.3s-0.4-0.2-0.6-0.4c-0.2-0.1-0.4-0.2-0.6-0.3 s-0.4-0.2-0.6-0.3s-0.4-0.2-0.6-0.3s-0.4-0.1-0.6-0.2c-0.2-0.1-0.5-0.2-0.7-0.2s-0.4-0.1-0.5-0.1c-0.3-0.1-0.5-0.1-0.8-0.1 c-0.1,0-0.2-0.1-0.4-0.1l-339.8-46.9v-47.4c0-0.5,0-1-0.1-1.4c0-0.1,0-0.2-0.1-0.4c0-0.3-0.1-0.6-0.1-0.9c-0.1-0.3-0.1-0.5-0.2-0.8 c0-0.2-0.1-0.3-0.1-0.5c-0.1-0.3-0.2-0.6-0.3-0.9c0-0.1-0.1-0.3-0.1-0.4c-0.1-0.3-0.2-0.5-0.4-0.8c-0.1-0.1-0.1-0.3-0.2-0.4 c-0.1-0.2-0.2-0.4-0.4-0.6c-0.1-0.2-0.2-0.3-0.3-0.5s-0.2-0.3-0.3-0.5s-0.3-0.4-0.4-0.6c-0.1-0.1-0.2-0.2-0.3-0.3 c-0.2-0.2-0.4-0.4-0.6-0.6c-0.1-0.1-0.2-0.2-0.3-0.3c-0.2-0.2-0.4-0.4-0.7-0.6c-0.1-0.1-0.3-0.2-0.4-0.3c-0.2-0.2-0.4-0.3-0.6-0.5 c-0.3-0.2-0.6-0.4-0.8-0.5c-0.1-0.1-0.2-0.1-0.3-0.2c-0.4-0.2-0.9-0.4-1.3-0.6l-73.7-31c-6.9-2.9-14.8,0.3-17.7,7.2 s0.3,14.8,7.2,17.7l65.4,27.6v61.2v9.7v74.4v66.5v84c0,28,21,51.2,48.1,54.7c-4.9,8.2-7.8,17.8-7.8,28c0,30.1,24.5,54.5,54.5,54.5 s54.5-24.5,54.5-54.5c0-10-2.7-19.5-7.5-27.5h121.4c-4.8,8.1-7.5,17.5-7.5,27.5c0,30.1,24.5,54.5,54.5,54.5s54.5-24.5,54.5-54.5 s-24.5-54.5-54.5-54.5h-255c-15.6,0-28.2-12.7-28.2-28.2v-36.6C126.069,317.569,135.769,320.369,146.069,320.369z M213.269,431.969 c0,15.2-12.4,27.5-27.5,27.5s-27.5-12.4-27.5-27.5s12.4-27.5,27.5-27.5S213.269,416.769,213.269,431.969z M428.669,431.969 c0,15.2-12.4,27.5-27.5,27.5s-27.5-12.4-27.5-27.5s12.4-27.5,27.5-27.5S428.669,416.769,428.669,431.969z M414.169,293.369h-268.1 c-15.6,0-28.2-12.7-28.2-28.2v-66.5v-74.4v-5l324.5,44.7v101.1C442.369,280.769,429.669,293.369,414.169,293.369z" />
  </svg>
)

const SearchIcon = () => (
  <svg id="SearchIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 451 451">
    <path d="M447.05,428l-109.6-109.6c29.4-33.8,47.2-77.9,47.2-126.1C384.65,86.2,298.35,0,192.35,0C86.25,0,0.05,86.3,0.05,192.3 s86.3,192.3,192.3,192.3c48.2,0,92.3-17.8,126.1-47.2L428.05,447c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4 C452.25,441.8,452.25,433.2,447.05,428z M26.95,192.3c0-91.2,74.2-165.3,165.3-165.3c91.2,0,165.3,74.2,165.3,165.3 s-74.1,165.4-165.3,165.4C101.15,357.7,26.95,283.5,26.95,192.3z" />
  </svg>
)

const ShoppingBagIcon = () => (
  <svg
    id="ShoppingBagIcon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 489 489"
  >
    <path d="M440.1,422.7l-28-315.3c-0.6-7-6.5-12.3-13.4-12.3h-57.6C340.3,42.5,297.3,0,244.5,0s-95.8,42.5-96.6,95.1H90.3 c-7,0-12.8,5.3-13.4,12.3l-28,315.3c0,0.4-0.1,0.8-0.1,1.2c0,35.9,32.9,65.1,73.4,65.1h244.6c40.5,0,73.4-29.2,73.4-65.1 C440.2,423.5,440.2,423.1,440.1,422.7z M244.5,27c37.9,0,68.8,30.4,69.6,68.1H174.9C175.7,57.4,206.6,27,244.5,27z M366.8,462 H122.2c-25.4,0-46-16.8-46.4-37.5l26.8-302.3h45.2v41c0,7.5,6,13.5,13.5,13.5s13.5-6,13.5-13.5v-41h139.3v41 c0,7.5,6,13.5,13.5,13.5s13.5-6,13.5-13.5v-41h45.2l26.9,302.3C412.8,445.2,392.1,462,366.8,462z" />
  </svg>
)

const SetUpShopIcon = () => (
  <svg
    id="SetupShopIcon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
  >
    <path
      className="st0"
      d="M488.5,448.9H480V226.4c19.3-12.4,32.1-34,32.1-58.6c0-1.3-0.3-2.6-1-3.7L451.5,60 c-4.2-7.3-12-11.9-20.4-11.9H80.9c-8.4,0-16.3,4.5-20.4,11.9L1,164.1c-0.6,1.1-1,2.4-1,3.7c0,24.6,12.8,46.2,32.1,58.6v222.5h-8.5 c-4.1,0-7.5,3.4-7.5,7.5s3.4,7.5,7.5,7.5h464.9c4.1,0,7.5-3.4,7.5-7.5S492.6,448.9,488.5,448.9z M15.5,175.3h24 c4.1,0,7.5-3.4,7.5-7.5s-3.4-7.5-7.5-7.5H20.4l53.1-92.9c1.5-2.7,4.4-4.3,7.4-4.3H431c3.1,0,5.9,1.6,7.4,4.3l53.1,92.9h-19.1 c-4.1,0-7.5,3.4-7.5,7.5s3.4,7.5,7.5,7.5h24c-3.7,26.6-26.5,47.1-54.1,47.1s-50.4-20.5-54.1-47.1h52.1c4.1,0,7.5-3.4,7.5-7.5 s-3.4-7.5-7.5-7.5H71.6c-4.1,0-7.5,3.4-7.5,7.5s3.4,7.5,7.5,7.5h52.1c-3.7,26.6-26.5,47.1-54.1,47.1S19.2,201.9,15.5,175.3z M372.2,175.3c-3.7,26.6-26.5,47.1-54.1,47.1s-50.4-20.5-54.1-47.1L372.2,175.3L372.2,175.3z M248,175.3 c-3.7,26.6-26.5,47.1-54.1,47.1s-50.4-20.5-54.1-47.1L248,175.3L248,175.3z M424.9,448.9h-81.2 M328.7,448.9H47.1V233.7 c7.1,2.4,14.7,3.8,22.6,3.8c27.1,0,50.6-15.6,62.1-38.2c11.5,22.6,35,38.2,62.1,38.2s50.6-15.6,62.1-38.2 c11.5,22.6,35,38.2,62.1,38.2s50.6-15.6,62.1-38.2c11.5,22.6,35,38.2,62.1,38.2c7.9,0,15.5-1.3,22.6-3.8v215.2h-25.1"
    />
    <rect x="15.5" y="160.3" className="st0" width="477.3" height="15" />
  </svg>
)

const ImageIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 336H54a6 6 0 0 1-6-6V118a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v276a6 6 0 0 1-6 6zM128 152c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zM96 352h320v-80l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L192 304l-39.515-39.515c-4.686-4.686-12.284-4.686-16.971 0L96 304v48z" />
  </svg>
)

const DarkTwitterLogo = () => (
  <svg
    id="DarkTwitter"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 612 612"
  >
    <path d="M612,116.258c-22.525,9.981-46.694,16.75-72.088,19.772c25.929-15.527,45.777-40.155,55.184-69.411 c-24.322,14.379-51.169,24.82-79.775,30.48c-22.907-24.437-55.49-39.658-91.63-39.658c-69.334,0-125.551,56.217-125.551,125.513 c0,9.828,1.109,19.427,3.251,28.606C197.065,206.32,104.556,156.337,42.641,80.386c-10.823,18.51-16.98,40.078-16.98,63.101 c0,43.559,22.181,81.993,55.835,104.479c-20.575-0.688-39.926-6.348-56.867-15.756v1.568c0,60.806,43.291,111.554,100.693,123.104 c-10.517,2.83-21.607,4.398-33.08,4.398c-8.107,0-15.947-0.803-23.634-2.333c15.985,49.907,62.336,86.199,117.253,87.194 c-42.947,33.654-97.099,53.655-155.916,53.655c-10.134,0-20.116-0.612-29.944-1.721c55.567,35.681,121.536,56.485,192.438,56.485 c230.948,0,357.188-191.291,357.188-357.188l-0.421-16.253C573.872,163.526,595.211,141.422,612,116.258z" />
  </svg>
)

const DarkLinkedInLogo = () => (
  <svg
    id="DarkLinkedIn"
    xmlns="http://www.w3.org/2000/svg"
    width="430.117"
    height="430.117"
    viewBox="0 0 430.117 430.117"
  >
    <path
      id="LinkedIn"
      d="M430.117,261.543V420.56h-92.188V272.193c0-37.271-13.334-62.707-46.703-62.707 c-25.473,0-40.632,17.142-47.301,33.724c-2.432,5.928-3.058,14.179-3.058,22.477V420.56h-92.219c0,0,1.242-251.285,0-277.32h92.21 v39.309c-0.187,0.294-0.43,0.611-0.606,0.896h0.606v-0.896c12.251-18.869,34.13-45.824,83.102-45.824 C384.633,136.724,430.117,176.361,430.117,261.543z M52.183,9.558C20.635,9.558,0,30.251,0,57.463 c0,26.619,20.038,47.94,50.959,47.94h0.616c32.159,0,52.159-21.317,52.159-47.94C103.128,30.251,83.734,9.558,52.183,9.558z M5.477,420.56h92.184v-277.32H5.477V420.56z"
    />
  </svg>
)

const DarkFbLogo = () => (
  <svg
    id="DarkFB"
    xmlns="http://www.w3.org/2000/svg"
    width="430.113"
    height="430.114"
    viewBox="0 0 430.113 430.114"
  >
    <path
      id="Facebook"
      d="M158.081,83.3c0,10.839,0,59.218,0,59.218h-43.385v72.412h43.385v215.183h89.122V214.936h59.805 c0,0,5.601-34.721,8.316-72.685c-7.784,0-67.784,0-67.784,0s0-42.127,0-49.511c0-7.4,9.717-17.354,19.321-17.354 c9.586,0,29.818,0,48.557,0c0-9.859,0-43.924,0-75.385c-25.016,0-53.476,0-66.021,0C155.878-0.004,158.081,72.48,158.081,83.3z"
    />
  </svg>
)

const DarkIgLogo = () => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    width="169.063"
    height="169.063"
    viewBox="0 0 169.063 169.063"
  >
    <path d="M122.406,0H46.654C20.929,0,0,20.93,0,46.655v75.752c0,25.726,20.929,46.655,46.654,46.655h75.752 c25.727,0,46.656-20.93,46.656-46.655V46.655C169.063,20.93,148.133,0,122.406,0z M154.063,122.407 c0,17.455-14.201,31.655-31.656,31.655H46.654C29.2,154.063,15,139.862,15,122.407V46.655C15,29.201,29.2,15,46.654,15h75.752 c17.455,0,31.656,14.201,31.656,31.655V122.407z" />
    <path d="M84.531,40.97c-24.021,0-43.563,19.542-43.563,43.563c0,24.02,19.542,43.561,43.563,43.561s43.563-19.541,43.563-43.561 C128.094,60.512,108.552,40.97,84.531,40.97z M84.531,113.093c-15.749,0-28.563-12.812-28.563-28.561 c0-15.75,12.813-28.563,28.563-28.563s28.563,12.813,28.563,28.563C113.094,100.281,100.28,113.093,84.531,113.093z" />
    <path d="M129.921,28.251c-2.89,0-5.729,1.17-7.77,3.22c-2.051,2.04-3.23,4.88-3.23,7.78c0,2.891,1.18,5.73,3.23,7.78 c2.04,2.04,4.88,3.22,7.77,3.22c2.9,0,5.73-1.18,7.78-3.22c2.05-2.05,3.22-4.89,3.22-7.78c0-2.9-1.17-5.74-3.22-7.78 C135.661,29.421,132.821,28.251,129.921,28.251z" />
  </svg>
)

const VisaLogo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53 32">
    <defs>
      <image
        id="visa"
        width="55"
        height="33"
        href="data:image/png;base64,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"
      />
    </defs>
    <use href="#visa" transform="translate(-1 -1)" />
  </svg>
)

const PaypalLogo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53 32">
    <defs>
      <image
        id="paypal"
        width="103"
        height="64"
        href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGcAAABACAYAAAAH6Gl3AAAEoklEQVR4Xu2ab2gbZRzHv5e7S66LbadhXSSLWXpJB9UJatU51C32hUPZasfYVCgrKFSxsoEoiMJWdMqGaOuLvlE7BrqB/9aik20i6xQGY/4ZKshsUymaEhh90bRp0zR3Jxdp0uvu0tgk8Fz45WWe33P3fb6f+z733N3DgX7MOsAxq4yEgeAwfBEQHILDsAMMS6PkEByGHWBYGiWH4DDsAMPSKDl2gDM6OvqEw+E4oGnadob1mkrjOG5YVdW+UCg0aDfthfRmkxONRo8LgtDp8XggSRJ4nrfNGBVFQSqVwuTkJDKZTJ8sywdtI34FoZyeGFEUT/t8PltBWT4uHVIsFkM6nY6Ew+HhagCkwxn2er3b3G637ceTTCYRj8cvhkIh203NZuZz0WhUCwQCtk7N4sD09IyPj0OW5apY6GThNDY22j41iwMYGxsjOFY0Z+fSeP3oV5hOzpuWuJwCvA11aLnzNrQ+uAmiWN7FB8EpkLMfLkfxzEsfF5XE9etqMfBuB8LBdUXVF1NEcAq4dOKzyzjSd7YYH7M1G/0enDvZDa5MdwmCU8D6Q++cwanBH4uGoxcODnShucn7v/pYFROcAjY++fwAfv7tb2OFmjHpwUGPi/7Ae/y9Dmy5J0hwljlQ9tXavY8dw1RiLncaLZOCOjtpaTzPi9j91gG8+WgYgqP0uY2SY2F1YiaFlh1HDa3a/DTU+YR1KngRyRdeRM+WBnTdcUvJ6SE4Fhb+8vs/2PfcR4ZWNXkdmpK2NF0NhjG3cyfub5AwtGsjwVniQFmntS/OXMWrbw8ZDFYSEwA0c9N5AbOdz0Jzr8Hta534bk/pD8OUHIvr+1j/t/jw5KUlrRr+g2Py40Wk2tqhbNiQbdwt16I/4qPkVCo5Xa+cwoVLf+YPrypQZuJGw10SlEAQ85EINJeUa3t/263YG64nOJWCE9nTi1h8Knd4tc6NZOtD2SUzeAc0SQJ44QYAHieHn55ugiTQam2pOWW75ywsKNjcegSqmr+/pJubkLrvroJpEDngkx1+POwrzycLuueY2D3y13U83tFvaJmLbMVCwG8KR8/IA+sl9Gz1YrMnP72VOq8RHBMHz1/8A92vfWpomX6qHZrLmfuvLViL/c03Y43ggLzWiVrRUSqLG/oTHBNL+098j94PLuRbOA6J/XsNlV/vCqCloabsQJYekOCY2PvyG6cxdO7XXAtXI2FqX5uh8lpHGPWu8n6/WS6F4FhMa1eujudaYjV1+NKRfx1TL3C41rmpoqnRD05wirC4e3gCn4/m36nd7XHim/bS3wCsdGqCs5JDQBbMlYmZbKUg8HjE70ar/6YiepZWQnBK86+ivasODm2Nquj1suqD06bCVVtX+Y60HbfyHq/6DIsb2Q8LgnCoCjay98iyfHjVbjDWMfcaeGRkZDvP8wc1TTM+OTIm2EwOx3FDiqL0VssG9sUxlv6O3gbw7CqR4DBMjuAQHIYdYFgaJYfgMOwAw9IoOQSHYQcYlkbJITgMO8CwNEoOwWHYAYalUXIIDsMOMCyNkkNwGHaAYWmUHILDsAMMS6PkEByGHWBYGiWH4DDsAMPS/gX1q9BQi+GVrwAAAABJRU5ErkJggg=="
      />
    </defs>
    <use href="#paypal" transform="translate(0 -10)" />
  </svg>
)

const MastercardLogo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53 32">
    <defs>
      <image
        id="mastercard"
        width="54"
        height="33"
        href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAAhCAYAAACSllj+AAAENElEQVRYR92ZX2xTdRTHv7/f/dPb1nZrJ6WrzI3dlixjweC2aBeETbIYwIVJcMGn4YsPJmTERCEmBnwA3ogQfTDGYHzgBY2a6NuiI8agJioRQ2K2Ox1oFTPWVep2197bn7lXO+rm6O/etg/dfT7ne86n59xzz+9XgnX6kCLX1NTUMKV0jDHWX2+shJCJQqFwLh6Pf1jM3QbTNO2Cz+c73NDQAK/XW29cWFxcRCaTwcLCwjlVVY9aAMSqlN/v/yAajdYd0MqEU6mUBTeQSCQmLLCJWCy2qx4rtRLMqlwqlbocj8f7iaZprL29ve6rZQGYpomZmRmoqkrWFZgFNz09XSEYY8hf/hJLlz6GceUbmDd+BSEEZEMTxO1bIe/dDc/TTwKydLcb8lmYU5dg/vIZ2O1rYPocQAWQQBvoxl4I7cOg0WRF3VMRmPHVd8g+/zKMb6/dMwnaHIHv9HEoowdhXH8bxtWzQO7OvX0i3RCTp0HDW10BugbT33gH2bETVkPzBSYEweMtKCRuAmB8PlSC1HcGQuIQn32JlSsw/fULyB55xVGwwM45eDYvohBWkOtqApZXgvIy0o6zEBIj5Q0rATO+vor5vv38lQLg7crC351ZDmu0BmC0BfkTpRI8Q5+AhDu5fZxVjDHM9+wt+06VRqc+E6EDt0CEkvYjBEu9ETCvyJ0ojfRA3re8KZX1cwSWH/8cmcFnyoqWGvh7M/B2Zlf5mDE/8olGR1rynvdBo49w+TgCyz73EvS3LnIJF43CI7+DelcPGCZRLPU1O9ISOkYhJU9x+TgCS3fsgvmjxiVsGQkNBkLDt9a0X+qJgPlLvm9llEnjFnie+pQrviOwWbHV0dCQN+kI7r69ZiLWdCw0KVyJ2kZUhDL6M5c9P1guj1nPZi7RopFHXUBgR3pNn3xHCOZGnyNNZfQngJavMj8YAMcVe1BHcKCKFSMUyuEbXD+EIzCn75gYzqNx6I/qvWOBVngOflF9MMdTkQBNh34DkQurknE1FdUDkHaerz6Ym+/Yfcl5KFv+qs53bPBd0E2PVx8MLjYPIfjvyC/dDV1sHvaoHx4HCK0BGAA3u6Jv+5/wbbt7THG8K4JAfuIiQCTQ5kdrA2apOt7uCezpKLforrZ7sfsYxG1HADMHCHLtwGw4p+cxShB84X4UOmf5z2MAxIdfhPjQGBdMqZGjcb9SnfsEHd0A36ljUJ4dgfHDmzC+P1/2BE2CbZCSZ0BjjzmGshwqArMj/s+dh7392HceXZD3DEAeGQLxlLRQ7g5M7T2YN8fB5q7/c+cBBuJ/ADTSDdq2D0LLoL1CuX0qB3MbuYZ+/7l+W7cXpuv2itvqDE3TTiqKciIUCkGWZQiCUMOGqa601X65XA7pdBq6rr+qqupJK8LyXjA5OdkvCMJRxtj+6oauvRoh5CPTNF+z/owoRvsb2R0gQLTjgCoAAAAASUVORK5CYII="
      />
    </defs>
    <use href="#mastercard" transform="translate(0 -1)" />
  </svg>
)

const BoldIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
    <path d="M304.793 243.891c33.639-18.537 53.657-54.16 53.657-95.693 0-48.236-26.25-87.626-68.626-104.179C265.138 34.01 240.849 32 209.661 32H24c-8.837 0-16 7.163-16 16v33.049c0 8.837 7.163 16 16 16h33.113v318.53H24c-8.837 0-16 7.163-16 16V464c0 8.837 7.163 16 16 16h195.69c24.203 0 44.834-1.289 66.866-7.584C337.52 457.193 376 410.647 376 350.014c0-52.168-26.573-91.684-71.207-106.123zM142.217 100.809h67.444c16.294 0 27.536 2.019 37.525 6.717 15.828 8.479 24.906 26.502 24.906 49.446 0 35.029-20.32 56.79-53.029 56.79h-76.846V100.809zm112.642 305.475c-10.14 4.056-22.677 4.907-31.409 4.907h-81.233V281.943h84.367c39.645 0 63.057 25.38 63.057 63.057.001 28.425-13.66 52.483-34.782 61.284z" />
  </svg>
)

const ItalicIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
    <path d="M204.758 416h-33.849l62.092-320h40.725a16 16 0 0015.704-12.937l6.242-32C297.599 41.184 290.034 32 279.968 32H120.235a16 16 0 00-15.704 12.937l-6.242 32C96.362 86.816 103.927 96 113.993 96h33.846l-62.09 320H46.278a16 16 0 00-15.704 12.935l-6.245 32C22.402 470.815 29.967 480 40.034 480h158.479a16 16 0 0015.704-12.935l6.245-32c1.927-9.88-5.638-19.065-15.704-19.065z" />
  </svg>
)

const LinkIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    enableBackground="new 0 0 482.8 482.8"
    version="1.1"
    viewBox="0 0 482.8 482.8"
    xmlSpace="preserve"
  >
    <path d="M255.2 209.3c-5.3 5.3-5.3 13.8 0 19.1 21.9 21.9 21.9 57.5 0 79.4l-115 115c-21.9 21.9-57.5 21.9-79.4 0l-17.3-17.3c-21.9-21.9-21.9-57.5 0-79.4l115-115c5.3-5.3 5.3-13.8 0-19.1s-13.8-5.3-19.1 0l-115 115C8.7 322.7 0 343.6 0 365.8c0 22.2 8.6 43.1 24.4 58.8l17.3 17.3c16.2 16.2 37.5 24.3 58.8 24.3s42.6-8.1 58.8-24.3l115-115c32.4-32.4 32.4-85.2 0-117.6-5.2-5.3-13.8-5.3-19.1 0z" />
    <path d="M458.5 58.2l-17.3-17.3c-32.4-32.4-85.2-32.4-117.6 0l-115 115c-32.4 32.4-32.4 85.2 0 117.6 5.3 5.3 13.8 5.3 19.1 0s5.3-13.8 0-19.1c-21.9-21.9-21.9-57.5 0-79.4l115-115c21.9-21.9 57.5-21.9 79.4 0l17.3 17.3c21.9 21.9 21.9 57.5 0 79.4l-115 115c-5.3 5.3-5.3 13.8 0 19.1 2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4l115-115c15.7-15.7 24.4-36.6 24.4-58.8 0-22.2-8.6-43.1-24.3-58.8z" />
  </svg>
)

const LineHeightIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    enableBackground="new 0 0 964.6 512"
    version="1.1"
    viewBox="0 0 964.6 512"
    xmlSpace="preserve"
  >
    <path d="M16 32h288c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16h-35.5c-8.8 0-16-7.2-16-16V96h-54.8v320H232c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H88c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h34.3V96H67.5v48c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16zm475.3 4.7l80 80c10 10 3 27.3-11.3 27.3h-48v224h48c15.6 0 20.6 18 11.3 27.3l-80 80c-6.2 6.2-16.4 6.2-22.6 0l-80-80c-10-10-3-27.3 11.3-27.3h48V144h-48c-15.6 0-20.6-18-11.3-27.3l80-80c6.2-6.3 16.4-6.3 22.6 0zM695.6 248.1h249.5c17.3 0 25.9 20.9 13.7 33L834.2 405.9c-7.5 7.5-19.9 7.5-27.4 0L682.1 281.2c-12.3-12.2-3.6-33.1 13.5-33.1z" />
  </svg>
)

const EmojiIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512">
    <path d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm84-143.4c-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.6-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8-10.2-8.4-25.3-7.1-33.8 3.1zM168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z" />
  </svg>
)

const BulletsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="M96 96c0 26.51-21.49 48-48 48S0 122.51 0 96s21.49-48 48-48 48 21.49 48 48zM48 208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm0 160c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm96-236h352c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h352c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h352c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z" />
  </svg>
)

const NumberedListIcons = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="M3.263 139.527c0-7.477 3.917-11.572 11.573-11.572h15.131V88.078c0-5.163.534-10.503.534-10.503h-.356s-1.779 2.67-2.848 3.738c-4.451 4.273-10.504 4.451-15.666-1.068l-5.518-6.231c-5.342-5.341-4.984-11.216.534-16.379l21.72-19.938C32.815 33.602 36.732 32 42.785 32H54.89c7.656 0 11.749 3.916 11.749 11.572v84.384h15.488c7.655 0 11.572 4.094 11.572 11.572v8.901c0 7.477-3.917 11.572-11.572 11.572H14.836c-7.656 0-11.573-4.095-11.573-11.572v-8.902zM2.211 304.591c0-47.278 50.955-56.383 50.955-69.165 0-7.18-5.954-8.755-9.28-8.755-3.153 0-6.479 1.051-9.455 3.852-5.079 4.903-10.507 7.004-16.111 2.451l-8.579-6.829c-5.779-4.553-7.18-9.805-2.803-15.409C13.592 201.981 26.025 192 47.387 192c19.437 0 44.476 10.506 44.476 39.573 0 38.347-46.753 46.402-48.679 56.909h39.049c7.529 0 11.557 4.027 11.557 11.382v8.755c0 7.354-4.028 11.382-11.557 11.382h-67.94c-7.005 0-12.083-4.028-12.083-11.382v-4.028zM5.654 454.61l5.603-9.28c3.853-6.654 9.105-7.004 15.584-3.152 4.903 2.101 9.63 3.152 14.359 3.152 10.155 0 14.358-3.502 14.358-8.23 0-6.654-5.604-9.106-15.934-9.106h-4.728c-5.954 0-9.28-2.101-12.258-7.88l-1.05-1.926c-2.451-4.728-1.226-9.806 2.801-14.884l5.604-7.004c6.829-8.405 12.257-13.483 12.257-13.483v-.35s-4.203 1.051-12.608 1.051H16.685c-7.53 0-11.383-4.028-11.383-11.382v-8.755c0-7.53 3.853-11.382 11.383-11.382h58.484c7.529 0 11.382 4.027 11.382 11.382v3.327c0 5.778-1.401 9.806-5.079 14.183l-17.509 20.137c19.611 5.078 28.716 20.487 28.716 34.845 0 21.363-14.358 44.126-48.503 44.126-16.636 0-28.192-4.728-35.896-9.455-5.779-4.202-6.304-9.805-2.626-15.934zM144 132h352c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h352c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h352c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z" />
  </svg>
)

const UnderlineIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
    <path d="M224.264 388.24c-91.669 0-156.603-51.165-156.603-151.392V64H39.37c-8.837 0-16-7.163-16-16V16c0-8.837 7.163-16 16-16h137.39c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16h-28.813v172.848c0 53.699 28.314 79.444 76.317 79.444 46.966 0 75.796-25.434 75.796-79.965V64h-28.291c-8.837 0-16-7.163-16-16V16c0-8.837 7.163-16 16-16h136.868c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16h-28.291v172.848c0 99.405-64.881 151.392-156.082 151.392zM16 448h416c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16z" />
  </svg>
)

const TextAlignIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    enableBackground="new 0 0 885.6 512"
    version="1.1"
    viewBox="0 0 885.6 512"
    xmlSpace="preserve"
  >
    <path d="M288 44v40c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V44c0-8.8 7.2-16 16-16h256c8.8 0 16 7.2 16 16zM0 172v40c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zm16 312h416c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16zm256-200H16c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h256c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zM617.2 250h249.5c17.3 0 25.9 20.9 13.7 33L755.8 407.8c-7.5 7.5-19.9 7.5-27.4 0L603.7 283.1c-12.3-12.2-3.6-33.1 13.5-33.1z" />
  </svg>
)

const SliderArrow = ({ arrowClass }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 306 306"
    className={arrowClass}
  >
    <path d="M94.35 0L58.65 35.7 175.95 153 58.65 270.3 94.35 306 247.35 153z" />
  </svg>
)

const JustifyAlignIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className="svg-inline--fa fa-align-justify fa-w-14"
    data-icon="align-justify"
    data-prefix="fas"
    viewBox="0 0 448 512"
  >
    <path
      fill="currentColor"
      d="M0 84V44c0-8.837 7.163-16 16-16h416c8.837 0 16 7.163 16 16v40c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16zm16 144h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 256h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0-128h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
    />
  </svg>
)

const LeftAlignIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className="svg-inline--fa fa-align-left fa-w-14"
    data-icon="align-left"
    data-prefix="fas"
    viewBox="0 0 448 512"
  >
    <path
      fill="currentColor"
      d="M288 44v40c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16V44c0-8.837 7.163-16 16-16h256c8.837 0 16 7.163 16 16zM0 172v40c0 8.837 7.163 16 16 16h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16zm16 312h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm256-200H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16h256c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16z"
    />
  </svg>
)

const CenterAlignIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className="svg-inline--fa fa-align-center fa-w-14"
    data-icon="align-center"
    data-prefix="fas"
    viewBox="0 0 448 512"
  >
    <path
      fill="currentColor"
      d="M352 44v40c0 8.837-7.163 16-16 16H112c-8.837 0-16-7.163-16-16V44c0-8.837 7.163-16 16-16h224c8.837 0 16 7.163 16 16zM16 228h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 256h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm320-200H112c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16h224c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16z"
    />
  </svg>
)

const DesktopIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    enableBackground="new 0 0 323.4 300.7"
    version="1.1"
    viewBox="0 0 323.4 300.7"
    xmlSpace="preserve"
  >
    <path d="M323.4 225.1V0H0v225.1h153.7v59.6H101v16h121.4v-16h-52.7v-59.6h153.7zM16 209.1V16h291.4v193.1H16z" />
  </svg>
)

const MobilePhoneIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    enableBackground="new 0 0 34 60"
    version="1.1"
    viewBox="0 0 34 60"
    xmlSpace="preserve"
  >
    <path d="M29.6 0H4.4C2 0 0 2 0 4.4v51.2C0 58 2 60 4.4 60h25.2c2.4 0 4.4-2 4.4-4.4V4.4C34 2 32 0 29.6 0zM2 8h30v38H2V8zm2.4-6h25.2C30.9 2 32 3.1 32 4.4V6H2V4.4C2 3.1 3.1 2 4.4 2zm25.2 56H4.4C3.1 58 2 56.9 2 55.6V48h30v7.6c0 1.3-1.1 2.4-2.4 2.4z" />
    <path d="M17 49c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
  </svg>
)

const HeartIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    enableBackground="new 0 0 471.701 471.701"
    version="1.1"
    viewBox="0 0 471.701 471.701"
    xmlSpace="preserve"
  >
    <path d="M433.601 67.001c-24.7-24.7-57.4-38.2-92.3-38.2s-67.7 13.6-92.4 38.3l-12.9 12.9-13.1-13.1c-24.7-24.7-57.6-38.4-92.5-38.4-34.8 0-67.6 13.6-92.2 38.2-24.7 24.7-38.3 57.5-38.2 92.4 0 34.9 13.7 67.6 38.4 92.3l187.8 187.8c2.6 2.6 6.1 4 9.5 4 3.4 0 6.9-1.3 9.5-3.9l188.2-187.5c24.7-24.7 38.3-57.5 38.3-92.4.1-34.9-13.4-67.7-38.1-92.4zm-19.2 165.7l-178.7 178-178.3-178.3c-19.6-19.6-30.4-45.6-30.4-73.3s10.7-53.7 30.3-73.2c19.5-19.5 45.5-30.3 73.1-30.3 27.7 0 53.8 10.8 73.4 30.4l22.6 22.6c5.3 5.3 13.8 5.3 19.1 0l22.4-22.4c19.6-19.6 45.7-30.4 73.3-30.4 27.6 0 53.6 10.8 73.2 30.3 19.6 19.6 30.3 45.6 30.3 73.3.1 27.7-10.7 53.7-30.3 73.3z" />
  </svg>
)

const MobilePhoneIconSolid = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    enableBackground="new 0 0 27.442 27.442"
    version="1.1"
    viewBox="0 0 27.442 27.442"
    xmlSpace="preserve"
  >
    <path d="M19.494 0H7.948a1.997 1.997 0 00-1.997 1.999v23.446c0 1.102.892 1.997 1.997 1.997h11.546a1.998 1.998 0 001.997-1.997V1.999A1.999 1.999 0 0019.494 0zm-8.622 1.214h5.7c.144 0 .261.215.261.481s-.117.482-.261.482h-5.7c-.145 0-.26-.216-.26-.482s.115-.481.26-.481zm2.85 24.255a1.275 1.275 0 110-2.55 1.275 1.275 0 010 2.55zm6.273-4.369H7.448V3.373h12.547V21.1z" />
  </svg>
)

const EmptyProductsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="0 0 256 256"
    width="512"
    height="512"
  >
    <g>
      <g>
        <path
          fill="#F9BB32"
          d="M230.808,180.837h-91.283c-3.512,0-6.358-2.847-6.358-6.358V92.195c0-3.512,2.847-6.358,6.358-6.358h91.283    c3.512,0,6.358,2.847,6.358,6.358v82.283C237.167,177.99,234.32,180.837,230.808,180.837z"
        />
      </g>
      <g>
        <path
          fill="#DB9C2E"
          d="M161.167,174.479V92.195c0-3.512,2.847-6.358,6.358-6.358h-28c-3.512,0-6.358,2.847-6.358,6.358v82.283    c0,3.512,2.847,6.358,6.358,6.358h28C164.014,180.837,161.167,177.99,161.167,174.479z"
        />
      </g>
      <g>
        <path
          fill="#FFC34C"
          d="M230.193,129.791c-1.104,0-2-0.896-2-2V92.605c0-1.104,0.896-2,2-2s2,0.896,2,2v35.186    C232.193,128.896,231.297,129.791,230.193,129.791z"
        />
      </g>
      <g>
        <path
          fill="#FFDF74"
          d="M201.189,127.788V85.687H173.54v42.101c2.3,0,2.3,4.21,4.6,4.21c2.303,0,2.303-4.21,4.606-4.21    c2.303,0,2.303,4.21,4.606,4.21c2.304,0,2.304-4.21,4.607-4.21c2.307,0,2.307,4.21,4.615,4.21    C198.881,131.998,198.881,127.788,201.189,127.788z"
        />
      </g>
      <g>
        <path
          fill="#FFF4C1"
          d="M196.294,126.67c-1.104,0-2-0.896-2-2V90.379c0-1.104,0.896-2,2-2s2,0.896,2,2v34.291    C198.294,125.774,197.399,126.67,196.294,126.67z"
        />
      </g>
      <g>
        <path
          fill="#A56021"
          d="M230.113,164.558h-21.725c-0.829,0-1.5-0.672-1.5-1.5s0.671-1.5,1.5-1.5h21.725c0.829,0,1.5,0.672,1.5,1.5    S230.941,164.558,230.113,164.558z"
        />
      </g>
      <g>
        <path
          fill="#A56021"
          d="M230.113,171.723h-21.725c-0.829,0-1.5-0.672-1.5-1.5s0.671-1.5,1.5-1.5h21.725c0.829,0,1.5,0.672,1.5,1.5    S230.941,171.723,230.113,171.723z"
        />
      </g>
      <g>
        <path
          fill="#8C4C17"
          d="M156.989,172.474h-18.425c-0.825,0-1.493-0.669-1.493-1.493v-8.68c0-0.825,0.669-1.493,1.493-1.493h18.425    c0.825,0,1.493,0.669,1.493,1.493v8.68C158.482,171.805,157.814,172.474,156.989,172.474z"
        />
      </g>
      <g>
        <rect x="31.61" y="39.355" fill="#FFC34C" width="16" height="156.122" />
      </g>
      <g>
        <path
          fill="#FFA730"
          d="M47.256,195.477v-16h193.894c2.172,0,3.933,1.761,3.933,3.933v8.135c0,2.172-1.761,3.933-3.933,3.933H47.256z    "
        />
      </g>
      <g>
        <path
          fill="#E58D23"
          d="M57.86,225.849L57.86,225.849c-5.661,0-10.25-4.589-10.25-10.25v-16.75h20.5v16.75    C68.11,221.26,63.521,225.849,57.86,225.849z"
        />
      </g>
      <g>
        <path
          fill="#E58D23"
          d="M191.86,225.849L191.86,225.849c-5.661,0-10.25-4.589-10.25-10.25v-16.75h20.5v16.75    C202.11,221.26,197.521,225.849,191.86,225.849z"
        />
      </g>
      <g>
        <path
          fill="#FFB74B"
          d="M10.917,31.355L10.917,31.355c0-4.418,3.582-8,8-8H43.61c2.209,0,4,1.791,4,4v12H18.917    C14.498,39.355,10.917,35.773,10.917,31.355z"
        />
      </g>
      <g>
        <path
          fill="#CCC033"
          d="M145.151,180.47H53.868c-3.512,0-6.358-2.847-6.358-6.358V91.828c0-3.512,2.847-6.358,6.358-6.358h91.283    c3.512,0,6.358,2.847,6.358,6.358v82.283C151.51,177.623,148.663,180.47,145.151,180.47z"
        />
      </g>
      <g>
        <path
          fill="#EACF32"
          d="M144.536,129.424c-1.104,0-2-0.896-2-2V92.238c0-1.104,0.896-2,2-2s2,0.896,2,2v35.186    C146.536,128.528,145.64,129.424,144.536,129.424z"
        />
      </g>
      <g>
        <path
          fill="#FFDF74"
          d="M115.532,127.421V85.32H87.883v42.101c2.3,0,2.3,4.21,4.6,4.21c2.303,0,2.303-4.21,4.606-4.21    c2.303,0,2.303,4.21,4.606,4.21c2.304,0,2.304-4.21,4.607-4.21c2.307,0,2.307,4.21,4.615,4.21    C113.224,131.631,113.224,127.421,115.532,127.421z"
        />
      </g>
      <g>
        <path
          fill="#FFF4C1"
          d="M110.637,126.303c-1.104,0-2-0.896-2-2V90.012c0-1.104,0.896-2,2-2s2,0.896,2,2v34.291    C112.637,125.407,111.742,126.303,110.637,126.303z"
        />
      </g>
      <g>
        <path
          fill="#A56021"
          d="M144.456,164.19h-21.725c-0.829,0-1.5-0.672-1.5-1.5s0.671-1.5,1.5-1.5h21.725c0.829,0,1.5,0.672,1.5,1.5    S145.284,164.19,144.456,164.19z"
        />
      </g>
      <g>
        <path
          fill="#A56021"
          d="M144.456,171.355h-21.725c-0.829,0-1.5-0.672-1.5-1.5s0.671-1.5,1.5-1.5h21.725c0.829,0,1.5,0.672,1.5,1.5    S145.284,171.355,144.456,171.355z"
        />
      </g>
      <g>
        <path
          fill="#FF9079"
          d="M187.409,86.623H66.223c-3.624,0-6.562-2.938-6.562-6.562V14.837c0-3.624,2.938-6.562,6.562-6.562h121.187    c3.624,0,6.562,2.938,6.562,6.562v65.224C193.971,83.685,191.033,86.623,187.409,86.623z"
        />
      </g>
      <g>
        <path
          fill="#FFD59A"
          d="M184.964,44.875c-1.104,0-2-0.896-2-2V13.857c0-1.104,0.896-2,2-2s2,0.896,2,2v29.018    C186.964,43.979,186.069,44.875,184.964,44.875z"
        />
      </g>
      <g>
        <path
          fill="#FFDF74"
          d="M148.437,42.903V8.182H112.73v34.721c2.971,0,2.971,3.472,5.941,3.472c2.974,0,2.974-3.472,5.948-3.472    c2.974,0,2.974,3.472,5.949,3.472c2.975,0,2.975-3.472,5.95-3.472c2.98,0,2.98,3.472,5.96,3.472    C145.457,46.375,145.457,42.903,148.437,42.903z"
        />
      </g>
      <g>
        <path
          fill="#FFF4C1"
          d="M142.116,42.331c-1.104,0-2-0.896-2-2v-28.28c0-1.104,0.896-2,2-2s2,0.896,2,2v28.28    C144.116,41.436,143.221,42.331,142.116,42.331z"
        />
      </g>
      <g>
        <path
          fill="#A56021"
          d="M184.861,73.46h-28.057c-0.829,0-1.5-0.672-1.5-1.5s0.671-1.5,1.5-1.5h28.057c0.829,0,1.5,0.672,1.5,1.5    S185.69,73.46,184.861,73.46z"
        />
      </g>
      <g>
        <path
          fill="#A56021"
          d="M184.861,79.369h-28.057c-0.829,0-1.5-0.672-1.5-1.5s0.671-1.5,1.5-1.5h28.057c0.829,0,1.5,0.672,1.5,1.5    S185.69,79.369,184.861,79.369z"
        />
      </g>
      <g>
        <path
          fill="#BF6C0D"
          d="M55.61,215.599v-16.75h-8v16.75c0,5.661,4.589,10.25,10.25,10.25c1.419,0,2.771-0.289,4-0.81    C58.187,223.481,55.61,219.841,55.61,215.599z"
        />
      </g>
      <g>
        <path
          fill="#BF6C0D"
          d="M189.61,215.599v-16.75h-8v16.75c0,5.661,4.589,10.25,10.25,10.25c1.419,0,2.771-0.289,4-0.81    C192.187,223.481,189.61,219.841,189.61,215.599z"
        />
      </g>
      <g>
        <path
          fill="#A56021"
          d="M31.61,207.246v-11.769h192v11.769c0,2.365-1.918,4.283-4.283,4.283H35.893    C33.528,211.529,31.61,209.611,31.61,207.246z"
        />
      </g>
      <g>
        <circle fill="#BF6C0D" cx="57.86" cy="232.818" r="15" />
      </g>
      <g>
        <circle fill="#BF6C0D" cx="191.86" cy="232.818" r="15" />
      </g>
      <g>
        <path
          fill="#A56021"
          d="M50.86,232.818c0-6.897,4.661-12.691,11-14.444c-1.275-0.353-2.613-0.556-4-0.556c-8.284,0-15,6.716-15,15    s6.716,15,15,15c1.387,0,2.725-0.204,4-0.556C55.521,245.51,50.86,239.715,50.86,232.818z"
        />
      </g>
      <g>
        <path
          fill="#A56021"
          d="M184.86,232.818c0-6.897,4.661-12.691,11-14.444c-1.275-0.353-2.613-0.556-4-0.556c-8.284,0-15,6.716-15,15    s6.716,15,15,15c1.387,0,2.725-0.204,4-0.556C189.521,245.51,184.86,239.715,184.86,232.818z"
        />
      </g>
      <g>
        <circle fill="#FFC34C" cx="57.86" cy="232.818" r="7.8" />
      </g>
      <g>
        <circle fill="#FFC34C" cx="191.86" cy="232.818" r="7.8" />
      </g>
      <g>
        <path
          fill="#DB9C2E"
          d="M56.06,232.818c0-3.238,1.984-6.021,4.8-7.198c-0.924-0.387-1.937-0.602-3-0.602c-4.301,0-7.8,3.5-7.8,7.8    s3.499,7.8,7.8,7.8c1.063,0,2.076-0.215,3-0.602C58.045,238.838,56.06,236.056,56.06,232.818z"
        />
      </g>
      <g>
        <path
          fill="#DB9C2E"
          d="M190.06,232.818c0-3.238,1.984-6.021,4.8-7.198c-0.924-0.387-1.937-0.602-3-0.602c-4.301,0-7.8,3.5-7.8,7.8    s3.499,7.8,7.8,7.8c1.063,0,2.076-0.215,3-0.602C192.045,238.838,190.06,236.056,190.06,232.818z"
        />
      </g>
      <g>
        <path
          fill="#8C4C17"
          d="M59.61,207.246v-11.769h-28v11.769c0,2.366,1.918,4.283,4.283,4.283h28    C61.528,211.529,59.61,209.611,59.61,207.246z"
        />
      </g>
      <g>
        <rect x="47.256" y="179.477" fill="#E58D23" width="28" height="16" />
      </g>
      <g>
        <rect x="31.61" y="39.355" fill="#F9BB32" width="8" height="156.123" />
      </g>
      <g>
        <path
          fill="#FFA730"
          d="M22.917,31.355c0-4.418,3.582-8,8-8h-12c-4.418,0-8,3.582-8,8c0,4.418,3.582,8,8,8h12    C26.498,39.355,22.917,35.773,22.917,31.355z"
        />
      </g>
      <g>
        <circle fill="#FF624B" cx="98.738" cy="23.355" r="9" />
      </g>
      <g>
        <circle fill="#DB9C2E" cx="176.761" cy="167.466" r="9" />
      </g>
      <g>
        <path
          fill="#99AF17"
          d="M75.51,174.111V91.828c0-3.512,2.847-6.358,6.358-6.358h-28c-3.512,0-6.358,2.847-6.358,6.358v82.283    c0,3.512,2.847,6.358,6.358,6.358h28C78.357,180.47,75.51,177.623,75.51,174.111z"
        />
      </g>
      <g>
        <path
          fill="#FF624B"
          d="M87.661,80.061V14.836c0-3.624,2.938-6.562,6.562-6.562h-28c-3.624,0-6.562,2.938-6.562,6.562v65.224    c0,3.624,2.938,6.562,6.562,6.562h28C90.599,86.623,87.661,83.685,87.661,80.061z"
        />
      </g>
      <g>
        <path
          fill="#CCC033"
          d="M71.332,172.106H52.907c-0.825,0-1.493-0.669-1.493-1.493v-8.68c0-0.825,0.669-1.493,1.493-1.493h18.425    c0.825,0,1.493,0.669,1.493,1.493v8.68C72.825,171.438,72.156,172.106,71.332,172.106z"
        />
      </g>
      <g>
        <path
          fill="#FFD59A"
          d="M90.813,79.725h-24.57c-0.851,0-1.541-0.69-1.541-1.541v-6.539c0-0.851,0.69-1.541,1.541-1.541h24.57    c0.851,0,1.541,0.69,1.541,1.541v6.539C92.354,79.035,91.664,79.725,90.813,79.725z"
        />
      </g>
    </g>
  </svg>
)

const EmptyOrdersIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="0 0 256 256"
    width="512"
    height="512"
  >
    <g>
      <g>
        <g>
          <path
            fill="#FFB74B"
            d="M126.442,5.375c-7.687,0-13.919,6.232-13.919,13.919V30.82c0,1.322,1.072,2.393,2.393,2.393h23.052     c1.322,0,2.393-1.071,2.393-2.393V19.294C140.361,11.607,134.129,5.375,126.442,5.375z M126.442,25.073c-4.418,0-8-3.582-8-8     c0-4.418,3.582-8,8-8c4.418,0,8,3.582,8,8C134.442,21.491,130.86,25.073,126.442,25.073z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#BF6C0D"
            d="M198.832,250.625H54.052c-4.203,0-7.61-3.407-7.61-7.61V39.722c0-4.203,3.407-7.61,7.61-7.61h144.781     c4.203,0,7.61,3.407,7.61,7.61v203.293C206.442,247.218,203.035,250.625,198.832,250.625z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#E58D23"
            d="M198.442,245.625c-1.657,0-3-1.343-3-3v-101.43c0-1.657,1.343-3,3-3s3,1.343,3,3v101.43     C201.442,244.282,200.1,245.625,198.442,245.625z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#A56021"
            d="M74.442,243.015V39.722c0-4.203,3.407-7.609,7.61-7.609h-28c-4.203,0-7.61,3.407-7.61,7.609v203.293     c0,4.203,3.407,7.61,7.61,7.61h28C77.849,250.625,74.442,247.218,74.442,243.015z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FFF4C1"
            d="M60.728,230.667V52.07c0-3.152,2.555-5.707,5.707-5.707h120.014c3.152,0,5.707,2.555,5.707,5.707v178.596     c0,3.152-2.555,5.707-5.707,5.707H66.435C63.283,236.374,60.728,233.819,60.728,230.667z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FCE575"
            d="M66.435,46.363c-3.152,0-5.707,2.555-5.707,5.708v178.596c0,3.152,2.555,5.708,5.707,5.708h8.007V46.363     H66.435z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FFC34C"
            d="M89.098,90.18H74.089c-1.91,0-3.458-1.548-3.458-3.458V71.766c0-1.91,1.548-3.458,3.458-3.458h15.009     c1.91,0,3.458,1.548,3.458,3.458v14.956C92.556,88.632,91.008,90.18,89.098,90.18z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#A56021"
            d="M180.759,83.244H103.52c-2.209,0-4-1.791-4-4s1.791-4,4-4h77.239c2.209,0,4,1.791,4,4     S182.968,83.244,180.759,83.244z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FFC34C"
            d="M89.098,150.448H74.089c-1.91,0-3.458-1.548-3.458-3.458v-14.956c0-1.91,1.548-3.458,3.458-3.458h15.009     c1.91,0,3.458,1.548,3.458,3.458v14.956C92.556,148.9,91.008,150.448,89.098,150.448z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#A56021"
            d="M180.759,143.512H103.52c-2.209,0-4-1.791-4-4s1.791-4,4-4h77.239c2.209,0,4,1.791,4,4     S182.968,143.512,180.759,143.512z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FFC34C"
            d="M89.098,182.216H74.089c-1.91,0-3.458-1.548-3.458-3.458v-14.956c0-1.91,1.548-3.458,3.458-3.458h15.009     c1.91,0,3.458,1.548,3.458,3.458v14.956C92.556,180.668,91.008,182.216,89.098,182.216z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#A56021"
            d="M180.759,175.28H103.52c-2.209,0-4-1.791-4-4s1.791-4,4-4h77.239c2.209,0,4,1.791,4,4     S182.968,175.28,180.759,175.28z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FFA730"
            d="M159.438,58.125H93.446c-2.816,0-5.1-2.283-5.1-5.1V32.81c0-2.816,2.283-5.1,5.1-5.1h65.991     c2.816,0,5.1,2.283,5.1,5.1v20.215C164.537,55.842,162.254,58.125,159.438,58.125z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FFB74B"
            d="M74.442,160.344h-0.353c-1.91,0-3.458,1.549-3.458,3.458v14.956c0,1.91,1.548,3.458,3.458,3.458h0.353     V160.344z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FFB74B"
            d="M74.442,128.576h-0.353c-1.91,0-3.458,1.548-3.458,3.458v14.956c0,1.91,1.548,3.458,3.458,3.458h0.353     V128.576z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FFB74B"
            d="M74.442,68.308h-0.353c-1.91,0-3.458,1.549-3.458,3.458v14.956c0,1.91,1.548,3.458,3.458,3.458h0.353V68.308     z"
          />
        </g>
      </g>
      <g>
        <g>
          <g>
            <path
              fill="#A56021"
              d="M180.758,107.244H70.63c-2.209,0-4-1.791-4-4s1.791-4,4-4h110.128c2.209,0,4,1.791,4,4      S182.967,107.244,180.758,107.244z"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <g>
            <path
              fill="#A56021"
              d="M180.758,121.244H70.63c-2.209,0-4-1.791-4-4s1.791-4,4-4h110.128c2.209,0,4,1.791,4,4      S182.967,121.244,180.758,121.244z"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <g>
            <path
              fill="#A56021"
              d="M180.758,199.244H70.63c-2.209,0-4-1.791-4-4s1.791-4,4-4h110.128c2.209,0,4,1.791,4,4      S182.967,199.244,180.758,199.244z"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <g>
            <path
              fill="#A56021"
              d="M180.758,213.244H70.63c-2.209,0-4-1.791-4-4s1.791-4,4-4h110.128c2.209,0,4,1.791,4,4      S182.967,213.244,180.758,213.244z"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#8C4C17"
            d="M74.442,205.244H70.63c-2.209,0-4,1.791-4,4s1.791,4,4,4h3.812V205.244z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#8C4C17"
            d="M74.442,191.244H70.63c-2.209,0-4,1.791-4,4s1.791,4,4,4h3.812V191.244z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#8C4C17"
            d="M74.442,113.244H70.63c-2.209,0-4,1.791-4,4s1.791,4,4,4h3.812V113.244z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#8C4C17"
            d="M74.442,99.244H70.63c-2.209,0-4,1.791-4,4s1.791,4,4,4h3.812V99.244z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#E58D23"
            d="M108.347,53.316V32.52c0-2.656,2.421-4.809,5.408-4.809h-20c-2.987,0-5.408,2.153-5.408,4.809v20.796     c0,2.656,2.421,4.809,5.408,4.809h20C110.768,58.125,108.347,55.972,108.347,53.316z"
          />
        </g>
      </g>
      <g>
        <g>
          <circle fill="#E58D23" cx="120.381" cy="46.363" r="9" />
        </g>
      </g>
      <g>
        <g>
          <circle fill="#FCE575" cx="88.347" cy="224.368" r="9" />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FFC34C"
            d="M201.216,75.893l-6.788-6.788l7.016-7.016c1.767-1.767,4.633-1.767,6.4,0l0.388,0.388     c1.767,1.767,1.767,4.633,0,6.4L201.216,75.893z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FFB74B"
            d="M209.41,66.003c0.092-1.336-0.352-2.7-1.371-3.72c-1.875-1.875-4.919-1.869-6.8,0.011l-6.811,6.811     l5.091,5.091l6.811-6.811C207.188,66.527,208.289,66.08,209.41,66.003z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FFD551"
            d="M111.708,170.493l-11.879-11.879l91.95-91.95c0.939-0.939,2.461-0.939,3.4,0l8.48,8.48     c0.939,0.939,0.939,2.461,0,3.4L111.708,170.493z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FCE575"
            d="M99.828,158.613l11.879,11.879l-15.577,5.215c-0.938,0.314-1.832-0.579-1.518-1.518L99.828,158.613z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FFC34C"
            d="M200.267,71.751l-5.091-5.091c-0.937-0.937-2.459-0.935-3.4,0.006l-91.948,91.948l5.091,5.091     l91.948-91.947C197.808,70.817,199.33,70.814,200.267,71.751z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#CCC033"
            d="M186.451,95.75L169.48,78.779l6.893-6.893c0.895-0.895,2.346-0.895,3.242,0l15.35,15.35L186.451,95.75z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#99AF17"
            d="M134.119,117.825l-0.715-0.715c-0.623-0.623-0.623-1.632,0-2.255l42.999-42.999     c0.878-0.878,2.302-0.878,3.18,0l1.38,1.38l-44.589,44.589C135.752,118.447,134.742,118.447,134.119,117.825z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#99AF17"
            d="M189.873,82.145l-10.394-10.394c-0.82-0.82-2.247-0.723-3.188,0.218l-6.811,6.811l10.394,10.394l6.811-6.811     C187.626,81.422,189.053,81.325,189.873,82.145z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FFD551"
            d="M105.01,163.795l-5.182-5.182l-5.216,15.577c-0.314,0.938,0.579,1.832,1.518,1.518l5.508-1.844     L105.01,163.795z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#CCC033"
            d="M82.052,178.772c-0.017,0-0.032,0-0.049,0c-0.997-0.016-1.921-0.527-2.465-1.363l-6.118-9.397     c-0.904-1.389-0.512-3.247,0.877-4.151c1.388-0.904,3.248-0.511,4.15,0.877l3.691,5.669l9.95-14.25     c0.949-1.358,2.818-1.692,4.178-0.742c1.358,0.948,1.69,2.818,0.742,4.177L84.512,177.49     C83.95,178.294,83.031,178.772,82.052,178.772z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#CCC033"
            d="M82.052,146.772c-0.017,0-0.032,0-0.049,0c-0.997-0.016-1.921-0.527-2.465-1.363l-6.118-9.397     c-0.904-1.389-0.512-3.247,0.877-4.151c1.388-0.905,3.248-0.511,4.15,0.877l3.691,5.669l9.95-14.25     c0.949-1.358,2.818-1.692,4.178-0.742c1.358,0.948,1.69,2.818,0.742,4.177L84.512,145.49     C83.95,146.294,83.031,146.772,82.052,146.772z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#CCC033"
            d="M82.052,86.772c-0.017,0-0.032,0-0.049,0c-0.997-0.016-1.921-0.527-2.465-1.363l-6.118-9.397     c-0.904-1.389-0.512-3.247,0.877-4.151c1.388-0.905,3.248-0.511,4.15,0.877l3.691,5.669l9.95-14.25     c0.949-1.358,2.818-1.692,4.178-0.742c1.358,0.948,1.69,2.818,0.742,4.177L84.512,85.49     C83.95,86.294,83.031,86.772,82.052,86.772z"
          />
        </g>
      </g>
    </g>
  </svg>
)

const EmptyCustomersIcon = () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
  >
    <g>
      <g>
        <g>
          <path
            fill="#CCC033"
            d="M498,493H304.5l0,0c0-46.8,37.9-84.7,84.7-84.7h24.1C460.1,408.3,498,446.3,498,493L498,493z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#EACF32"
            d="M484.5,489.5c-3.3,0-6-2.7-6-6c0-19.7-12.1-27.7-12.2-27.8c-2.8-1.8-3.6-5.5-1.8-8.3
          c1.8-2.8,5.5-3.6,8.3-1.8c0.7,0.5,17.8,11.7,17.8,37.9C490.5,486.9,487.8,489.5,484.5,489.5z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#99AF17"
            d="M413.3,408.3h-24.1c-21,0-40.2,7.7-55,20.4c-0.1,0.1-0.1,0.1-0.2,0.2c-2,1.8-4,3.6-5.9,5.6
          c-0.2,0.2-0.3,0.3-0.5,0.5c-1.7,1.8-3.4,3.7-4.9,5.7c-0.2,0.3-0.4,0.6-0.7,0.8c-0.4,0.6-0.9,1.2-1.3,1.8c-0.3,0.3-0.5,0.7-0.7,1
          c-0.7,0.9-1.3,1.9-1.9,2.8c-0.3,0.5-0.6,0.9-0.9,1.4c-0.3,0.5-0.6,1.1-1,1.6c-0.3,0.5-0.6,1-0.9,1.5c-0.3,0.5-0.6,1-0.8,1.5
          c-0.5,0.9-1,1.9-1.4,2.8c-0.2,0.5-0.4,0.9-0.6,1.4c-0.3,0.7-0.6,1.3-0.9,2c-0.2,0.5-0.4,0.9-0.6,1.4c-0.4,1-0.8,2-1.2,3
          c-0.1,0.3-0.2,0.7-0.4,1c-0.3,0.9-0.6,1.7-0.9,2.6c-0.1,0.4-0.3,0.8-0.4,1.2c-0.3,0.9-0.5,1.8-0.8,2.8c-0.1,0.3-0.1,0.5-0.2,0.8
          c-0.3,1.2-0.6,2.3-0.8,3.5c-0.1,0.4-0.1,0.7-0.2,1.1c-0.2,0.9-0.4,1.9-0.5,2.8c-0.1,0.3-0.1,0.7-0.2,1c-0.2,1.2-0.3,2.5-0.5,3.7
          c0,0.3,0,0.5-0.1,0.8c-0.1,1-0.2,2.1-0.2,3.1c0,0.4,0,0.7-0.1,1.1c-0.1,1.3-0.1,2.6-0.1,3.9h41.4h37.3V489
          c0-15.8-3.9-30.7-10.7-43.8c15-13.6,34.9-21.9,56.8-21.9h24.1c3,0,5.9,0.2,8.7,0.4C448.3,414.1,431.5,408.3,413.3,408.3z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#8C4C17"
            d="M353.3,339.1h16.6V269c0-9.2-7.4-16.6-16.6-16.6l0,0c-9.2,0-16.6,7.4-16.6,16.6v53.4
          C336.7,331.6,344.1,339.1,353.3,339.1z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#8C4C17"
            d="M453.5,252.4H445c-6.8,0-12.4,5.5-12.4,12.4v10.8c13.4,10,22.1,25.9,22.1,43.9V339
          c6.3-0.6,11.1-5.9,11.1-12.3v-61.9C465.8,258,460.3,252.4,453.5,252.4z"
          />
        </g>
      </g>
      <g>
        <g>
          <circle fill="#FFEACF" cx="455.9" cy="324.2" r="17.7" />
        </g>
      </g>
      <g>
        <g>
          <circle fill="#FFD59A" cx="344.5" cy="324.2" r="17.7" />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FFEACF"
            d="M401.3,443.9L401.3,443.9c-14.8,0-26.8-12-26.8-26.8v-64h53.6v64C428.1,431.9,416.1,443.9,401.3,443.9z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FFD59A"
            d="M393,417.1v-64h-18.6v64c0,14.8,12,26.8,26.8,26.8l0,0c3.3,0,6.4-0.6,9.3-1.7
          C400.3,438.5,393,428.7,393,417.1z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FFEACF"
            d="M401.3,387.2L401.3,387.2c-30.2,0-54.7-24.5-54.7-54.7v-27.8c0-30.2,24.5-54.7,54.7-54.7l0,0
          c30.2,0,54.7,24.5,54.7,54.7v27.8C455.9,362.7,431.5,387.2,401.3,387.2z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FFC34C"
            d="M207.5,493H14l0,0c0-46.8,37.9-84.7,84.7-84.7h24.1C169.6,408.3,207.5,446.3,207.5,493L207.5,493z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FFA730"
            d="M128.7,418.3h24.1c3.8,0,7.6,0.3,11.3,0.8c-12.2-6.9-26.3-10.8-41.3-10.8H98.7C51.9,408.3,14,446.3,14,493
          l0,0h30.6C49.5,451,85.3,418.3,128.7,418.3z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FFD59A"
            d="M365.8,325.6v-27.1c0-2.1,0.1-4.1,0.3-6.1c0.3-3.1,3-5.4,6.1-5.4H453c-7.4-21.5-27.7-36.9-51.7-36.9
          c-2.3,0-4.7,0.2-6.9,0.4c0,0,0,0,0,0c-0.2,0-0.3,0.1-0.5,0.1c-0.6,0.1-1.2,0.2-1.7,0.3c-0.3,0-0.6,0.1-0.8,0.2
          c-0.5,0.1-1,0.2-1.5,0.3c-0.3,0.1-0.6,0.1-0.9,0.2c-0.5,0.1-1,0.2-1.5,0.4c-0.3,0.1-0.6,0.1-0.8,0.2c-0.5,0.1-1,0.3-1.5,0.4
          c-0.3,0.1-0.5,0.2-0.8,0.2c-0.6,0.2-1.2,0.4-1.8,0.6c-0.1,0.1-0.3,0.1-0.4,0.2c-0.7,0.3-1.4,0.6-2.1,0.9
          c-0.2,0.1-0.4,0.2-0.5,0.2c-0.5,0.2-1,0.5-1.5,0.7c-0.3,0.1-0.5,0.2-0.8,0.4c-0.4,0.2-0.9,0.4-1.3,0.7c-0.3,0.1-0.5,0.3-0.8,0.4
          c-0.4,0.2-0.8,0.4-1.2,0.7c-0.3,0.2-0.5,0.3-0.8,0.5c-0.4,0.2-0.8,0.5-1.2,0.7c-0.2,0.2-0.5,0.3-0.7,0.5
          c-0.4,0.3-0.9,0.6-1.3,0.9c-0.2,0.1-0.4,0.3-0.6,0.4c-0.6,0.4-1.2,0.9-1.8,1.3c-0.2,0.1-0.4,0.3-0.5,0.4c-0.4,0.3-0.8,0.7-1.2,1
          c-0.2,0.2-0.5,0.4-0.7,0.6c-0.3,0.3-0.7,0.6-1,0.9c-0.2,0.2-0.5,0.5-0.7,0.7c-0.3,0.3-0.6,0.6-0.9,0.9c-0.2,0.2-0.5,0.5-0.7,0.7
          c-0.3,0.3-0.6,0.6-0.9,0.9c-0.2,0.2-0.5,0.5-0.7,0.8c-0.3,0.3-0.6,0.7-0.9,1c-0.2,0.2-0.4,0.5-0.6,0.7c-0.4,0.5-0.8,1-1.2,1.6
          c-0.2,0.3-0.4,0.6-0.6,0.8c-0.3,0.4-0.6,0.8-0.8,1.2c-0.2,0.3-0.4,0.6-0.6,0.9c-0.2,0.3-0.4,0.7-0.7,1c-0.2,0.3-0.4,0.6-0.6,0.9
          c-0.2,0.3-0.4,0.7-0.6,1c-0.2,0.3-0.4,0.6-0.5,1c-0.2,0.3-0.4,0.7-0.5,1c-0.2,0.3-0.3,0.7-0.5,1c-0.2,0.4-0.3,0.7-0.5,1.1
          c-0.1,0.3-0.3,0.6-0.4,1c-0.2,0.4-0.4,0.9-0.6,1.3c-0.2,0.5-0.4,1-0.6,1.5c-0.2,0.4-0.3,0.8-0.4,1.2h0c-1.9,5.6-3,11.5-3,17.8
          v27.2c0,30.1,24,55,54.1,55.3c9.7,0.1,18.8-2.3,26.7-6.6c-2.4,0.3-4.8,0.5-7.3,0.4C389.9,380.8,365.8,355.8,365.8,325.6z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#8C4C17"
            d="M62.8,339.1h16.6V269c0-9.2-7.4-16.6-16.6-16.6l0,0c-9.2,0-16.6,7.4-16.6,16.6v53.4
          C46.2,331.6,53.6,339.1,62.8,339.1z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#8C4C17"
            d="M162.9,252.4h-8.5c-6.8,0-12.4,5.5-12.4,12.4v10.8c13.4,10,22.1,25.9,22.1,43.9V339
          c6.3-0.6,11.1-5.9,11.1-12.3v-61.9C175.3,258,169.8,252.4,162.9,252.4z"
          />
        </g>
      </g>
      <g>
        <g>
          <circle fill="#FFEACF" cx="165.4" cy="324.2" r="17.7" />
        </g>
      </g>
      <g>
        <g>
          <circle fill="#FFD59A" cx="54" cy="324.2" r="17.7" />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FFEACF"
            d="M110.7,443.9L110.7,443.9c-14.8,0-26.8-12-26.8-26.8v-64h53.6v64C137.6,431.9,125.6,443.9,110.7,443.9z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FFD59A"
            d="M102.5,417.1v-64H83.9v64c0,14.8,12,26.8,26.8,26.8l0,0c3.3,0,6.4-0.6,9.3-1.7
          C109.8,438.5,102.5,428.7,102.5,417.1z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FFEACF"
            d="M110.7,387.2L110.7,387.2c-30.2,0-54.7-24.5-54.7-54.7v-27.8c0-30.2,24.5-54.7,54.7-54.7l0,0
          c30.2,0,54.7,24.5,54.7,54.7v27.8C165.4,362.7,140.9,387.2,110.7,387.2z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FFD59A"
            d="M75.2,325.6v-27.1c0-2.1,0.1-4.1,0.3-6.1c0.3-3.1,3-5.4,6.1-5.4h80.7c-7.4-21.5-27.7-36.9-51.7-36.9
          c-2.3,0-4.7,0.2-6.9,0.4c0,0,0,0,0,0c-0.2,0-0.3,0.1-0.5,0.1c-0.6,0.1-1.2,0.2-1.7,0.3c-0.3,0-0.6,0.1-0.8,0.2
          c-0.5,0.1-1,0.2-1.5,0.3c-0.3,0.1-0.6,0.1-0.9,0.2c-0.5,0.1-1,0.2-1.5,0.4c-0.3,0.1-0.6,0.1-0.8,0.2c-0.5,0.1-1,0.3-1.5,0.4
          c-0.3,0.1-0.5,0.2-0.8,0.2c-0.6,0.2-1.2,0.4-1.8,0.6c-0.1,0.1-0.3,0.1-0.4,0.2c-0.7,0.3-1.4,0.6-2.1,0.9
          c-0.2,0.1-0.4,0.2-0.6,0.2c-0.5,0.2-1,0.5-1.5,0.7c-0.3,0.1-0.5,0.2-0.8,0.4c-0.4,0.2-0.9,0.4-1.3,0.7c-0.3,0.1-0.5,0.3-0.8,0.4
          c-0.4,0.2-0.8,0.4-1.2,0.7c-0.3,0.2-0.5,0.3-0.8,0.5c-0.4,0.2-0.8,0.5-1.2,0.7c-0.2,0.2-0.5,0.3-0.7,0.5
          c-0.4,0.3-0.9,0.6-1.3,0.9c-0.2,0.1-0.4,0.3-0.6,0.4c-0.6,0.4-1.2,0.9-1.8,1.3c-0.2,0.1-0.4,0.3-0.5,0.4c-0.4,0.3-0.8,0.7-1.2,1
          c-0.2,0.2-0.5,0.4-0.7,0.6c-0.3,0.3-0.7,0.6-1,0.9c-0.2,0.2-0.5,0.5-0.7,0.7c-0.3,0.3-0.6,0.6-0.9,0.9c-0.2,0.2-0.5,0.5-0.7,0.7
          c-0.3,0.3-0.6,0.6-0.9,0.9c-0.2,0.2-0.5,0.5-0.7,0.8c-0.3,0.3-0.6,0.7-0.9,1c-0.2,0.2-0.4,0.5-0.6,0.7c-0.4,0.5-0.8,1-1.2,1.6
          c-0.2,0.3-0.4,0.6-0.6,0.8c-0.3,0.4-0.6,0.8-0.8,1.2c-0.2,0.3-0.4,0.6-0.6,0.9c-0.2,0.3-0.4,0.7-0.7,1c-0.2,0.3-0.4,0.6-0.6,0.9
          c-0.2,0.3-0.4,0.7-0.6,1c-0.2,0.3-0.4,0.6-0.5,1c-0.2,0.3-0.4,0.7-0.5,1c-0.2,0.3-0.3,0.7-0.5,1c-0.2,0.4-0.3,0.7-0.5,1.1
          c-0.2,0.3-0.3,0.6-0.4,1c-0.2,0.4-0.4,0.9-0.6,1.3c-0.2,0.5-0.4,1-0.6,1.5c-0.2,0.4-0.3,0.8-0.4,1.2h0c-1.9,5.6-3,11.5-3,17.8
          v27.2c0,30.1,24,55,54.1,55.3c9.7,0.1,18.8-2.3,26.7-6.6c-2.4,0.3-4.8,0.5-7.3,0.4C99.4,380.8,75.2,355.8,75.2,325.6z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#A56021"
            d="M148.5,279.8H70.5c-8,0-14.5-6.5-14.5-14.5l0,0c0-19.3,15.7-35,35-35h36.9c19.3,0,35,15.7,35,35l0,0
          C162.9,273.4,156.5,279.8,148.5,279.8z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#BF6C0D"
            d="M150.6,264.6c-3.2,0-5.8-2.5-6-5.7c-0.1-2.8-1-4.8-2.6-6.2c-3.4-3-9.5-3.3-11.6-3.1
          c-3.3,0.2-6.2-2.2-6.4-5.5c-0.2-3.3,2.2-6.2,5.5-6.4c1.3-0.1,12.6-0.8,20.4,6.1c4.1,3.6,6.4,8.7,6.7,14.7
          c0.1,3.3-2.4,6.1-5.7,6.3C150.7,264.6,150.6,264.6,150.6,264.6z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FFD551"
            d="M199.7,489.5c-0.2,0-0.4,0-0.6,0c-3.3-0.3-5.7-3.3-5.4-6.6c3.2-32.1-9.8-39.6-10-39.7l0.1,0.1l5.2-10.8
          c2.1,1,20.6,11,16.6,51.6C205.3,487.2,202.7,489.5,199.7,489.5z"
          />
        </g>
      </g>
      <g>
        <g>
          <g>
            <circle fill="#A56021" cx="79.8" cy="318.6" r="6.8" />
          </g>
        </g>
        <g>
          <g>
            <circle fill="#A56021" cx="141.7" cy="318.6" r="6.8" />
          </g>
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#8C4C17"
            d="M317,211.6h-9.9c-8,0-14.5,6.5-14.5,14.5v12.6c15.7,11.7,25.8,30.3,25.8,51.3v22.9c7.3-0.7,13-6.9,13-14.4
          v-72.4C331.5,218.1,325,211.6,317,211.6z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FF624B"
            d="M369.1,493H142.7V489c0-52.5,42.5-95,95-95h36.4c52.5,0,95,42.5,95,95V493z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FF9079"
            d="M350.5,489.5c-0.2,0-0.3,0-0.5,0c-3.3-0.3-5.8-3.1-5.5-6.5c2.2-27.8-13-39.9-13.6-40.4
          c-2.6-2-3.1-5.8-1.1-8.4c2-2.6,5.7-3.2,8.4-1.2c0.9,0.6,21.1,16.2,18.3,50.9C356.2,487.2,353.6,489.5,350.5,489.5z"
          />
        </g>
      </g>
      <g style={{ display: "none" }}>
        <g style={{ display: "inline" }}>
          <path
            fill="#FFF4C1"
            d="M461.9,19h-79.2h-64.5H195.9h-75.5H52.1c-12.1,0-22,15.5-22,34.5v48c0,19.1,9.8,34.5,22,34.5h5.5l18.1,32.4
          c1.7,3.1,4.8,3,6.4-0.1L99.9,136h20.4h75.5h36.8l19.7,32.2c2.1,3.4,6.4,3.3,8.4-0.2l18.2-32h39.2h64.5h31.4l17.7,32.3
          c1.7,3.1,4.7,3.1,6.4,0.1l18.1-32.4h5.5c12.1,0,22-15.5,22-34.5v-48C483.8,34.4,474,19,461.9,19z"
          />
        </g>
      </g>
      <g style={{ display: "none" }}>
        <g style={{ display: "inline" }}>
          <g>
            <path
              fill="#FCE575"
              d="M97.7,136h-5.5c-12.1,0-22-15.5-22-34.5v-48c0-19.1,9.8-34.5,22-34.5h-40c-12.1,0-22,15.5-22,34.5v48
            c0,19.1,9.8,34.5,22,34.5h5.5l18.1,32.4c1.7,3.1,4.8,3,6.4-0.1L98.8,138L97.7,136z"
            />
          </g>
        </g>
      </g>
      <g style={{ display: "none" }}>
        <g style={{ display: "inline" }}>
          <path
            fill="#A56021"
            d="M292.6,66.8h-186c-5,0-9-4-9-9l0,0c0-5,4-9,9-9h186c5,0,9,4,9,9l0,0C301.6,62.8,297.6,66.8,292.6,66.8z"
          />
        </g>
      </g>
      <g style={{ display: "none" }}>
        <g style={{ display: "inline" }}>
          <path
            fill="#A56021"
            d="M423.6,102.8h-317c-5,0-9-4-9-9l0,0c0-5,4-9,9-9h317c5,0,9,4,9,9l0,0C432.6,98.8,428.6,102.8,423.6,102.8z"
          />
        </g>
      </g>
      <g style={{ display: "none" }}>
        <g style={{ display: "inline" }}>
          <path
            fill="#FCF9DE"
            d="M465.8,108.8c-3.3,0-6-2.7-6-6V48c0-3.3,2.7-6,6-6s6,2.7,6,6v54.8C471.8,106.1,469.2,108.8,465.8,108.8z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FF4B34"
            d="M277.7,409h36.4c4.2,0,8.4,0.3,12.5,0.8c-15-10-33.1-15.8-52.5-15.8h-36.4c-52.5,0-95,42.5-95,95v4.1h40.6
          C188.8,445.7,229,409,277.7,409z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#8C4C17"
            d="M199.8,313h19.4V231c0-10.7-8.7-19.4-19.4-19.4l0,0c-10.7,0-19.4,8.7-19.4,19.4v62.5
          C180.4,304.3,189.1,313,199.8,313z"
          />
        </g>
      </g>
      <g>
        <g>
          <circle fill="#FFEACF" cx="319.9" cy="295.6" r="20.7" />
        </g>
      </g>
      <g>
        <g>
          <circle fill="#FFD59A" cx="189.5" cy="295.6" r="20.7" />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FFEACF"
            d="M255.9,435.6L255.9,435.6c-17.3,0-31.4-14-31.4-31.4v-74.8h62.7v74.8C287.3,421.6,273.2,435.6,255.9,435.6z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FFD59A"
            d="M246.3,404.2v-74.8h-21.7v74.8c0,17.3,14,31.4,31.4,31.4l0,0c3.8,0,7.5-0.7,10.9-1.9
          C254.8,429.2,246.3,417.7,246.3,404.2z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FFEACF"
            d="M255.9,369.2L255.9,369.2c-35.3,0-64-28.6-64-64v-32.6c0-35.3,28.6-64,64-64l0,0c35.3,0,64,28.6,64,64v32.6
          C319.9,340.6,291.2,369.2,255.9,369.2z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FFD59A"
            d="M214.4,297.2v-31.7c0-2.4,0.1-4.8,0.4-7.2c0.4-3.6,3.5-6.4,7.2-6.4h94.4c-8.6-25.1-32.5-43.2-60.5-43.2
          c-2.7,0-5.4,0.2-8.1,0.5c0,0,0,0,0,0c-0.2,0-0.4,0.1-0.6,0.1c-0.7,0.1-1.3,0.2-2,0.3c-0.3,0.1-0.6,0.1-1,0.2
          c-0.6,0.1-1.2,0.2-1.8,0.3c-0.3,0.1-0.7,0.1-1,0.2c-0.6,0.1-1.1,0.3-1.7,0.4c-0.3,0.1-0.7,0.2-1,0.3c-0.6,0.2-1.2,0.3-1.7,0.5
          c-0.3,0.1-0.6,0.2-0.9,0.3c-0.7,0.2-1.4,0.5-2.1,0.7c-0.2,0.1-0.3,0.1-0.5,0.2c-0.8,0.3-1.7,0.6-2.5,1c-0.2,0.1-0.4,0.2-0.6,0.3
          c-0.6,0.3-1.2,0.5-1.8,0.8c-0.3,0.1-0.6,0.3-0.9,0.4c-0.5,0.2-1,0.5-1.5,0.8c-0.3,0.2-0.6,0.3-0.9,0.5c-0.5,0.3-0.9,0.5-1.4,0.8
          c-0.3,0.2-0.6,0.4-0.9,0.6c-0.5,0.3-0.9,0.6-1.4,0.9c-0.3,0.2-0.6,0.4-0.9,0.6c-0.5,0.3-1,0.7-1.5,1c-0.2,0.2-0.5,0.3-0.7,0.5
          c-0.7,0.5-1.4,1-2.1,1.6c-0.2,0.2-0.4,0.3-0.6,0.5c-0.5,0.4-0.9,0.8-1.4,1.2c-0.3,0.2-0.5,0.5-0.8,0.7c-0.4,0.3-0.8,0.7-1.2,1
          c-0.3,0.3-0.6,0.5-0.9,0.8c-0.4,0.3-0.7,0.7-1.1,1c-0.3,0.3-0.6,0.6-0.8,0.9c-0.3,0.4-0.7,0.7-1,1.1c-0.3,0.3-0.5,0.6-0.8,0.9
          c-0.3,0.4-0.7,0.8-1,1.2c-0.2,0.3-0.5,0.6-0.7,0.8c-0.5,0.6-1,1.2-1.4,1.8c-0.2,0.3-0.5,0.6-0.7,1c-0.3,0.4-0.6,0.9-1,1.4
          c-0.2,0.3-0.4,0.7-0.7,1c-0.3,0.4-0.5,0.8-0.8,1.2c-0.2,0.4-0.4,0.7-0.7,1.1c-0.2,0.4-0.5,0.8-0.7,1.2c-0.2,0.4-0.4,0.8-0.6,1.1
          c-0.2,0.4-0.4,0.8-0.6,1.2c-0.2,0.4-0.4,0.8-0.6,1.2c-0.2,0.4-0.4,0.9-0.6,1.3c-0.2,0.4-0.4,0.8-0.5,1.1c-0.2,0.5-0.4,1-0.7,1.6
          c-0.2,0.6-0.5,1.2-0.7,1.7c-0.2,0.5-0.4,1-0.5,1.4h0c-2.2,6.5-3.5,13.5-3.5,20.8v31.8c0,35.2,28.1,64.4,63.3,64.7
          c11.3,0.1,22-2.7,31.2-7.7c-2.8,0.4-5.6,0.5-8.5,0.5C242.6,361.7,214.4,332.5,214.4,297.2z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#A56021"
            d="M288,243.5h-92.4c-16,0-28.9-13-28.9-28.9l0,0c0-16,13-28.9,28.9-28.9H288c16,0,28.9,13,28.9,28.9l0,0
          C317,230.6,304,243.5,288,243.5z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#BF6C0D"
            d="M304.9,224.7c-3.2,0-5.9-2.5-6-5.8c-0.2-5.5-1.8-9.5-5-12.3c-5.8-5.1-15-4.4-15.1-4.4
          c-3.3,0.3-6.2-2.2-6.5-5.5s2.1-6.2,5.4-6.5c0.6-0.1,14.3-1.2,24,7.3c5.7,5,8.7,12,9.1,20.9c0.1,3.3-2.5,6.1-5.8,6.2
          C305.1,224.7,305,224.7,304.9,224.7z"
          />
        </g>
      </g>
      <g>
        <g>
          <g>
            <circle fill="#A56021" cx="219.7" cy="289" r="8" />
          </g>
        </g>
        <g>
          <g>
            <circle fill="#A56021" cx="292.1" cy="289" r="8" />
          </g>
        </g>
      </g>
      <g>
        <g>
          <g>
            <circle fill="#A56021" cx="370.3" cy="318.6" r="6.8" />
          </g>
        </g>
        <g>
          <g>
            <circle fill="#A56021" cx="432.2" cy="318.6" r="6.8" />
          </g>
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#A56021"
            d="M439,279.8h-77.9c-8,0-14.5-6.5-14.5-14.5l0,0c0-19.3,15.7-35,35-35h36.9c19.3,0,35,15.7,35,35l0,0
          C453.5,273.4,447,279.8,439,279.8z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#BF6C0D"
            d="M441.1,264.6c-3.2,0-5.8-2.5-6-5.7c-0.1-2.8-1-4.8-2.6-6.3c-3.4-3-9.6-3.3-11.5-3.1
          c-3.3,0.3-6.2-2.2-6.5-5.5c-0.3-3.3,2.2-6.2,5.5-6.5c1.3-0.1,12.6-0.8,20.4,6.1c4.1,3.6,6.4,8.7,6.7,14.7
          c0.1,3.3-2.4,6.1-5.7,6.3C441.3,264.6,441.2,264.6,441.1,264.6z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#8C4C17"
            d="M196.6,214.6L196.6,214.6c0-16,13-28.9,28.9-28.9h-30c-16,0-28.9,13-28.9,28.9l0,0c0,16,13,28.9,28.9,28.9
          h30C209.6,243.5,196.6,230.6,196.6,214.6z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#8C4C17"
            d="M366.6,265.4L366.6,265.4c0-19.3,15.7-35,35-35h-20c-19.3,0-35,15.7-35,35l0,0c0,8,6.5,14.5,14.5,14.5h20
          C373.1,279.8,366.6,273.4,366.6,265.4z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#8C4C17"
            d="M79.1,265.4L79.1,265.4c0-19.3,15.7-35,35-35h-23c-19.3,0-35,15.7-35,35l0,0c0,8,6.5,14.5,14.5,14.5h23
          C85.5,279.8,79.1,273.4,79.1,265.4z"
          />
        </g>
      </g>
      <g>
        <g>
          <circle fill="#FFA730" cx="74.2" cy="469.7" r="15.8" />
        </g>
      </g>
      <g>
        <g>
          <circle fill="#FF4B34" cx="214.2" cy="469.7" r="15.8" />
        </g>
      </g>
      <g>
        <g>
          <circle fill="#99AF17" cx="401.6" cy="469.7" r="15.8" />
        </g>
      </g>
      <g style={{ display: "none" }}>
        <g style={{ display: "inline" }}>
          <circle fill="#FCE575" cx="349.9" cy="48.8" r="15.8" />
        </g>
      </g>
    </g>
  </svg>
)

const EmptyPaymentIcon = () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
  >
    <g>
      <g>
        <g>
          <path
            fill="#F9BB32"
            d="M450,434.4H46.2c-15.5,0-28.1-12.6-28.1-28.1V42.5c0-15.5,12.6-28.1,28.1-28.1H450
            c15.5,0,28.1,12.6,28.1,28.1v363.8C478.1,421.8,465.5,434.4,450,434.4z"
          />
        </g>
      </g>
      <g>
        <g>
          <g>
            <path
              fill="#A56021"
              d="M437.8,363.7h-7.7v35.4c0,1.3-1.3,2.3-2.8,2.3h-24.8c-1.5,0-2.8-1-2.8-2.3v-35.4h-7.8
              c-0.9,0-1.4-0.9-0.8-1.4l23.2-20.7c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2l23.2,20.7
              C439.1,362.8,438.7,363.7,437.8,363.7z"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FFC34C"
            d="M462.1,249.4c-3.3,0-6-2.7-6-6v-200c0-3.3,2.7-6,6-6s6,2.7,6,6v200C468.1,246.7,465.4,249.4,462.1,249.4z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#A56021"
            d="M304.6,364.2h-96.1c-4.4,0-8-3.6-8-8s3.6-8,8-8h96.1c4.4,0,8,3.6,8,8S309,364.2,304.6,364.2z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#A56021"
            d="M304.6,395.9h-96.1c-4.4,0-8-3.6-8-8s3.6-8,8-8h96.1c4.4,0,8,3.6,8,8S309,395.9,304.6,395.9z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#A56021"
            d="M123.5,397.4H42c-3.6,0-6.6-3-6.6-6.6v-38.4c0-3.6,3-6.6,6.6-6.6h81.5c3.6,0,6.6,3,6.6,6.6v38.4
            C130.1,394.4,127.1,397.4,123.5,397.4z"
          />
        </g>
      </g>
      <g>
        <g>
          <circle fill="#DB9C2E" cx="110.9" cy="43.4" r="18" />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#DB9C2E"
            d="M74.1,406.3V42.5c0-15.5,12.6-28.1,28.1-28.1h-56c-15.5,0-28.1,12.6-28.1,28.1v363.8
            c0,15.5,12.6,28.1,28.1,28.1h56C86.7,434.4,74.1,421.8,74.1,406.3z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#8C4C17"
            d="M42,345.8c-3.6,0-6.6,3-6.6,6.6v38.4c0,3.6,3,6.6,6.6,6.6h32.1v-51.6H42z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FFDF74"
            d="M314.9,200.5V14.4H192.6v186.1c10.2,0,10.2,18.6,20.3,18.6c10.2,0,10.2-18.6,20.4-18.6
            c10.2,0,10.2,18.6,20.4,18.6c10.2,0,10.2-18.6,20.4-18.6c10.2,0,10.2,18.6,20.4,18.6S304.6,200.5,314.9,200.5z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FFF4C1"
            d="M298.9,196.8c-3.3,0-6-2.7-6-6V30.4c0-3.3,2.7-6,6-6s6,2.7,6,6v160.4C304.9,194.1,302.2,196.8,298.9,196.8z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#CCC033"
            d="M485.8,497.9H202.2c-4.5,0-8.2-3.7-8.2-8.2V346.1c0-4.5,3.7-8.2,8.2-8.2h283.6c4.5,0,8.2,3.7,8.2,8.2v143.6
            C494,494.2,490.3,497.9,485.8,497.9z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#99AF17"
            d="M248,490V345.8c0-4.4,3.6-7.9,7.9-7.9h-56c-4.4,0-7.9,3.6-7.9,7.9V490c0,4.4,3.6,7.9,7.9,7.9h56
            C251.6,497.9,248,494.3,248,490z"
          />
        </g>
      </g>
      <g>
        <g>
          <circle fill="#FCDA4F" cx="344" cy="421.2" r="60" />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#CCC033"
            d="M192,465.3V490c0,4.4,3.6,7.9,7.9,7.9h20.5c0.1-0.9,0.1-1.8,0.1-2.7C220.6,479.2,207.9,466.1,192,465.3z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#EACF32"
            d="M494,465.3c-0.5,0-1-0.1-1.4-0.1c-16.6,0-30,13.4-30,30c0,0.9,0.1,1.8,0.1,2.7h23.4c4.4,0,7.9-3.6,7.9-7.9
            V465.3z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#EACF32"
            d="M486.1,337.9h-23.4c0,0.5-0.1,0.9-0.1,1.3c0,16.6,13.4,30,30,30c0.5,0,1,0,1.4-0.1v-23.3
            C494,341.5,490.4,337.9,486.1,337.9z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#CCC033"
            d="M192,345.8v23.3c15.9-0.8,28.6-13.8,28.6-29.9c0-0.5,0-0.9-0.1-1.3h-20.6C195.6,337.9,192,341.5,192,345.8z"
          />
        </g>
      </g>
      <g>
        <g>
          <circle fill="#99AF17" cx="274" cy="476" r="18" />
        </g>
      </g>
      <path
        fill="#99AF17"
        d="M381.2,401h-6.4c0-0.2,0-0.4-0.1-0.7c-0.5-3.7-6-15.5-22.7-15.5l-23.8-0.2c0,0-7.2-0.7-7.7,6.2V401h-7
        c-2.7,0-5,2.2-5,5c0,2.7,2.2,5,5,5h7v45c0,0,0,6.2,6.2,6.2c0,0,6.5,0.7,6.5-6.3v-22.2c0,0-0.2-5.8,6.2-6.2h10.5
        c0.1,0.1,20.6,0.8,24.5-16.5h6.8c2.7,0,5-2.2,5-5C386.2,403.4,384,401,381.2,401z M339.4,395c0,0,0.1,0,0.1,0c6.3,0,9.9,0,9.9,0
        s0.2,0,0.6,0c1.7,0,8.2,0.3,11,6h-27.8C333.2,400.1,333.6,395,339.4,395z M349.6,417.2c-0.5,0-0.7,0-0.7,0h-9.4c0,0-0.2,0-0.5,0
        c-1.3,0-5.3-0.5-5.8-6.2h28.5C359.4,416.9,351.8,417.3,349.6,417.2z"
      />
    </g>
  </svg>
)

const EmptyTaxIcon = () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
  >
    <g>
      <g>
        <path
          fill="#F9BB32"
          d="M451.1,435.6H47.4c-15.5,0-28.1-12.6-28.1-28.1V43.7c0-15.5,12.6-28.1,28.1-28.1h403.8
        c15.5,0,28.1,12.6,28.1,28.1v363.8C479.2,423,466.7,435.6,451.1,435.6z"
        />
      </g>
      <g>
        <g>
          <path
            fill="#A56021"
            d="M438.9,359.8h-7.7v35.4c0,1.3-1.3,2.3-2.8,2.3h-24.8c-1.5,0-2.8-1-2.8-2.3v-35.4H393c-0.9,0-1.4-0.9-0.8-1.4
          l23.2-20.7c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2l23.2,20.7C440.3,358.9,439.8,359.8,438.9,359.8z"
          />
        </g>
      </g>
      <g>
        <path
          fill="#FFC34C"
          d="M463.2,250.6c-3.3,0-6-2.7-6-6v-200c0-3.3,2.7-6,6-6s6,2.7,6,6v200C469.2,247.9,466.6,250.6,463.2,250.6z"
        />
      </g>
      <g>
        <path
          fill="#A56021"
          d="M305.7,365.4h-96.1c-4.4,0-8-3.6-8-8s3.6-8,8-8h96.1c4.4,0,8,3.6,8,8S310.1,365.4,305.7,365.4z"
        />
      </g>
      <g>
        <path
          fill="#A56021"
          d="M305.7,397.1h-96.1c-4.4,0-8-3.6-8-8s3.6-8,8-8h96.1c4.4,0,8,3.6,8,8S310.1,397.1,305.7,397.1z"
        />
      </g>
      <g>
        <path
          fill="#A56021"
          d="M124.6,398.6H43.1c-3.6,0-6.6-3-6.6-6.6v-38.4c0-3.6,3-6.6,6.6-6.6h81.5c3.6,0,6.6,3,6.6,6.6V392
        C131.2,395.6,128.3,398.6,124.6,398.6z"
        />
      </g>
      <g>
        <circle fill="#DB9C2E" cx="112.1" cy="44.6" r="18" />
      </g>
      <g>
        <path
          fill="#DB9C2E"
          d="M75.2,407.5V43.7c0-15.5,12.6-28.1,28.1-28.1h-56c-15.5,0-28.1,12.6-28.1,28.1v363.8
        c0,15.5,12.6,28.1,28.1,28.1h56C87.8,435.6,75.2,423,75.2,407.5z"
        />
      </g>
      <g>
        <path
          fill="#8C4C17"
          d="M43.1,347c-3.6,0-6.6,3-6.6,6.6V392c0,3.6,3,6.6,6.6,6.6h32.1V347H43.1z"
        />
      </g>
      <g>
        <path
          fill="#FFDF74"
          d="M316,201.7V15.6H193.7v186.1c10.2,0,10.2,18.6,20.3,18.6c10.2,0,10.2-18.6,20.4-18.6
        c10.2,0,10.2,18.6,20.4,18.6c10.2,0,10.2-18.6,20.4-18.6c10.2,0,10.2,18.6,20.4,18.6C305.8,220.3,305.8,201.7,316,201.7z"
        />
      </g>
      <g>
        <path
          fill="#FFF4C1"
          d="M300,198c-3.3,0-6-2.7-6-6V31.6c0-3.3,2.7-6,6-6s6,2.7,6,6V192C306,195.3,303.3,198,300,198z"
        />
      </g>
      <g>
        <ellipse fill="#CCC033" cx="406.9" cy="410.4" rx="85.9" ry="86" />
      </g>
      <g>
        <path
          fill="#99AF17"
          d="M386.1,471.2c-33.5-33.6-33.5-88,0-121.6c11.6-11.7,25.8-19.3,40.7-22.8c-28.1-6.7-58.8,0.9-80.7,22.8
        c-33.5,33.6-33.5,88,0,121.6c21.9,21.9,52.7,29.5,80.7,22.8C412,490.5,397.8,482.9,386.1,471.2z"
        />
      </g>
      <g>
        <path
          fill="#FFDF74"
          d="M406.9,486.4c-20.3,0-39.3-7.9-53.7-22.3c-29.6-29.6-29.6-77.8,0-107.5c14.3-14.4,33.4-22.3,53.7-22.3
        s39.3,7.9,53.7,22.3c29.6,29.6,29.6,77.8,0,107.5C446.2,478.5,427.1,486.4,406.9,486.4z"
        />
      </g>
      <g>
        <path
          fill="#FFD551"
          d="M406.7,334.5c-20.2,0-39.2,7.9-53.5,22.2c-29.6,29.6-29.6,77.8,0,107.5c14.3,14.3,33.3,22.2,53.5,22.2
        c-7.4-3.9-14.3-9-20.6-15.2c-33.5-33.6-33.5-88,0-121.6C392.4,343.4,399.3,338.4,406.7,334.5z"
        />
      </g>
      <path
        fill="#DB9C2E"
        d="M449.6,374.5l-79,79c-1.9,1.9-4.9,1.9-6.8,0l-0.3-0.3c-1.9-1.9-1.9-4.9,0-6.8l79-79c1.9-1.9,4.9-1.9,6.8,0
      l0.3,0.3C451.4,369.6,451.4,372.6,449.6,374.5z"
      />
      <circle
        style={{
          fill: "none",
          stroke: "#DB9C2E",
          strokeWidth: 8,
          strokeMiterLimit: 10
        }}
        cx="380"
        cy="384"
        r="17"
      />
      <circle
        style={{
          fill: "none",
          stroke: "#DB9C2E",
          strokeWidth: 8,
          strokeMiterLimit: 10
        }}
        cx="433"
        cy="434"
        r="17"
      />
    </g>
  </svg>
)

const EmptyCategoriesIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="0 0 256 256"
    width="512"
    height="512"
  >
    <g>
      <g>
        <path
          fill="#F9BB32"
          d="M208.63,45.14h-72.964c-1.657,0-3-1.343-3-3v-28c0-1.657,1.343-3,3-3h72.964c1.657,0,3,1.343,3,3v28    C211.63,43.797,210.287,45.14,208.63,45.14z"
        />
      </g>
      <g>
        <path
          fill="#DB9C2E"
          d="M144.667,42.14v-28c0-1.657,1.343-3,3-3h-12c-1.657,0-3,1.343-3,3v28c0,1.657,1.343,3,3,3h12    C146.01,45.14,144.667,43.797,144.667,42.14z"
        />
      </g>
      <g>
        <path
          fill="#F9BB32"
          d="M207.63,125.14h-70.964c-2.209,0-4-1.791-4-4V81.22c0-2.209,1.791-4,4-4h70.964c2.209,0,4,1.791,4,4v39.92    C211.63,123.349,209.839,125.14,207.63,125.14z"
        />
      </g>
      <g>
        <path
          fill="#DB9C2E"
          d="M144.667,121.14V81.22c0-2.209,1.791-4,4-4h-12c-2.209,0-4,1.791-4,4v39.92c0,2.209,1.791,4,4,4h12    C146.458,125.14,144.667,123.349,144.667,121.14z"
        />
      </g>
      <g>
        <path
          fill="#BF6C0D"
          d="M88.586,205.14H47.414c-1.681,0-3.044-1.363-3.044-3.044v-41.831c0-1.681,1.363-3.044,3.044-3.044h41.172    c1.681,0,3.044,1.363,3.044,3.044v41.831C91.63,203.777,90.267,205.14,88.586,205.14z"
        />
      </g>
      <g>
        <path
          fill="#CCC033"
          d="M148.586,205.14h-41.172c-1.681,0-3.044-1.363-3.044-3.044v-41.831c0-1.681,1.363-3.044,3.044-3.044h41.172    c1.681,0,3.044,1.363,3.044,3.044v41.831C151.63,203.777,150.267,205.14,148.586,205.14z"
        />
      </g>
      <g>
        <path
          fill="#FF9079"
          d="M208.586,205.14h-41.172c-1.681,0-3.044-1.363-3.044-3.044v-41.831c0-1.681,1.363-3.044,3.044-3.044h41.172    c1.681,0,3.044,1.363,3.044,3.044v41.831C211.63,203.777,210.267,205.14,208.586,205.14z"
        />
      </g>
      <g>
        <path
          fill="#8C4C17"
          d="M56.37,202.096v-41.831c0-1.681,1.363-3.044,3.044-3.044h-12c-1.681,0-3.044,1.363-3.044,3.044v41.831    c0,1.681,1.363,3.044,3.044,3.044h12C57.733,205.14,56.37,203.777,56.37,202.096z"
        />
      </g>
      <g>
        <path
          fill="#99AF17"
          d="M116.37,202.096v-41.831c0-1.681,1.363-3.044,3.044-3.044h-12c-1.681,0-3.044,1.363-3.044,3.044v41.831    c0,1.681,1.363,3.044,3.044,3.044h12C117.733,205.14,116.37,203.777,116.37,202.096z"
        />
      </g>
      <g>
        <path
          fill="#FF624B"
          d="M176.37,202.096v-41.831c0-1.681,1.363-3.044,3.044-3.044h-12c-1.681,0-3.044,1.363-3.044,3.044v41.831    c0,1.681,1.363,3.044,3.044,3.044h12C177.733,205.14,176.37,203.777,176.37,202.096z"
        />
      </g>
      <g>
        <rect
          x="119"
          y="94.14"
          transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 342.1403 86.1403)"
          fill="#E58D23"
          width="18"
          height="240"
        />
      </g>
      <g>
        <rect
          x="119"
          y="14.14"
          transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 262.1402 6.1402)"
          fill="#E58D23"
          width="18"
          height="240"
        />
      </g>
      <g>
        <rect
          x="119"
          y="-65.86"
          transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 182.1402 -73.8598)"
          fill="#E58D23"
          width="18"
          height="240"
        />
      </g>
      <g>
        <rect x="8" y="205.14" fill="#BF6C0D" width="52" height="18" />
      </g>
      <g>
        <rect x="8" y="125.14" fill="#BF6C0D" width="52" height="18" />
      </g>
      <g>
        <rect x="8" y="45.14" fill="#BF6C0D" width="52" height="18" />
      </g>
      <g>
        <path
          fill="#BF6C0D"
          d="M29,248H12c-2.209,0-4-1.791-4-4V12c0-2.209,1.791-4,4-4h17c2.209,0,4,1.791,4,4v232    C33,246.209,31.209,248,29,248z"
        />
      </g>
      <g>
        <path
          fill="#BF6C0D"
          d="M244,248h-17c-2.209,0-4-1.791-4-4V12c0-2.209,1.791-4,4-4h17c2.209,0,4,1.791,4,4v232    C248,246.209,246.209,248,244,248z"
        />
      </g>
      <g>
        <path
          fill="#E58D23"
          d="M240,200.979c-1.657,0-3-1.343-3-3v-47.373c0-1.657,1.343-3,3-3s3,1.343,3,3v47.373    C243,199.636,241.657,200.979,240,200.979z"
        />
      </g>
      <g>
        <path
          fill="#FFDF74"
          d="M74.967,178.457V157.22H62.403v21.237c1.045,0,1.045,2.124,2.091,2.124c1.046,0,1.046-2.124,2.093-2.124    c1.047,0,1.047,2.124,2.093,2.124c1.047,0,1.047-2.124,2.094-2.124c1.049,0,1.049,2.124,2.097,2.124    C73.919,180.581,73.919,178.457,74.967,178.457z"
        />
      </g>
      <g>
        <path
          fill="#A56021"
          d="M88.425,197.172h-9.872c-0.553,0-1-0.448-1-1s0.447-1,1-1h9.872c0.553,0,1,0.448,1,1    S88.978,197.172,88.425,197.172z"
        />
      </g>
      <g>
        <path
          fill="#A56021"
          d="M88.425,200.786h-9.872c-0.553,0-1-0.448-1-1s0.447-1,1-1h9.872c0.553,0,1,0.448,1,1    S88.978,200.786,88.425,200.786z"
        />
      </g>
      <g>
        <path
          fill="#BF6C0D"
          d="M55.159,200.922h-8.3c-0.395,0-0.715-0.32-0.715-0.715v-4.455c0-0.395,0.32-0.715,0.715-0.715h8.3    c0.395,0,0.715,0.32,0.715,0.715v4.455C55.874,200.602,55.554,200.922,55.159,200.922z"
        />
      </g>
      <g>
        <path
          fill="#FFDF74"
          d="M135.06,178.457V157.22h-12.565v21.237c1.045,0,1.045,2.124,2.091,2.124c1.046,0,1.046-2.124,2.093-2.124    c1.047,0,1.047,2.124,2.093,2.124c1.047,0,1.047-2.124,2.094-2.124c1.049,0,1.049,2.124,2.097,2.124    C134.011,180.581,134.011,178.457,135.06,178.457z"
        />
      </g>
      <g>
        <path
          fill="#A56021"
          d="M148.425,197.172h-9.872c-0.553,0-1-0.448-1-1s0.447-1,1-1h9.872c0.553,0,1,0.448,1,1    S148.978,197.172,148.425,197.172z"
        />
      </g>
      <g>
        <path
          fill="#A56021"
          d="M148.425,200.786h-9.872c-0.553,0-1-0.448-1-1s0.447-1,1-1h9.872c0.553,0,1,0.448,1,1    S148.978,200.786,148.425,200.786z"
        />
      </g>
      <g>
        <path
          fill="#CCC033"
          d="M115.159,200.922h-8.3c-0.395,0-0.715-0.32-0.715-0.715v-4.455c0-0.395,0.32-0.715,0.715-0.715h8.3    c0.395,0,0.715,0.32,0.715,0.715v4.455C115.874,200.602,115.554,200.922,115.159,200.922z"
        />
      </g>
      <g>
        <path
          fill="#FFDF74"
          d="M196.547,178.457V157.22h-12.565v21.237c1.045,0,1.045,2.124,2.091,2.124c1.046,0,1.046-2.124,2.093-2.124    c1.047,0,1.047,2.124,2.093,2.124c1.047,0,1.047-2.124,2.094-2.124c1.049,0,1.049,2.124,2.097,2.124    S195.498,178.457,196.547,178.457z"
        />
      </g>
      <g>
        <path
          fill="#A56021"
          d="M208.425,197.172h-9.872c-0.553,0-1-0.448-1-1s0.447-1,1-1h9.872c0.553,0,1,0.448,1,1    S208.978,197.172,208.425,197.172z"
        />
      </g>
      <g>
        <path
          fill="#A56021"
          d="M208.425,200.786h-9.872c-0.553,0-1-0.448-1-1s0.447-1,1-1h9.872c0.553,0,1,0.448,1,1    S208.978,200.786,208.425,200.786z"
        />
      </g>
      <g>
        <path
          fill="#FFAB34"
          d="M175.159,200.922h-8.3c-0.395,0-0.715-0.32-0.715-0.715v-4.455c0-0.395,0.32-0.715,0.715-0.715h8.3    c0.395,0,0.715,0.32,0.715,0.715v4.455C175.874,200.602,175.554,200.922,175.159,200.922z"
        />
      </g>
      <g>
        <path
          fill="#CCC033"
          d="M119.695,125.14H48.602c-2.173,0-3.935-1.762-3.935-3.935v-40.05c0-2.173,1.762-3.935,3.935-3.935h71.094    c2.173,0,3.935,1.762,3.935,3.935v40.05C123.63,123.379,121.869,125.14,119.695,125.14z"
        />
      </g>
      <g>
        <path
          fill="#EACF32"
          d="M115.63,109.5c-1.104,0-2-0.896-2-2V85.221c0-1.104,0.896-2,2-2s2,0.896,2,2V107.5    C117.63,108.604,116.734,109.5,115.63,109.5z"
        />
      </g>
      <g>
        <path
          fill="#FFDF74"
          d="M90.431,98.457V77.22H77.866v21.237c1.045,0,1.045,2.124,2.091,2.124c1.046,0,1.046-2.124,2.093-2.124    c1.047,0,1.047,2.124,2.093,2.124c1.047,0,1.047-2.124,2.094-2.124c1.049,0,1.049,2.124,2.097,2.124    C89.382,100.581,89.382,98.457,90.431,98.457z"
        />
      </g>
      <g>
        <path
          fill="#A56021"
          d="M120.425,117.172h-9.872c-0.553,0-1-0.448-1-1s0.447-1,1-1h9.872c0.553,0,1,0.448,1,1    S120.978,117.172,120.425,117.172z"
        />
      </g>
      <g>
        <path
          fill="#A56021"
          d="M120.425,120.786h-9.872c-0.553,0-1-0.448-1-1s0.447-1,1-1h9.872c0.553,0,1,0.448,1,1    S120.978,120.786,120.425,120.786z"
        />
      </g>
      <g>
        <rect x="8" y="205.14" fill="#FFA730" width="25" height="18" />
      </g>
      <g>
        <rect x="8" y="125.14" fill="#FFA730" width="25" height="18" />
      </g>
      <g>
        <rect x="8" y="45.14" fill="#FFA730" width="25" height="18" />
      </g>
      <g>
        <rect x="223" y="45.14" fill="#FFA730" width="25" height="18" />
      </g>
      <g>
        <rect x="223" y="125.14" fill="#FFA730" width="25" height="18" />
      </g>
      <g>
        <rect x="223" y="205.14" fill="#FFA730" width="25" height="18" />
      </g>
      <g>
        <path
          fill="#A56021"
          d="M20,244V12c0-2.209,1.791-4,4-4H12c-2.209,0-4,1.791-4,4v232c0,2.209,1.791,4,4,4h12    C21.791,248,20,246.209,20,244z"
        />
      </g>
      <g>
        <rect x="8" y="205.14" fill="#E58D23" width="12" height="18" />
      </g>
      <g>
        <rect x="8" y="125.14" fill="#E58D23" width="12" height="18" />
      </g>
      <g>
        <rect x="8" y="45.14" fill="#E58D23" width="12" height="18" />
      </g>
      <g>
        <circle fill="#BF6C0D" cx="74.047" cy="214.14" r="9" />
      </g>
      <g>
        <path
          fill="#E58D23"
          d="M240,242.979c-1.657,0-3-1.343-3-3V230c0-1.657,1.343-3,3-3s3,1.343,3,3v9.979    C243,241.636,241.657,242.979,240,242.979z"
        />
      </g>
      <g>
        <path
          fill="#99AF17"
          d="M56.667,121.205v-40.05c0-2.173,1.762-3.935,3.935-3.935h-12c-2.173,0-3.935,1.762-3.935,3.935v40.05    c0,2.173,1.762,3.935,3.935,3.935h12C58.428,125.14,56.667,123.378,56.667,121.205z"
        />
      </g>
      <g>
        <path
          fill="#EACF32"
          d="M62.964,120.922H48.555c-0.51,0-0.924-0.414-0.924-0.924v-4.036c0-0.51,0.414-0.924,0.924-0.924h14.409    c0.51,0,0.924,0.414,0.924,0.924v4.036C63.888,120.508,63.474,120.922,62.964,120.922z"
        />
      </g>
      <g>
        <path
          fill="#CCC033"
          d="M48.555,115.037c-0.51,0-0.924,0.414-0.924,0.924v4.037c0,0.51,0.414,0.924,0.924,0.924h8.112v-5.885H48.555    z"
        />
      </g>
      <g>
        <path
          fill="#FFC34C"
          d="M203.63,109.5c-1.104,0-2-0.896-2-2V85.221c0-1.104,0.896-2,2-2s2,0.896,2,2V107.5    C205.63,108.604,204.734,109.5,203.63,109.5z"
        />
      </g>
      <g>
        <path
          fill="#FFDF74"
          d="M179.601,98.457V77.22h-12.565v21.237c1.045,0,1.045,2.124,2.091,2.124c1.046,0,1.046-2.124,2.093-2.124    c1.047,0,1.047,2.124,2.093,2.124c1.047,0,1.047-2.124,2.094-2.124c1.049,0,1.049,2.124,2.097,2.124    C178.552,100.581,178.552,98.457,179.601,98.457z"
        />
      </g>
      <g>
        <path
          fill="#A56021"
          d="M150.964,120.922h-14.409c-0.51,0-0.924-0.414-0.924-0.924v-4.036c0-0.51,0.414-0.924,0.924-0.924h14.409    c0.51,0,0.924,0.414,0.924,0.924v4.036C151.888,120.508,151.474,120.922,150.964,120.922z"
        />
      </g>
      <g>
        <path
          fill="#8C4C17"
          d="M136.555,115.037c-0.51,0-0.924,0.414-0.924,0.924v4.037c0,0.51,0.414,0.924,0.924,0.924h8.112v-5.885    H136.555z"
        />
      </g>
      <g>
        <path
          fill="#FFF4C1"
          d="M176.499,96.757c-0.553,0-1-0.448-1-1V84.299c0-0.552,0.447-1,1-1s1,0.448,1,1v11.458    C177.499,96.309,177.052,96.757,176.499,96.757z"
        />
      </g>
      <g>
        <path
          fill="#FFF4C1"
          d="M88.499,96.757c-0.553,0-1-0.448-1-1V84.299c0-0.552,0.447-1,1-1s1,0.448,1,1v11.458    C89.499,96.309,89.052,96.757,88.499,96.757z"
        />
      </g>
      <g>
        <path
          fill="#FFF4C1"
          d="M72.499,174.757c-0.553,0-1-0.448-1-1v-11.458c0-0.552,0.447-1,1-1s1,0.448,1,1v11.458    C73.499,174.309,73.052,174.757,72.499,174.757z"
        />
      </g>
      <g>
        <path
          fill="#FFF4C1"
          d="M132.499,174.757c-0.553,0-1-0.448-1-1v-11.458c0-0.552,0.447-1,1-1s1,0.448,1,1v11.458    C133.499,174.309,133.052,174.757,132.499,174.757z"
        />
      </g>
      <g>
        <path
          fill="#FFF4C1"
          d="M194.499,174.757c-0.553,0-1-0.448-1-1v-11.458c0-0.552,0.447-1,1-1s1,0.448,1,1v11.458    C195.499,174.309,195.052,174.757,194.499,174.757z"
        />
      </g>
      <g>
        <path
          fill="#A56021"
          d="M179.318,116.979h-12c-0.553,0-1-0.448-1-1s0.447-1,1-1h12c0.553,0,1,0.448,1,1    S179.871,116.979,179.318,116.979z"
        />
      </g>
      <g>
        <path
          fill="#A56021"
          d="M179.318,120.979h-12c-0.553,0-1-0.448-1-1s0.447-1,1-1h12c0.553,0,1,0.448,1,1    S179.871,120.979,179.318,120.979z"
        />
      </g>
      <g>
        <g>
          <path
            fill="#A56021"
            d="M201.763,116.297h-1.121v4.721c0,0.167-0.183,0.303-0.408,0.303h-3.622c-0.225,0-0.408-0.135-0.408-0.303     v-4.721h-1.134c-0.133,0-0.203-0.117-0.113-0.19l3.387-2.762c0.019-0.015,0.045-0.024,0.073-0.024     c0.028,0,0.054,0.009,0.073,0.024l3.387,2.762C201.966,116.181,201.896,116.297,201.763,116.297z"
          />
        </g>
      </g>
      <g>
        <path
          fill="#FFDF74"
          d="M167.036,11.14v15.317c1.045,0,1.045,2.124,2.091,2.124c1.047,0,1.047-2.124,2.093-2.124    c1.047,0,1.047,2.124,2.093,2.124c1.047,0,1.047-2.124,2.094-2.124c1.048,0,1.048,2.124,2.097,2.124s1.049-2.124,2.097-2.124    V11.14H167.036z"
        />
      </g>
      <g>
        <path
          fill="#FFC34C"
          d="M203.63,30.36c-1.104,0-2-0.896-2-2v-12c0-1.104,0.896-2,2-2s2,0.896,2,2v12    C205.63,29.465,204.734,30.36,203.63,30.36z"
        />
      </g>
      <g>
        <path
          fill="#A56021"
          d="M150.964,40.922h-14.409c-0.51,0-0.924-0.414-0.924-0.924v-4.036c0-0.51,0.414-0.924,0.924-0.924h14.409    c0.51,0,0.924,0.414,0.924,0.924v4.036C151.888,40.508,151.474,40.922,150.964,40.922z"
        />
      </g>
      <g>
        <path
          fill="#FFF4C1"
          d="M176.499,26.028c-0.553,0-1-0.448-1-1v-10c0-0.552,0.447-1,1-1s1,0.448,1,1v10    C177.499,25.58,177.052,26.028,176.499,26.028z"
        />
      </g>
      <g>
        <path
          fill="#A56021"
          d="M179.318,36.979h-12c-0.553,0-1-0.448-1-1s0.447-1,1-1h12c0.553,0,1,0.448,1,1    S179.871,36.979,179.318,36.979z"
        />
      </g>
      <g>
        <g>
          <path
            fill="#A56021"
            d="M201.763,36.297h-1.121v4.721c0,0.167-0.183,0.303-0.408,0.303h-3.622c-0.225,0-0.408-0.135-0.408-0.303     v-4.721h-1.134c-0.133,0-0.203-0.117-0.113-0.19l3.387-2.762c0.019-0.015,0.045-0.024,0.073-0.024     c0.028,0,0.054,0.009,0.073,0.024l3.387,2.762C201.966,36.181,201.896,36.297,201.763,36.297z"
          />
        </g>
      </g>
      <g>
        <path
          fill="#8C4C17"
          d="M136.555,35.037c-0.51,0-0.924,0.414-0.924,0.924v4.036c0,0.51,0.414,0.924,0.924,0.924h8.112v-5.885    H136.555z"
        />
      </g>
      <g>
        <path
          fill="#A56021"
          d="M179.318,40.979h-12c-0.553,0-1-0.448-1-1s0.447-1,1-1h12c0.553,0,1,0.448,1,1    S179.871,40.979,179.318,40.979z"
        />
      </g>
      <g>
        <circle fill="#DB9C2E" cx="155.749" cy="88.901" r="9" />
      </g>
    </g>
  </svg>
)

const LalamoveIcon = () => (
  <svg
    version="1.1"
    id="Logo_Horizontal_with_Clear_space"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 712 197.5"
  >
    <title>Logo with clearspace guide_2018MAY</title>
    <path
      fill="#FFA400"
      d="M489.8,133.8h-13.2c-0.6,0-1-0.4-1-1c0-0.1,0-0.2,0-0.3l7.6-42c0.2-0.6-0.1-1.1-0.7-1.3
      c-0.6-0.2-1.1,0.1-1.3,0.7l-18.5,43.2c-0.2,0.4-0.6,0.7-1,0.6h-16.4c-0.6,0-1-0.4-1-1L441,89.5c0-0.6-0.4-1.1-1-1.1s-1.1,0.4-1.1,1
      l-7.5,43.4c-0.1,0.5-0.5,0.9-1,0.9h-13.2c-0.6,0-1-0.5-1-1.1v-0.1L427.7,67c0.1-0.5,0.5-0.9,1-0.9h23.1c0.6,0,1,0.4,1,1L456,113
      c0.1,0.6,0.6,1,1.2,0.9c0.4,0,0.7-0.3,0.8-0.6l18.8-46.5c0.2-0.4,0.6-0.7,1-0.7h23.6c0.6,0,1,0.4,1,1c0,0.1,0,0.2,0,0.3l-11.6,65.5
      C490.8,133.4,490.3,133.8,489.8,133.8z"
    />
    <path
      fill="#FFA400"
      d="M576.8,94.1c0,24.1-16,41-39,41c-20,0-31.1-12.7-31.1-29.3c0-24.2,16-41,39-41
      C565.8,64.8,576.8,77.6,576.8,94.1z M560.6,94.5c0-10.9-5.5-18.3-15.7-18.3c-14.9,0-21.8,16-21.8,29.3c0,10.8,5.5,18.3,15.7,18.3
      C553.5,123.8,560.6,107.8,560.6,94.5z"
    />
    <path
      fill="#FFA400"
      d="M596.8,132.9l-11.4-65.5c-0.1-0.5,0.2-1.1,0.8-1.2c0.1,0,0.2,0,0.2,0h14.5c0.5,0,1,0.4,1,0.9l6.8,51.4
      c-0.1,0.6,0.3,1.1,0.8,1.2c0.6,0.1,1.1-0.3,1.2-0.8l25.4-52c0.2-0.4,0.5-0.6,0.9-0.6h14.1c0.6,0,1,0.4,1.1,0.9c0,0.2,0,0.4-0.2,0.6
      l-34.7,65.5c-0.2,0.3-0.5,0.6-0.9,0.6h-18.6C597.3,133.8,596.8,133.4,596.8,132.9z"
    />
    <path
      fill="#FFA400"
      d="M670.7,93.9h29.2c0.6,0,1,0.4,1,1c0,0.1,0,0.2,0,0.3l-1.8,9.8c-0.1,0.5-0.5,0.9-1,0.9h-29.9
      c-0.5,0-0.9,0.4-1,0.9l-2.4,13.8c-0.1,0.5,0.2,1.1,0.8,1.2c0.1,0,0.2,0,0.2,0h32.3c0.6,0,1,0.4,1,1c0,0.1,0,0.2,0,0.3l-1.8,10
      c-0.1,0.5-0.5,0.9-1,0.9h-47.9c-0.6,0-1-0.4-1-1c0-0.1,0-0.2,0-0.3L659,67.2c0.1-0.5,0.5-0.9,1-0.9h47c0.6,0,1,0.4,1,1
      c0,0.1,0,0.2,0,0.3l-1.8,9.9c-0.1,0.5-0.5,0.9-1,0.9H673c-0.5,0-0.9,0.4-1,0.9L669.6,93c-0.1,0.5,0.2,1.1,0.7,1.2
      C670.5,93.9,670.6,93.9,670.7,93.9z"
    />
    <path
      fill="#FF671D"
      d="M210.1,133.8h-43.7c-0.6,0-1-0.4-1-1c0-0.1,0-0.2,0-0.3L177,67.1c0.1-0.5,0.5-0.9,1-0.9h13.2c0.6,0,1,0.4,1,1
      c0,0.1,0,0.2,0,0.3l-9.2,52.2c-0.1,0.5,0.2,1.1,0.7,1.2c0.1,0,0.2,0,0.3,0h31.9c0.6,0,1,0.4,1.1,0.9c0,0.2,0,0.4-0.2,0.6l-5.8,10.8
      C210.9,133.6,210.5,133.8,210.1,133.8z"
    />
    <path
      fill="#FF671D"
      d="M335.5,133.8h-43.7c-0.6,0-1-0.4-1-1c0-0.1,0-0.2,0-0.3L302.4,67c0.1-0.5,0.5-0.9,1-0.9h13.2c0.6,0,1,0.4,1,1
      c0,0.1,0,0.2,0,0.3l-9.3,52.2c-0.1,0.5,0.2,1.1,0.7,1.2c0.1,0,0.2,0,0.3,0h31.9c0.6,0,1,0.4,1.1,0.9c0,0.2,0,0.4-0.2,0.6l-5.8,10.8
      C336.2,133.6,335.8,133.8,335.5,133.8z"
    />
    <path
      fill="#FF671D"
      d="M398.7,67.1c-0.1-0.5-0.5-0.9-1-0.9h-18.6c-0.4,0-0.7,0.2-0.9,0.6l-34.7,65.5c-0.3,0.5-0.2,1.1,0.3,1.4
      c0.2,0.1,0.4,0.2,0.6,0.2h14.1c0.4,0,0.8-0.2,0.9-0.6l2.2-4.4l0,0l13.7-27.6v-0.1l2-4.1l1.4-2.8l0,0l5.6-11.1
      c0.1-0.6,0.6-0.9,1.2-0.8s0.9,0.6,0.8,1.2l2.6,18c0.1,0.6-0.3,1.1-0.9,1.2h-0.1h-8.2c-0.6,0-1.1,0.3-1.3,0.8l-4.5,9.1
      c-0.4,0.7-0.1,1.6,0.6,2c0.2,0.1,0.4,0.2,0.7,0.2h15c0.5,0,0.9,0.4,1,0.9l2.5,17.3c0.1,0.5,0.5,0.9,1,0.9H409c0.6,0,1-0.4,1-1
      c0-0.1,0-0.2,0-0.2L398.7,67.1z"
    />
    <path
      fill="#FF671D"
      d="M273.4,67.1c-0.1-0.5-0.5-0.9-1-0.9h-18.6c-0.4,0-0.8,0.2-0.9,0.6l-34.8,65.5c-0.3,0.5-0.1,1.1,0.4,1.4
      c0.2,0.1,0.3,0.1,0.5,0.1h14.1c0.4,0,0.8-0.2,0.9-0.6l1-2l0,0l14.9-30.1c0,0,0,0,0-0.1l1.4-2.9l0.8-1.6l0,0l6.8-13.5
      c0.1-0.6,0.6-0.9,1.2-0.8s0.9,0.6,0.8,1.2l2.6,18c0.1,0.6-0.3,1.1-0.9,1.2h-0.1h-8.2c-0.6,0-1.1,0.3-1.3,0.8l-4.5,9.1
      c-0.4,0.7-0.1,1.6,0.7,2c0.2,0.1,0.4,0.2,0.7,0.2h14.9c0.5,0,0.9,0.4,1,0.9l2.5,17.3c0.1,0.5,0.5,0.9,1,0.9h14.5c0.6,0,1-0.4,1-1
      c0-0.1,0-0.2,0-0.2L273.4,67.1z"
    />
    <path
      fill="#FF671D"
      d="M154.4,29.6c-52.4,0-40.9,34.5-40.9,34.5c-7-2.2-96.2-31.7-108.9-35.9c-0.2-0.1-0.5,0-0.5,0.3
      c0,0.1,0,0.3,0.1,0.4c1.3,1.5,3.9,4.4,8.1,9.1c0.3,0.4,0.7,0.6,1.2,0.8l1.3,0.4l73.9,24.2c0.4,0.1,0.8,0.4,1,0.8l4,6.8v0.1h-0.1
      L21.4,47.6c-0.1,0-0.2,0-0.3,0.1c0,0.1,0,0.2,0,0.2c1.7,1.9,3.5,3.8,5.4,5.8c0.5,0.5,1.1,1,1.9,1.2l68.5,22.5c0.4,0.1,0.8,0.4,1,0.8
      l4,6.8v0.1h-0.1L36.2,63.6c-0.1,0-0.2,0-0.2,0.1s0,0.1,0,0.2c2,2.2,4.1,4.3,6.2,6.5c0.3,0.3,0.6,0.5,0.9,0.6l61.8,20.3
      c0.6,0.2,1,0.6,1.3,1.1l3.9,6.6v0.1c0,0,0,0-0.1,0l-57.5-19c-0.2,0-0.3,0-0.4,0.2c0,0.1,0,0.2,0.1,0.3c12.8,12.8,24.2,23,28.5,23.4
      l-41.2,92.6c-0.1,0.3,0,0.7,0.4,0.8c0.2,0.1,0.5,0.1,0.6-0.1c18.6-15.2,31.6-55.8,51.4-66.6c28.6-15.6,39.6-24.7,46.6-40.3
      C146.8,72,157.4,41.2,159,40c11.3-8.7,31.5-28.2,40-36.6c0.2-0.2,0.2-0.6,0-0.8s-0.5-0.2-0.7-0.1C186.5,10.2,156.1,29.6,154.4,29.6z
      "
    />
  </svg>
)

export {
  InventoryIcon,
  ClipboardIcon,
  WalletIcon,
  DeliveryTruckIcon,
  HeadsetIcon,
  DiagramIcon,
  ShopIcon,
  FlagIcon,
  NextIcon,
  MapMarkerIcon,
  MailIcon,
  PhoneIcon,
  BackIcon,
  HomeIcon,
  CustomerIcon,
  CalendarIcon,
  AddIcon,
  SubtractIcon,
  CloseIcon,
  ArrowDownIcon,
  MagnifierIcon,
  TrashCanIcon,
  NotPermittedIcon,
  CheckedIcon,
  OrangeCheckedIcon,
  InfoIcon,
  WarningIcon,
  PencilIcon,
  UserProfileDropdownIcon,
  UserProfileIcon,
  HidePasswordButton,
  ViewPasswordButton,
  DuplicateIcon,
  BoxIcon,
  PriceTagIcon,
  AvatarIcon,
  CalculatorIcon,
  PaymentMethodIcon,
  SettingsIcon,
  ArrowUpIcon,
  UserIcon,
  CameraIcon,
  LogOutIcon,
  LeftArrowIconCircular,
  ClockIcon,
  IncreaseArrowIcon,
  PackageIcon,
  RobotIcon,
  CreditCardIcon,
  BlueCheckedIcon,
  StarIcon,
  SadIcon,
  TickedIcon,
  CircularFacebookIcon,
  CircularTwitterIcon,
  CircularLinkedInIcon,
  GiftIcon,
  ShadedMapMarkerIcon,
  MapOriginIcon,
  MoreIcon,
  ImageIcon,
  BoldIcon,
  ItalicIcon,
  LinkIcon,
  LineHeightIcon,
  EmojiIcon,
  BulletsIcon,
  NumberedListIcons,
  UnderlineIcon,
  TextAlignIcon,
  JustifyAlignIcon,
  LeftAlignIcon,
  CenterAlignIcon,
  DesktopIcon,
  MobilePhoneIcon,
  HeartIcon,
  MobilePhoneIconSolid,
  ShoppingCartIcon,
  SearchIcon,
  ShoppingBagIcon,
  SetUpShopIcon,
  DarkTwitterLogo,
  DarkLinkedInLogo,
  DarkFbLogo,
  DarkIgLogo,
  VisaLogo,
  PaypalLogo,
  MastercardLogo,
  SliderArrow,
  EmptyProductsIcon,
  EmptyOrdersIcon,
  EmptyCustomersIcon,
  EmptyPaymentIcon,
  EmptyTaxIcon,
  EmptyCategoriesIcon,
  LalamoveIcon
}
